import {
  protoOf180f3jzyo7rfj as protoOf,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  toString1pkumu07cwy4m as toString,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  IllegalStateException_init_$Create$2w9444nebyjns as IllegalStateException_init_$Create$,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  VOID3gxj6tk5isa35 as VOID,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  LinkedHashMap_init_$Create$1f9mb1z5f3dxn as LinkedHashMap_init_$Create$,
  PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance,
  arrayOf1akklvh2at202 as arrayOf,
  createKType31ecntyyaay3k as createKType,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  equals2au1ep9vhcato as equals,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalStateException_init_$Init$36ffgdfb0luqc as IllegalStateException_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  defineProp3ur6h3slcvq4x as defineProp,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  UnsupportedOperationException_init_$Init$aiu0wswgl7ck as UnsupportedOperationException_init_$Init$,
  trimIndent1qytc1wvt8suh as trimIndent,
  fromInt2ii0rejb1w62w as fromInt,
  IllegalStateException_init_$Init$28k6zlhbptery as IllegalStateException_init_$Init$_0,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  IllegalArgumentException_init_$Create$3ewkh27kzt8z8 as IllegalArgumentException_init_$Create$,
  emptySetcxexqki71qfa as emptySet,
  ArrayList_init_$Create$149jv2ovkkvnt as ArrayList_init_$Create$,
  CancellationException_init_$Create$2cv5nayrc39hr as CancellationException_init_$Create$,
  getKClass3t8tygqu4lcxf as getKClass,
  getStarKTypeProjection316vzroubdy0t as getStarKTypeProjection,
  lazy2hsh8ze7j6ikd as lazy,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
  setOf1u3mizs95ngxo as setOf,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  joinToString1cxrrlmo0chqs as joinToString,
  setOf45ia9pnfhe90 as setOf_0,
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  first58ocm7j58k3q as first,
  checkBuilderCapacity1h6g02949wvv as checkBuilderCapacity,
  ArrayList_init_$Create$3bxttkj3v1mea as ArrayList_init_$Create$_0,
  Unitkvevlwgzwiuc as Unit,
  toLongkk4waq8msp1k as toLong,
  isByteArray4nnzfn1x4o3w as isByteArray,
  CancellationException3b36o9qz53rgr as CancellationException,
  toInt2q8uldh7sc951 as toInt,
  reversed22y3au42jl32b as reversed,
  LinkedHashSet_init_$Create$3o6z3oewjhki9 as LinkedHashSet_init_$Create$,
  toList2zksu85ukrmi as toList,
  sortedWith2csnbbb21k0lg as sortedWith,
  StringBuilder_init_$Create$2qsge4ydj6bin as StringBuilder_init_$Create$,
  roundToInt1ue8x8yshtznx as roundToInt,
  firstOrNull1982767dljvdy as firstOrNull,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  hashCodeq5arwsb9dgti as hashCode,
  compareValues1n2ayl87ihzfk as compareValues,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  Default_getInstance3u4i6y54ri5cn as Default_getInstance,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  multiply2k9eolhnz1bjv as multiply,
  toNumber2e2hj9zugjwi2 as toNumber,
  numberToLong2pakxeg38estk as numberToLong,
  add2suhfggl4zvkk as add,
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result__exceptionOrNull_impl_p6xea9ty3elzpd9eo3 as Result__exceptionOrNull_impl_p6xea9,
  toString30pk9tzaqopn as toString_0,
  trimMarginhyd3fsmh8iev as trimMargin,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  KProperty02ce7r476m8633 as KProperty0,
  createKTypeParameter16gw97ll17xmd as createKTypeParameter,
  removeAll3o43e67jmwdpc as removeAll,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  isBlank1dvkhjjvox3p0 as isBlank,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimStart1mkod6gyztuyy as trimStart,
  endsWith278181ii8uuo as endsWith,
  endsWith3cq61xxngobwh as endsWith_0,
  startsWith26w8qjqapeeq6 as startsWith,
  IllegalStateException_init_$Init$3ccqbeatlpw5c as IllegalStateException_init_$Init$_1,
  KtMutableList1beimitadwkna as KtMutableList,
  equals2v6cggk171b6e as equals_0,
  flatten2dh4kibw1u0qq as flatten,
  copyToArray2j022khrow2yi as copyToArray,
  intercepted2ogpsikxxj4u0 as intercepted,
  toTypedArray3sl1vhn8ifta0 as toTypedArray,
  SafeContinuation_init_$Create$2diyd7x16hgma as SafeContinuation_init_$Create$,
  Error_init_$Create$31zepbtb442q4 as Error_init_$Create$,
  decodeToString1dbzcjd620q25 as decodeToString,
} from './kotlin-kotlin-stdlib.mjs';
import {
  cancel36mj9lv3a0whl as cancel,
  Key_instance2tirv2rj82ml4 as Key_instance,
  Job13y4jkazwjho0 as Job,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  cancel2ztysw4v4hav6 as cancel_0,
  GlobalScope_instance1sfulufhd2ijt as GlobalScope_instance,
  get_job2zvlvce9o9a29 as get_job,
  asyncz02dsa2nb2zt as async,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CompletableJob1w6swnu15iclo as CompletableJob,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  cancel1xim2hrvjmwpn as cancel_1,
  delayolwo40i9ucjz as delay,
  CopyableThrowable1mvc99jcyvivf as CopyableThrowable,
  launch1c91vkjzdi9sd as launch,
  Mutex16li1l0asjv17 as Mutex,
  Dispatchers_getInstanceitgtkvqfcnx3 as Dispatchers_getInstance,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  await20nhgj9iqzkt as await_0,
  CancellationExceptionjngvjj221x3v as CancellationException_0,
  cancel2en0dn4yvpufo as cancel_2,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  cancelConsumed2i0oizqhmljf6 as cancelConsumed,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  Channel3r72atmcithql as Channel,
} from './kotlinx-coroutines-core.mjs';
import {
  PipelineContext34fsb0mycu471 as PipelineContext,
  AttributesJsFn25rjfgcprgprf as AttributesJsFn,
  AttributeKey3aq8ytwgx54f7 as AttributeKey,
  PlatformUtils_getInstance350nj2wi6ds9r as PlatformUtils_getInstance,
  TypeInfo2nbxsuf4v8os2 as TypeInfo,
  instanceOf2cx3k00nj6a0p as instanceOf,
  SilentSupervisorlzoikirj0zeo as SilentSupervisor,
  PipelinePhase2q3d54imxjlma as PipelinePhase,
  appendAlltwnjnu28pmtx as appendAll,
  KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger,
  Attributes2dg90yv0ot9wx as Attributes,
  get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled,
  getTimeMillis12o7k17x9fmwi as getTimeMillis,
  toLowerCasePreservingASCIIRulesa2d90zyoc6kw as toLowerCasePreservingASCIIRules,
  putAll10o0q8e6mgnzr as putAll,
  GMTDate36bhedawynxlf as GMTDate,
  Pipeline2vw6c5wpzxajt as Pipeline,
} from './ktor-ktor-utils.mjs';
import {
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from './kotlinx-atomicfu.mjs';
import {
  Events63tfxre48w4z as Events,
  EventDefinition1fymk8xrdelhn as EventDefinition,
} from './ktor-ktor-events.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  ByteReadChannel1cb89sbyipkce as ByteReadChannel_0,
  readRemaining1x8kk1vq7p6gm as readRemaining,
  writer1eia5its2a1fh as writer,
  Companion_getInstance2ai11rhpust2a as Companion_getInstance,
  WriterScope3b0bo1enaee6b as WriterScope,
  ioDispatcher3b9pa3x0duop as ioDispatcher,
  MalformedInputExceptionbvc6h5ij0ias as MalformedInputException,
  copyTo2vm7vz7rr51or as copyTo,
  canceldn4b3cdqcfny as cancel_3,
  invokeOnCompletion1ziuxzoag0iwj as invokeOnCompletion,
  toByteArrayafjflk7yznm4 as toByteArray,
  readText3frapgncbqrcg as readText,
  Charsets_getInstanceqs70pvl4noow as Charsets_getInstance,
  get_name2f11g4r0d5pxp as get_name,
  readText27783kyxjxi1g as readText_0,
  decode1t43jmuxrxpmo as decode,
  get_ByteArrayPool3f7yrgvqxz9ct as get_ByteArrayPool,
  readAvailable22vc1bmbuj93x as readAvailable,
  writeFully3gv1ab611t04k as writeFully,
  close3semq7pafb42g as close,
  writeFully359t6q8kam2g5 as writeFully_0,
} from './ktor-ktor-io.mjs';
import {
  NullBody_instance2i6w0hfghwfg0 as NullBody_instance,
  HttpHeaders_getInstanceelogg8fjd54u as HttpHeaders_getInstance,
  contentLength2suzxu1lzutku as contentLength,
  WriteChannelContent1d7f40hsfcaxg as WriteChannelContent,
  ReadChannelContentz1amb4hnpqp4 as ReadChannelContent,
  NoContent1bdx48poqrifq as NoContent,
  ProtocolUpgradexnnpt2xliy8g as ProtocolUpgrade,
  ByteArrayContent2n0wb43y6ugs1 as ByteArrayContent,
  ContentWrapper3n9gdymgnbto9 as ContentWrapper,
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  UnsafeHeaderException3ncvrrp48xjzq as UnsafeHeaderException,
  URLBuilder1hwx1b9569i61 as URLBuilder,
  ParametersBuilder1ry9ntvvg567r as ParametersBuilder,
  takeFromkqlcz7c6dx2r as takeFrom,
  HeadersBuilder3h7sn3kkvu98m as HeadersBuilder,
  URLBuilder2mz8zkz4u9ray as URLBuilder_0,
  takeFrom3rd40szpqy350 as takeFrom_0,
  Application_getInstanceq87g3bor693u as Application_getInstance,
  contentType2zzm38yxo3syt as contentType,
  Text_getInstance1qa6l8g2r3h9g as Text_getInstance,
  TextContent1rb6ftlpvl1d2 as TextContent,
  Companion_getInstancecf9b3ybko8sp as Companion_getInstance_0,
  MultiPart_getInstance1zzge3g94afj6 as MultiPart_getInstance,
  MultiPartData57syw40llxls as MultiPartData,
  HttpStatusCode3o1wkms10pg4k as HttpStatusCode,
  charset1dribv3ku48b1 as charset,
  withCharset27k3t3dvzhi4n as withCharset,
  charset3qqtyytkmxogi as charset_0,
  Companion_getInstanceud97dyzf471m as Companion_getInstance_1,
  get_authority2s3hk87lssumy as get_authority,
  isSecurex1qiiavqi0xu as isSecure,
  get_authorityakhc3pgcrb9j as get_authority_0,
  Companion_getInstance1p3cpld7r1jz3 as Companion_getInstance_2,
  isWebsocket1w1xog9vfgwm1 as isWebsocket,
  NullBody1903zz7riiwr0 as NullBody,
  hostIsIp3bb88hkcut0h0 as hostIsIp,
  clone36ocpwr7g14r5 as clone,
  parseClientCookiesHeadert8p20xfeewy as parseClientCookiesHeader,
  CookieEncoding_RAW_getInstancelgliu5pjdx3k as CookieEncoding_RAW_getInstance,
  Cookie2mi3e4peeulg2 as Cookie,
  setCookie224ax7zijawy2 as setCookie,
  renderCookieHeader384jfdw23qi6g as renderCookieHeader,
  Companion_getInstance312jiahuid5ey as Companion_getInstance_3,
  Companion_getInstance2krh5pmq7pw0k as Companion_getInstance_4,
  headersOf2tgdoojg8tifn as headersOf,
  get_supportsRequestBodyjdtitrt33hir as get_supportsRequestBody,
  isEmpty1yq29t926r0va as isEmpty,
} from './ktor-ktor-http.mjs';
import {
  readByteArray1ri21h2rciakw as readByteArray,
  Source1shr0ps16u4p4 as Source,
  IOException1wyutdmfe71nu as IOException,
  IOException_init_$Init$1s6rw4r2mxxsm as IOException_init_$Init$,
  Buffergs925ekssbch as Buffer,
} from './kotlinx-io-kotlinx-io-core.mjs';
import { CIOMultipartDataBase3o5u8w437tq5s as CIOMultipartDataBase } from './ktor-ktor-http-cio.mjs';
import {
  Companion_getInstance3hj6iykoiauw8 as Companion_getInstance_5,
  Codes_CLOSED_ABNORMALLY_getInstance36fk4x8bui0mi as Codes_CLOSED_ABNORMALLY_getInstance,
  Text_init_$Create$j4ennvj3nfor as Text_init_$Create$,
  Binary_init_$Create$3ard3o30qds9x as Binary_init_$Create$,
  CloseReason10cphaqpp3ct7 as CloseReason,
  Close_init_$Create$37951fhr84rmk as Close_init_$Create$,
  Codes_NORMAL_getInstance2p2d63s1iongn as Codes_NORMAL_getInstance,
} from './ktor-ktor-websockets.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForLambda(HttpClient$slambda, CoroutineImpl, VOID, [2]);
initMetadataForLambda(HttpClient$slambda_1, CoroutineImpl, VOID, [2]);
initMetadataForCoroutine($executeCOROUTINE$, CoroutineImpl);
initMetadataForClass(HttpClient, 'HttpClient', VOID, VOID, [CoroutineScope, AutoCloseable], [1]);
initMetadataForClass(HttpClientConfig, 'HttpClientConfig', HttpClientConfig);
initMetadataForClass(HttpClientCall, 'HttpClientCall', VOID, VOID, [CoroutineScope], [0, 1]);
initMetadataForClass(DelegatedCall, 'DelegatedCall', VOID, HttpClientCall, VOID, [0, 1]);
function get_coroutineContext() {
  return this.s4r().f1x();
}
initMetadataForInterface(HttpRequest_0, 'HttpRequest', VOID, VOID, [CoroutineScope]);
initMetadataForClass(DelegatedRequest, 'DelegatedRequest', VOID, VOID, [HttpRequest_0]);
initMetadataForClass(HttpResponse, 'HttpResponse', VOID, VOID, [CoroutineScope]);
initMetadataForClass(DelegatedResponse, 'DelegatedResponse', VOID, HttpResponse);
initMetadataForCompanion(Companion);
initMetadataForCoroutine($bodyNullableCOROUTINE$, CoroutineImpl);
initMetadataForClass(DoubleReceiveException, 'DoubleReceiveException', VOID, IllegalStateException);
initMetadataForClass(NoTransformationFoundException, 'NoTransformationFoundException', VOID, UnsupportedOperationException);
initMetadataForClass(SavedHttpCall, 'SavedHttpCall', VOID, HttpClientCall, VOID, [0, 1]);
initMetadataForClass(SavedHttpRequest, 'SavedHttpRequest', VOID, VOID, [HttpRequest_0]);
initMetadataForClass(SavedHttpResponse, 'SavedHttpResponse', VOID, HttpResponse);
initMetadataForCoroutine($saveCOROUTINE$, CoroutineImpl);
initMetadataForClass(UnsupportedContentTypeException, 'UnsupportedContentTypeException', VOID, IllegalStateException);
initMetadataForInterface(ProgressListener, 'ProgressListener', VOID, VOID, VOID, [2]);
initMetadataForLambda(ObservableContent$getContent$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(ObservableContent, 'ObservableContent', VOID, ReadChannelContent);
initMetadataForLambda(HttpClientEngine$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForLambda(HttpClientEngine$executeWithinCallContext$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($executeWithinCallContextCOROUTINE$, CoroutineImpl);
function get_supportedCapabilities() {
  return emptySet();
}
function install(client) {
  var tmp = Phases_getInstance_0().o4q_1;
  client.g4o_1.e31(tmp, HttpClientEngine$install$slambda_0(client, this, null));
}
initMetadataForInterface(HttpClientEngine, 'HttpClientEngine', VOID, VOID, [CoroutineScope, AutoCloseable], [1]);
initMetadataForClass(HttpClientEngineBase, 'HttpClientEngineBase', VOID, VOID, [HttpClientEngine], [1]);
initMetadataForClass(ClientEngineClosedException, 'ClientEngineClosedException', ClientEngineClosedException, IllegalStateException);
initMetadataForInterface(HttpClientEngineCapability, 'HttpClientEngineCapability');
initMetadataForClass(HttpClientEngineConfig, 'HttpClientEngineConfig', HttpClientEngineConfig);
initMetadataForCompanion(Companion_0);
initMetadataForClass(KtorCallContextElement, 'KtorCallContextElement', VOID, VOID, [Element]);
initMetadataForLambda(AfterRenderHook$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForObject(AfterRenderHook, 'AfterRenderHook');
initMetadataForLambda(AfterReceiveHook$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForObject(AfterReceiveHook, 'AfterReceiveHook');
initMetadataForLambda(BodyProgress$lambda$slambda, CoroutineImpl, VOID, [2]);
initMetadataForLambda(BodyProgress$lambda$slambda_1, CoroutineImpl, VOID, [1]);
initMetadataForLambda(DefaultRequest$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForObject(Plugin, 'Plugin');
initMetadataForClass(DefaultRequestBuilder, 'DefaultRequestBuilder');
initMetadataForClass(DefaultRequest, 'DefaultRequest');
initMetadataForClass(ResponseException, 'ResponseException', VOID, IllegalStateException);
initMetadataForClass(RedirectResponseException, 'RedirectResponseException', VOID, ResponseException);
initMetadataForClass(ClientRequestException, 'ClientRequestException', VOID, ResponseException);
initMetadataForClass(ServerResponseException, 'ServerResponseException', VOID, ResponseException);
initMetadataForLambda(addDefaultResponseValidation$lambda$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(defaultTransformers$2$content$1, VOID, VOID, ByteArrayContent);
initMetadataForClass(defaultTransformers$2$content$2, VOID, VOID, ReadChannelContent);
initMetadataForLambda(defaultTransformers$slambda, CoroutineImpl, VOID, [2]);
initMetadataForLambda(defaultTransformers$slambda$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(defaultTransformers$slambda_1, CoroutineImpl, VOID, [2]);
initMetadataForClass(HttpCallValidatorConfig, 'HttpCallValidatorConfig', HttpCallValidatorConfig);
initMetadataForClass(ExceptionHandlerWrapper, 'ExceptionHandlerWrapper');
initMetadataForClass(RequestExceptionHandlerWrapper, 'RequestExceptionHandlerWrapper');
initMetadataForLambda(RequestError$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForObject(RequestError, 'RequestError');
initMetadataForLambda(ReceiveError$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForObject(ReceiveError, 'ReceiveError');
initMetadataForLambda(HttpCallValidator$lambda$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(HttpCallValidator$lambda$slambda_1, CoroutineImpl, VOID, [2]);
initMetadataForLambda(HttpCallValidator$lambda$slambda_3, CoroutineImpl, VOID, [2]);
initMetadataForLambda(HttpCallValidator$lambda$slambda_5, CoroutineImpl, VOID, [2]);
initMetadataForCoroutine($invoke$validateResponseCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($invoke$processExceptionCOROUTINE$, CoroutineImpl);
initMetadataForClass(HttpRequest$1, VOID, VOID, VOID, [HttpRequest_0]);
initMetadataForClass(HttpPlainTextConfig, 'HttpPlainTextConfig', HttpPlainTextConfig);
initMetadataForLambda(RenderRequestHook$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForObject(RenderRequestHook, 'RenderRequestHook');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForLambda(HttpPlainText$lambda$slambda, CoroutineImpl, VOID, [2]);
initMetadataForLambda(HttpPlainText$lambda$slambda_1, CoroutineImpl, VOID, [4]);
initMetadataForClass(HttpRedirectConfig, 'HttpRedirectConfig', HttpRedirectConfig);
initMetadataForLambda(HttpRedirect$lambda$slambda, CoroutineImpl, VOID, [2]);
initMetadataForCoroutine($invoke$handleCallCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($invokeCOROUTINE$, CoroutineImpl);
initMetadataForFunctionReference(PipelineContext$proceed$ref, VOID, VOID, [0]);
initMetadataForLambda(SetupRequestContext$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForObject(SetupRequestContext, 'SetupRequestContext');
initMetadataForLambda(HttpRequestLifecycle$lambda$slambda, CoroutineImpl, VOID, [2]);
initMetadataForClass(HttpRetryEventData, 'HttpRetryEventData');
initMetadataForLambda(HttpRequestRetryConfig$delay$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(HttpRequestRetryConfig, 'HttpRequestRetryConfig', HttpRequestRetryConfig);
initMetadataForClass(HttpRetryShouldRetryContext, 'HttpRetryShouldRetryContext');
initMetadataForClass(HttpRetryDelayContext, 'HttpRetryDelayContext');
initMetadataForClass(HttpRetryModifyRequestContext, 'HttpRetryModifyRequestContext');
initMetadataForLambda(HttpRequestRetry$lambda$slambda, CoroutineImpl, VOID, [3]);
initMetadataForLambda(HttpRequestRetry$lambda$slambda_1, CoroutineImpl, VOID, [2]);
initMetadataForCoroutine($throwOnInvalidResponseBodyCOROUTINE$, CoroutineImpl);
initMetadataForInterface(Sender, 'Sender', VOID, VOID, VOID, [1]);
initMetadataForLambda(HttpSend$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForCoroutine($executeCOROUTINE$_0, CoroutineImpl);
initMetadataForClass(Config, 'Config', Config);
initMetadataForObject(Plugin_0, 'Plugin');
initMetadataForClass(InterceptedSender, 'InterceptedSender', VOID, VOID, [Sender], [1]);
initMetadataForClass(DefaultSender, 'DefaultSender', VOID, VOID, [Sender], [1]);
initMetadataForClass(HttpSend, 'HttpSend');
initMetadataForClass(SendCountExceedException, 'SendCountExceedException', VOID, IllegalStateException);
initMetadataForObject(HttpTimeoutCapability, 'HttpTimeoutCapability', VOID, VOID, [HttpClientEngineCapability]);
initMetadataForClass(HttpRequestTimeoutException, 'HttpRequestTimeoutException', VOID, IOException, [IOException, CopyableThrowable]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(HttpTimeoutConfig, 'HttpTimeoutConfig', HttpTimeoutConfig_init_$Create$);
initMetadataForLambda(HttpTimeout$lambda$slambda, CoroutineImpl, VOID, [2]);
initMetadataForLambda(applyRequestTimeout$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(SaveBodyPluginConfig, 'SaveBodyPluginConfig', SaveBodyPluginConfig);
initMetadataForLambda(SaveBody$lambda$slambda, CoroutineImpl, VOID, [2]);
initMetadataForClass(HookHandler, 'HookHandler');
initMetadataForClass(ClientPluginBuilder, 'ClientPluginBuilder');
initMetadataForClass(ClientPluginInstance, 'ClientPluginInstance', VOID, VOID, [AutoCloseable]);
initMetadataForLambda(SetupRequest$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForObject(SetupRequest, 'SetupRequest');
initMetadataForClass(Sender_0, 'Sender', VOID, VOID, [CoroutineScope], [1]);
initMetadataForLambda(Send$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForObject(Send, 'Send');
initMetadataForLambda(SendingRequest$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForObject(SendingRequest, 'SendingRequest');
initMetadataForClass(ClientPluginImpl, 'ClientPluginImpl');
initMetadataForClass(TransformRequestBodyContext, 'TransformRequestBodyContext');
initMetadataForClass(TransformResponseBodyContext, 'TransformResponseBodyContext');
initMetadataForClass(OnRequestContext, 'OnRequestContext');
initMetadataForLambda(RequestHook$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForObject(RequestHook, 'RequestHook');
initMetadataForClass(OnResponseContext, 'OnResponseContext');
initMetadataForLambda(ResponseHook$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForObject(ResponseHook, 'ResponseHook');
initMetadataForLambda(TransformRequestBodyHook$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForObject(TransformRequestBodyHook, 'TransformRequestBodyHook');
initMetadataForLambda(TransformResponseBodyHook$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForObject(TransformResponseBodyHook, 'TransformResponseBodyHook');
initMetadataForClass(CookieWithTimestamp, 'CookieWithTimestamp');
initMetadataForCoroutine($getCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($addCookieCOROUTINE$, CoroutineImpl);
initMetadataForClass(AcceptAllCookiesStorage, 'AcceptAllCookiesStorage', AcceptAllCookiesStorage, VOID, [AutoCloseable], [1, 2]);
initMetadataForLambda(HttpCookies$Companion$install$slambda, CoroutineImpl, VOID, [2]);
initMetadataForLambda(HttpCookies$Companion$install$slambda_1, CoroutineImpl, VOID, [2]);
initMetadataForLambda(HttpCookies$Companion$install$slambda_3, CoroutineImpl, VOID, [2]);
initMetadataForClass(Config_0, 'Config', Config_0);
initMetadataForCompanion(Companion_2);
initMetadataForLambda(HttpCookies$initializer$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($getCOROUTINE$_0, CoroutineImpl);
initMetadataForCoroutine($captureHeaderCookiesCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($sendCookiesWithCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($saveCookiesFromCOROUTINE$, CoroutineImpl);
initMetadataForClass(HttpCookies, 'HttpCookies', VOID, VOID, [AutoCloseable], [1]);
initMetadataForClass(ClientSSESession, 'ClientSSESession', VOID, VOID, [CoroutineScope]);
initMetadataForClass(ClientSSESessionWithDeserialization, 'ClientSSESessionWithDeserialization', VOID, VOID, [CoroutineScope]);
initMetadataForObject(SSECapability, 'SSECapability', VOID, VOID, [HttpClientEngineCapability]);
initMetadataForClass(SSEClientContent, 'SSEClientContent', VOID, ContentWrapper);
initMetadataForObject(WebSocketCapability, 'WebSocketCapability', VOID, VOID, [HttpClientEngineCapability]);
initMetadataForClass(WebSocketException, 'WebSocketException', VOID, IllegalStateException);
initMetadataForClass(ClientUpgradeContent, 'ClientUpgradeContent', VOID, NoContent, VOID, [1]);
initMetadataForClass(DefaultHttpRequest, 'DefaultHttpRequest', VOID, VOID, [HttpRequest_0]);
initMetadataForCompanion(Companion_3);
initMetadataForClass(HttpRequestBuilder, 'HttpRequestBuilder', HttpRequestBuilder);
initMetadataForClass(HttpRequestData, 'HttpRequestData');
initMetadataForInterface(ResponseAdapter, 'ResponseAdapter');
initMetadataForClass(HttpResponseData, 'HttpResponseData');
initMetadataForObject(Phases, 'Phases');
initMetadataForClass(HttpRequestPipeline, 'HttpRequestPipeline', HttpRequestPipeline, Pipeline, VOID, [2]);
initMetadataForObject(Phases_0, 'Phases');
initMetadataForClass(HttpSendPipeline, 'HttpSendPipeline', HttpSendPipeline, Pipeline, VOID, [2]);
initMetadataForClass(DefaultHttpResponse, 'DefaultHttpResponse', VOID, HttpResponse);
initMetadataForCoroutine($bodyAsTextCOROUTINE$, CoroutineImpl);
initMetadataForObject(Phases_1, 'Phases');
initMetadataForClass(HttpReceivePipeline, 'HttpReceivePipeline', HttpReceivePipeline, Pipeline, VOID, [2]);
initMetadataForObject(Phases_2, 'Phases');
initMetadataForClass(HttpResponsePipeline, 'HttpResponsePipeline', HttpResponsePipeline, Pipeline, VOID, [2]);
initMetadataForClass(HttpResponseContainer, 'HttpResponseContainer');
initMetadataForCoroutine($fetchResponseCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($cleanupCOROUTINE$, CoroutineImpl);
initMetadataForClass(HttpStatement, 'HttpStatement', VOID, VOID, VOID, [1, 0]);
initMetadataForLambda(observable$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(HttpResponseReceiveFail, 'HttpResponseReceiveFail');
initMetadataForObject(EmptyContent, 'EmptyContent', VOID, NoContent);
initMetadataForCompanion(Companion_4);
initMetadataForClass(FetchOptions, 'FetchOptions');
initMetadataForObject(Js, 'Js');
initMetadataForClass(JsClientEngineConfig, 'JsClientEngineConfig', JsClientEngineConfig, HttpClientEngineConfig);
initMetadataForClass(JsClientEngine$createWebSocket$headers_capturingHack$1);
initMetadataForCoroutine($executeCOROUTINE$_1, CoroutineImpl);
initMetadataForCoroutine($createWebSocketCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($executeWebSocketRequestCOROUTINE$, CoroutineImpl);
initMetadataForClass(JsClientEngine, 'JsClientEngine', VOID, HttpClientEngineBase, VOID, [1, 2]);
initMetadataForLambda(getBodyBytes$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($toRawCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($getBodyBytesCOROUTINE$, CoroutineImpl);
initMetadataForLambda(channelFromStream$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(JsWebSocketSession$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(JsWebSocketSession, 'JsWebSocketSession', VOID, VOID, [CoroutineScope], [0, 1]);
initMetadataForClass(Node, 'Node');
initMetadataForClass(engines$iterator$1);
initMetadataForObject(engines, 'engines');
initMetadataForClass(ConnectTimeoutException, 'ConnectTimeoutException', VOID, IOException);
initMetadataForClass(InterruptedIOException, 'InterruptedIOException', VOID, IOException);
initMetadataForClass(SocketTimeoutException, 'SocketTimeoutException', VOID, InterruptedIOException);
//endregion
function HttpClient_init_$Init$(engine, userConfig, manageEngine, $this) {
  HttpClient.call($this, engine, userConfig);
  $this.a4o_1 = manageEngine;
  return $this;
}
function HttpClient_init_$Create$(engine, userConfig, manageEngine) {
  return HttpClient_init_$Init$(engine, userConfig, manageEngine, objectCreate(protoOf(HttpClient)));
}
function HttpClient$lambda(this$0) {
  return function (it) {
    var tmp;
    if (!(it == null)) {
      cancel(this$0.y4n_1);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function HttpClient$slambda(this$0, resultContinuation) {
  this.u4o_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpClient$slambda).x4o = function ($this$intercept, call, $completion) {
  var tmp = this.y4o($this$intercept, call, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpClient$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpClient$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          var tmp_0 = this.w4o_1;
          if (!(tmp_0 instanceof HttpClientCall)) {
            var message = 'Error: HttpClientCall expected, but found ' + toString(this.w4o_1) + '(' + toString(getKClassFromExpression(this.w4o_1)) + ').';
            throw IllegalStateException_init_$Create$(toString(message));
          }

          this.d8_1 = 1;
          suspendResult = this.u4o_1.h4o_1.z30(Unit_instance, this.w4o_1.m47(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var response = suspendResult;
          this.w4o_1.e4p(response);
          this.d8_1 = 2;
          suspendResult = this.v4o_1.e30(this.w4o_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpClient$slambda).y4o = function ($this$intercept, call, completion) {
  var i = new HttpClient$slambda(this.u4o_1, completion);
  i.v4o_1 = $this$intercept;
  i.w4o_1 = call;
  return i;
};
function HttpClient$slambda_0(this$0, resultContinuation) {
  var i = new HttpClient$slambda(this$0, resultContinuation);
  var l = function ($this$intercept, call, $completion) {
    return i.x4o($this$intercept, call, $completion);
  };
  l.$arity = 2;
  return l;
}
function HttpClient$lambda_0($this$install) {
  defaultTransformers($this$install);
  return Unit_instance;
}
function HttpClient$slambda_1(this$0, resultContinuation) {
  this.n4p_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpClient$slambda_1).r4p = function ($this$intercept, it, $completion) {
  var tmp = this.s4p($this$intercept, it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpClient$slambda_1).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.r4p(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpClient$slambda_1).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.o4p_1.f30(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.q4p_1 = suspendResult;
          this.e8_1 = 3;
          this.d8_1 = 4;
          continue $sm;
        case 2:
          this.e8_1 = 3;
          var tmp_0 = this.g8_1;
          if (tmp_0 instanceof Error) {
            var cause = this.g8_1;
            var tmp_1 = this;
            this.n4p_1.k4o_1.w4e(get_HttpResponseReceiveFailed(), new HttpResponseReceiveFail(this.o4p_1.a31_1.m47(), cause));
            throw cause;
          } else {
            throw this.g8_1;
          }

        case 3:
          throw this.g8_1;
        case 4:
          this.e8_1 = 3;
          return Unit_instance;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpClient$slambda_1).s4p = function ($this$intercept, it, completion) {
  var i = new HttpClient$slambda_1(this.n4p_1, completion);
  i.o4p_1 = $this$intercept;
  i.p4p_1 = it;
  return i;
};
function HttpClient$slambda_2(this$0, resultContinuation) {
  var i = new HttpClient$slambda_1(this$0, resultContinuation);
  var l = function ($this$intercept, it, $completion) {
    return i.r4p($this$intercept, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function $executeCOROUTINE$(_this__u8e3s4, builder, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.b4q_1 = _this__u8e3s4;
  this.c4q_1 = builder;
}
protoOf($executeCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.b4q_1.k4o_1.w4e(get_HttpRequestCreated(), this.c4q_1);
          this.d8_1 = 1;
          suspendResult = this.b4q_1.e4o_1.z30(this.c4q_1, this.c4q_1.g4q_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult instanceof HttpClientCall ? suspendResult : THROW_CCE();
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function HttpClient(engine, userConfig) {
  userConfig = userConfig === VOID ? new HttpClientConfig() : userConfig;
  this.y4n_1 = engine;
  this.z4n_1 = userConfig;
  this.a4o_1 = false;
  this.b4o_1 = atomic$boolean$1(false);
  this.c4o_1 = Job(this.y4n_1.f1x().q8(Key_instance));
  this.d4o_1 = this.y4n_1.f1x().fh(this.c4o_1);
  this.e4o_1 = new HttpRequestPipeline();
  this.f4o_1 = new HttpResponsePipeline();
  this.g4o_1 = new HttpSendPipeline();
  this.h4o_1 = new HttpReceivePipeline();
  this.i4o_1 = AttributesJsFn(true);
  this.j4o_1 = this.y4n_1.j4q();
  this.k4o_1 = new Events();
  this.l4o_1 = new HttpClientConfig();
  if (this.a4o_1) {
    this.c4o_1.h1y(HttpClient$lambda(this));
  }
  this.y4n_1.k4q(this);
  var tmp = Phases_getInstance_0().p4q_1;
  this.g4o_1.e31(tmp, HttpClient$slambda_0(this, null));
  // Inline function 'kotlin.with' call
  var $this$with = this.z4n_1;
  this.l4o_1.y4q(get_HttpRequestLifecycle());
  this.l4o_1.y4q(get_BodyProgress());
  this.l4o_1.y4q(get_SaveBody());
  if ($this$with.v4q_1) {
    this.l4o_1.z4q('DefaultTransformers', HttpClient$lambda_0);
  }
  this.l4o_1.y4q(Plugin_getInstance_0());
  this.l4o_1.y4q(get_HttpCallValidator());
  if ($this$with.u4q_1) {
    this.l4o_1.y4q(get_HttpRedirect());
  }
  this.l4o_1.a4r($this$with);
  if ($this$with.v4q_1) {
    this.l4o_1.y4q(get_HttpPlainText());
  }
  addDefaultResponseValidation(this.l4o_1);
  this.l4o_1.k4q(this);
  var tmp_0 = Phases_getInstance_2().b4r_1;
  this.f4o_1.e31(tmp_0, HttpClient$slambda_2(this, null));
}
protoOf(HttpClient).f1x = function () {
  return this.d4o_1;
};
protoOf(HttpClient).g4r = function (builder, $completion) {
  var tmp = new $executeCOROUTINE$(this, builder, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpClient).i3 = function () {
  var success = this.b4o_1.atomicfu$compareAndSet(false, true);
  if (!success)
    return Unit_instance;
  var installedFeatures = this.i4o_1.l2v(get_PLUGIN_INSTALLED_LIST());
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = installedFeatures.r2v().l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    var plugin = installedFeatures.l2v(element instanceof AttributeKey ? element : THROW_CCE());
    if (isInterface(plugin, AutoCloseable)) {
      plugin.i3();
    }
  }
  this.c4o_1.b24();
  if (this.a4o_1) {
    this.y4n_1.i3();
  }
};
protoOf(HttpClient).toString = function () {
  return 'HttpClient[' + toString(this.y4n_1) + ']';
};
function HttpClient_0(engineFactory, block) {
  var tmp;
  if (block === VOID) {
    tmp = HttpClient$lambda_1;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'kotlin.apply' call
  var this_0 = new HttpClientConfig();
  block(this_0);
  var config = this_0;
  var engine = engineFactory.h4r(config.t4q_1);
  var client = HttpClient_init_$Create$(engine, config, true);
  var tmp_0 = ensureNotNull(client.d4o_1.q8(Key_instance));
  tmp_0.h1y(HttpClient$lambda_2(engine));
  return client;
}
function HttpClient$lambda_1(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClient$lambda_2($engine) {
  return function (it) {
    $engine.i3();
    return Unit_instance;
  };
}
function HttpClientConfig$engineConfig$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$install$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$install$lambda_0($previousConfigBlock, $configure) {
  return function (_this__u8e3s4) {
    var tmp0_safe_receiver = $previousConfigBlock;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    $configure(!(_this__u8e3s4 == null) ? _this__u8e3s4 : THROW_CCE());
    return Unit_instance;
  };
}
function HttpClientConfig$install$lambda$lambda() {
  return AttributesJsFn(true);
}
function HttpClientConfig$install$lambda_1($plugin) {
  return function (scope) {
    var tmp = get_PLUGIN_INSTALLED_LIST();
    var attributes = scope.i4o_1.q2v(tmp, HttpClientConfig$install$lambda$lambda);
    var config = ensureNotNull(scope.l4o_1.r4q_1.h2($plugin.v()));
    var pluginData = $plugin.i4r(config);
    $plugin.j4r(pluginData, scope);
    attributes.o2v($plugin.v(), pluginData);
    return Unit_instance;
  };
}
function HttpClientConfig() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.q4q_1 = LinkedHashMap_init_$Create$();
  var tmp_0 = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp_0.r4q_1 = LinkedHashMap_init_$Create$();
  var tmp_1 = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp_1.s4q_1 = LinkedHashMap_init_$Create$();
  var tmp_2 = this;
  tmp_2.t4q_1 = HttpClientConfig$engineConfig$lambda;
  this.u4q_1 = true;
  this.v4q_1 = true;
  this.w4q_1 = false;
  this.x4q_1 = PlatformUtils_getInstance().v2w_1;
}
protoOf(HttpClientConfig).k4r = function (plugin, configure) {
  var previousConfigBlock = this.r4q_1.h2(plugin.v());
  var tmp0 = this.r4q_1;
  var tmp2 = plugin.v();
  // Inline function 'kotlin.collections.set' call
  var value = HttpClientConfig$install$lambda_0(previousConfigBlock, configure);
  tmp0.a2(tmp2, value);
  if (this.q4q_1.f2(plugin.v()))
    return Unit_instance;
  var tmp0_0 = this.q4q_1;
  var tmp2_0 = plugin.v();
  // Inline function 'kotlin.collections.set' call
  var value_0 = HttpClientConfig$install$lambda_1(plugin);
  tmp0_0.a2(tmp2_0, value_0);
};
protoOf(HttpClientConfig).y4q = function (plugin, configure, $super) {
  var tmp;
  if (configure === VOID) {
    tmp = HttpClientConfig$install$lambda;
  } else {
    tmp = configure;
  }
  configure = tmp;
  var tmp_0;
  if ($super === VOID) {
    this.k4r(plugin, configure);
    tmp_0 = Unit_instance;
  } else {
    tmp_0 = $super.k4r.call(this, plugin, configure);
  }
  return tmp_0;
};
protoOf(HttpClientConfig).z4q = function (key, block) {
  // Inline function 'kotlin.collections.set' call
  this.s4q_1.a2(key, block);
};
protoOf(HttpClientConfig).k4q = function (client) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = this.q4q_1.e2().l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    // Inline function 'kotlin.apply' call
    element(client);
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = this.s4q_1.e2().l();
  while (_iterator__ex2g4s_0.m()) {
    var element_0 = _iterator__ex2g4s_0.n();
    // Inline function 'kotlin.apply' call
    element_0(client);
  }
};
protoOf(HttpClientConfig).a4r = function (other) {
  this.u4q_1 = other.u4q_1;
  this.v4q_1 = other.v4q_1;
  this.w4q_1 = other.w4q_1;
  var tmp0 = this.q4q_1;
  // Inline function 'kotlin.collections.plusAssign' call
  var map = other.q4q_1;
  tmp0.c2(map);
  var tmp0_0 = this.r4q_1;
  // Inline function 'kotlin.collections.plusAssign' call
  var map_0 = other.r4q_1;
  tmp0_0.c2(map_0);
  var tmp0_1 = this.s4q_1;
  // Inline function 'kotlin.collections.plusAssign' call
  var map_1 = other.s4q_1;
  tmp0_1.c2(map_1);
};
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.m47().q39() : headers;
  return new DelegatedCall(_this__u8e3s4.z4o_1, _this__u8e3s4, content, headers);
}
function DelegatedCall(client, originCall, responseContent, responseHeaders) {
  responseHeaders = responseHeaders === VOID ? originCall.m47().q39() : responseHeaders;
  HttpClientCall.call(this, client);
  this.b4p_1 = new DelegatedRequest(this, originCall.l4r());
  this.c4p_1 = new DelegatedResponse(this, originCall.m47(), responseContent, responseHeaders);
}
function DelegatedRequest(call, origin) {
  this.q4r_1 = origin;
  this.r4r_1 = call;
}
protoOf(DelegatedRequest).s4r = function () {
  return this.r4r_1;
};
protoOf(DelegatedRequest).f1x = function () {
  return this.q4r_1.f1x();
};
protoOf(DelegatedRequest).t4r = function () {
  return this.q4r_1.t4r();
};
protoOf(DelegatedRequest).b3p = function () {
  return this.q4r_1.b3p();
};
protoOf(DelegatedRequest).m4r = function () {
  return this.q4r_1.m4r();
};
protoOf(DelegatedRequest).q39 = function () {
  return this.q4r_1.q39();
};
function DelegatedResponse(call, origin, content, headers) {
  headers = headers === VOID ? origin.q39() : headers;
  HttpResponse.call(this);
  this.u4r_1 = call;
  this.v4r_1 = origin;
  this.w4r_1 = content;
  this.x4r_1 = headers;
  this.y4r_1 = this.v4r_1.f1x();
}
protoOf(DelegatedResponse).s4r = function () {
  return this.u4r_1;
};
protoOf(DelegatedResponse).q39 = function () {
  return this.x4r_1;
};
protoOf(DelegatedResponse).z4r = function () {
  return this.w4r_1(this.v4r_1);
};
protoOf(DelegatedResponse).f1x = function () {
  return this.y4r_1;
};
protoOf(DelegatedResponse).r3w = function () {
  return this.v4r_1.r3w();
};
protoOf(DelegatedResponse).r3t = function () {
  return this.v4r_1.r3t();
};
protoOf(DelegatedResponse).a4s = function () {
  return this.v4r_1.a4s();
};
protoOf(DelegatedResponse).b4s = function () {
  return this.v4r_1.b4s();
};
function HttpClientCall_init_$Init$(client, requestData, responseData, $this) {
  HttpClientCall.call($this, client);
  $this.b4p_1 = new DefaultHttpRequest($this, requestData);
  $this.c4p_1 = new DefaultHttpResponse($this, responseData);
  $this.m4r().p2v(Companion_getInstance_6().c4s_1);
  var tmp = responseData.h4s_1;
  if (!isInterface(tmp, ByteReadChannel)) {
    $this.m4r().o2v(Companion_getInstance_6().c4s_1, responseData.h4s_1);
  }
  return $this;
}
function HttpClientCall_init_$Create$(client, requestData, responseData) {
  return HttpClientCall_init_$Init$(client, requestData, responseData, objectCreate(protoOf(HttpClientCall)));
}
function Companion() {
  Companion_instance_0 = this;
  var tmp = this;
  // Inline function 'io.ktor.util.AttributeKey' call
  var name = 'CustomResponse';
  // Inline function 'io.ktor.util.reflect.typeInfo' call
  var tmp_0 = PrimitiveClasses_getInstance().ab();
  // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
  var tmp_1;
  try {
    tmp_1 = createKType(PrimitiveClasses_getInstance().ab(), arrayOf([]), false);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_1 = tmp_2;
  }
  var tmp$ret$0 = tmp_1;
  var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$0);
  tmp.c4s_1 = new AttributeKey(name, tmp$ret$1);
}
var Companion_instance_0;
function Companion_getInstance_6() {
  if (Companion_instance_0 == null)
    new Companion();
  return Companion_instance_0;
}
function $bodyNullableCOROUTINE$(_this__u8e3s4, info, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.s4s_1 = _this__u8e3s4;
  this.t4s_1 = info;
}
protoOf($bodyNullableCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 5;
          this.e8_1 = 4;
          if (instanceOf(this.s4s_1.m47(), this.t4s_1.r31_1))
            return this.s4s_1.m47();
          if (!this.s4s_1.n4r() && !get_isSaved(this.s4s_1.m47()) && !this.s4s_1.a4p_1.atomicfu$compareAndSet(false, true)) {
            throw new DoubleReceiveException(this.s4s_1);
          }

          var tmp0_elvis_lhs = this.s4s_1.m4r().m2v(Companion_getInstance_6().c4s_1);
          if (tmp0_elvis_lhs == null) {
            this.d8_1 = 1;
            suspendResult = this.s4s_1.o4r(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.u4s_1 = tmp0_elvis_lhs;
            this.d8_1 = 2;
            continue $sm;
          }

        case 1:
          this.u4s_1 = suspendResult;
          this.d8_1 = 2;
          continue $sm;
        case 2:
          var responseData = this.u4s_1;
          var subject = new HttpResponseContainer(this.t4s_1, responseData);
          this.d8_1 = 3;
          suspendResult = this.s4s_1.z4o_1.f4o_1.z30(this.s4s_1, subject, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          var this_0 = suspendResult.w4s_1;
          var tmp_0;
          if (!equals(this_0, NullBody_instance)) {
            tmp_0 = this_0;
          } else {
            tmp_0 = null;
          }

          var result = tmp_0;
          if (!(result == null) && !instanceOf(result, this.t4s_1.r31_1)) {
            var from = getKClassFromExpression(result);
            var to = this.t4s_1.r31_1;
            throw new NoTransformationFoundException(this.s4s_1.m47(), from, to);
          }

          return result;
        case 4:
          this.e8_1 = 5;
          var tmp_1 = this.g8_1;
          if (tmp_1 instanceof Error) {
            var cause = this.g8_1;
            cancel_0(this.s4s_1.m47(), 'Receive failed', cause);
            throw cause;
          } else {
            throw this.g8_1;
          }

        case 5:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 5) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function HttpClientCall(client) {
  Companion_getInstance_6();
  this.z4o_1 = client;
  this.a4p_1 = atomic$boolean$1(false);
  this.d4p_1 = false;
}
protoOf(HttpClientCall).f1x = function () {
  return this.m47().f1x();
};
protoOf(HttpClientCall).m4r = function () {
  return this.l4r().m4r();
};
protoOf(HttpClientCall).l4r = function () {
  var tmp = this.b4p_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('request');
  }
};
protoOf(HttpClientCall).m47 = function () {
  var tmp = this.c4p_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('response');
  }
};
protoOf(HttpClientCall).n4r = function () {
  return this.d4p_1;
};
protoOf(HttpClientCall).o4r = function ($completion) {
  return this.m47().z4r();
};
protoOf(HttpClientCall).p4r = function (info, $completion) {
  var tmp = new $bodyNullableCOROUTINE$(this, info, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpClientCall).toString = function () {
  return 'HttpClientCall[' + this.l4r().b3p().toString() + ', ' + this.m47().r3w().toString() + ']';
};
protoOf(HttpClientCall).e4p = function (response) {
  this.c4p_1 = response;
};
function DoubleReceiveException(call) {
  IllegalStateException_init_$Init$(this);
  captureStack(this, DoubleReceiveException);
  this.x4s_1 = 'Response already received: ' + call.toString();
  delete this.message;
}
protoOf(DoubleReceiveException).e = function () {
  return this.x4s_1;
};
function NoTransformationFoundException(response, from, to) {
  UnsupportedOperationException_init_$Init$(this);
  captureStack(this, NoTransformationFoundException);
  this.y4s_1 = trimIndent("\n        Expected response body of the type '" + toString(to) + "' but was '" + toString(from) + "'\n        In response from `" + get_request(response).b3p().toString() + '`\n        Response status `' + response.r3w().toString() + '`\n        Response header `ContentType: ' + response.q39().g1c(HttpHeaders_getInstance().d36_1) + '` \n        Request header `Accept: ' + get_request(response).q39().g1c(HttpHeaders_getInstance().l35_1) + '`\n        \n        You can read how to resolve NoTransformationFoundException at FAQ: \n        https://ktor.io/docs/faq.html#no-transformation-found-exception\n    ');
  delete this.message;
}
protoOf(NoTransformationFoundException).e = function () {
  return this.y4s_1;
};
function save(_this__u8e3s4, $completion) {
  var tmp = new $saveCOROUTINE$(_this__u8e3s4, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function SavedHttpCall(client, request, response, responseBody) {
  HttpClientCall.call(this, client);
  this.n4t_1 = responseBody;
  this.b4p_1 = new SavedHttpRequest(this, request);
  this.c4p_1 = new SavedHttpResponse(this, this.n4t_1, response);
  checkContentLength(contentLength(response), fromInt(this.n4t_1.length), request.t4r());
  this.o4t_1 = true;
}
protoOf(SavedHttpCall).n4r = function () {
  return this.o4t_1;
};
function SavedHttpRequest(call, origin) {
  this.p4t_1 = origin;
  this.q4t_1 = call;
}
protoOf(SavedHttpRequest).s4r = function () {
  return this.q4t_1;
};
protoOf(SavedHttpRequest).f1x = function () {
  return this.p4t_1.f1x();
};
protoOf(SavedHttpRequest).t4r = function () {
  return this.p4t_1.t4r();
};
protoOf(SavedHttpRequest).b3p = function () {
  return this.p4t_1.b3p();
};
protoOf(SavedHttpRequest).m4r = function () {
  return this.p4t_1.m4r();
};
protoOf(SavedHttpRequest).q39 = function () {
  return this.p4t_1.q39();
};
function SavedHttpResponse(call, body, origin) {
  HttpResponse.call(this);
  this.r4t_1 = call;
  this.s4t_1 = body;
  this.t4t_1 = origin.r3w();
  this.u4t_1 = origin.r3t();
  this.v4t_1 = origin.a4s();
  this.w4t_1 = origin.b4s();
  this.x4t_1 = origin.q39();
  this.y4t_1 = origin.f1x();
}
protoOf(SavedHttpResponse).s4r = function () {
  return this.r4t_1;
};
protoOf(SavedHttpResponse).r3w = function () {
  return this.t4t_1;
};
protoOf(SavedHttpResponse).r3t = function () {
  return this.u4t_1;
};
protoOf(SavedHttpResponse).a4s = function () {
  return this.v4t_1;
};
protoOf(SavedHttpResponse).b4s = function () {
  return this.w4t_1;
};
protoOf(SavedHttpResponse).q39 = function () {
  return this.x4t_1;
};
protoOf(SavedHttpResponse).f1x = function () {
  return this.y4t_1;
};
protoOf(SavedHttpResponse).z4r = function () {
  return ByteReadChannel_0(this.s4t_1);
};
function $saveCOROUTINE$(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.h4t_1 = _this__u8e3s4;
}
protoOf($saveCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          var tmp_0 = this.h4t_1;
          if (tmp_0 instanceof SavedHttpCall)
            return this.h4t_1;
          this.d8_1 = 1;
          suspendResult = readRemaining(this.h4t_1.m47().z4r(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          var responseBody = readByteArray(ARGUMENT);
          return new SavedHttpCall(this.h4t_1.z4o_1, this.h4t_1.l4r(), this.h4t_1.m47(), responseBody);
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function UnsupportedContentTypeException(content) {
  IllegalStateException_init_$Init$_0('Failed to write body: ' + toString(getKClassFromExpression(content)), this);
  captureStack(this, UnsupportedContentTypeException);
}
function ProgressListener() {
}
function getContent($this, delegate) {
  var tmp;
  if (delegate instanceof ContentWrapper) {
    tmp = getContent($this, delegate.r3f());
  } else {
    if (delegate instanceof ByteArrayContent) {
      tmp = ByteReadChannel_0(delegate.i3f());
    } else {
      if (delegate instanceof ProtocolUpgrade) {
        throw new UnsupportedContentTypeException(delegate);
      } else {
        if (delegate instanceof NoContent) {
          tmp = Companion_getInstance().o2n_1;
        } else {
          if (delegate instanceof ReadChannelContent) {
            tmp = delegate.l3f();
          } else {
            if (delegate instanceof WriteChannelContent) {
              var tmp_0 = GlobalScope_instance;
              tmp = writer(tmp_0, $this.c4u_1, true, ObservableContent$getContent$slambda_0(delegate, null)).n2s_1;
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
  }
  return tmp;
}
function ObservableContent$getContent$slambda($delegate, resultContinuation) {
  this.m4u_1 = $delegate;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(ObservableContent$getContent$slambda).n4m = function ($this$writer, $completion) {
  var tmp = this.o4m($this$writer, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(ObservableContent$getContent$slambda).x8 = function (p1, $completion) {
  return this.n4m(p1 instanceof WriterScope ? p1 : THROW_CCE(), $completion);
};
protoOf(ObservableContent$getContent$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.m4u_1.n3f(this.n4u_1.p2s_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(ObservableContent$getContent$slambda).o4m = function ($this$writer, completion) {
  var i = new ObservableContent$getContent$slambda(this.m4u_1, completion);
  i.n4u_1 = $this$writer;
  return i;
};
function ObservableContent$getContent$slambda_0($delegate, resultContinuation) {
  var i = new ObservableContent$getContent$slambda($delegate, resultContinuation);
  var l = function ($this$writer, $completion) {
    return i.n4m($this$writer, $completion);
  };
  l.$arity = 1;
  return l;
}
function ObservableContent(delegate, callContext, listener) {
  ReadChannelContent.call(this);
  this.b4u_1 = delegate;
  this.c4u_1 = callContext;
  this.d4u_1 = listener;
}
protoOf(ObservableContent).g3f = function () {
  return this.b4u_1.g3f();
};
protoOf(ObservableContent).h3f = function () {
  return this.b4u_1.h3f();
};
protoOf(ObservableContent).q39 = function () {
  return this.b4u_1.q39();
};
protoOf(ObservableContent).l3f = function () {
  return observable(getContent(this, this.b4u_1), this.c4u_1, this.h3f(), this.d4u_1);
};
function get_CALL_COROUTINE() {
  _init_properties_HttpClientEngine_kt__h91z5h();
  return CALL_COROUTINE;
}
var CALL_COROUTINE;
function get_CLIENT_CONFIG() {
  _init_properties_HttpClientEngine_kt__h91z5h();
  return CLIENT_CONFIG;
}
var CLIENT_CONFIG;
function HttpClientEngine$install$slambda$lambda($client, $response) {
  return function (it) {
    var tmp;
    if (!(it == null)) {
      $client.k4o_1.w4e(get_HttpResponseCancelled(), $response);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function _get_closed__iwkfs1($this) {
  var tmp0_safe_receiver = $this.f1x().q8(Key_instance);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g1x();
  return !(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
}
function executeWithinCallContext($this, requestData, $completion) {
  var tmp = new $executeWithinCallContextCOROUTINE$($this, requestData, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function checkExtensions($this, requestData) {
  var _iterator__ex2g4s = requestData.e4v_1.l();
  while (_iterator__ex2g4s.m()) {
    var requestedExtension = _iterator__ex2g4s.n();
    // Inline function 'kotlin.require' call
    if (!$this.f4v().q1(requestedExtension)) {
      var message = "Engine doesn't support " + toString(requestedExtension);
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
}
function HttpClientEngine$install$slambda($client, this$0, resultContinuation) {
  this.o4v_1 = $client;
  this.p4v_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpClientEngine$install$slambda).x4o = function ($this$intercept, content, $completion) {
  var tmp = this.y4o($this$intercept, content, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpClientEngine$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpClientEngine$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          var this_0 = new HttpRequestBuilder();
          this_0.t4v(this.q4v_1.a31_1);
          var body = this.r4v_1;
          if (body == null) {
            this_0.g4q_1 = NullBody_instance;
            var tmp_0 = PrimitiveClasses_getInstance().ab();
            var tmp_1;
            try {
              tmp_1 = createKType(PrimitiveClasses_getInstance().ab(), arrayOf([]), false);
            } catch ($p) {
              var tmp_2;
              if ($p instanceof Error) {
                var _unused_var__etf5q3 = $p;
                tmp_2 = null;
              } else {
                throw $p;
              }
              tmp_1 = tmp_2;
            }
            this_0.u4v(new TypeInfo(tmp_0, tmp_1));
          } else {
            if (body instanceof OutgoingContent) {
              this_0.g4q_1 = body;
              this_0.u4v(null);
            } else {
              this_0.g4q_1 = body;
              var tmp_3 = PrimitiveClasses_getInstance().ab();
              var tmp_4;
              try {
                tmp_4 = createKType(PrimitiveClasses_getInstance().ab(), arrayOf([]), false);
              } catch ($p) {
                var tmp_5;
                if ($p instanceof Error) {
                  var _unused_var__etf5q3_0 = $p;
                  tmp_5 = null;
                } else {
                  throw $p;
                }
                tmp_4 = tmp_5;
              }
              this_0.u4v(new TypeInfo(tmp_3, tmp_4));
            }
          }

          var builder = this_0;
          this.o4v_1.k4o_1.w4e(get_HttpRequestIsReadyForSending(), builder);
          var tmp_6 = this;
          var this_1 = builder.z1m();
          this_1.d4v_1.o2v(get_CLIENT_CONFIG(), this.o4v_1.l4o_1);
          tmp_6.s4v_1 = this_1;
          validateHeaders(this.s4v_1);
          checkExtensions(this.p4v_1, this.s4v_1);
          this.d8_1 = 1;
          suspendResult = executeWithinCallContext(this.p4v_1, this.s4v_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var responseData = suspendResult;
          var call = HttpClientCall_init_$Create$(this.o4v_1, this.s4v_1, responseData);
          var response = call.m47();
          this.o4v_1.k4o_1.w4e(get_HttpResponseReceived(), response);
          var tmp_7 = get_job(response.f1x());
          tmp_7.h1y(HttpClientEngine$install$slambda$lambda(this.o4v_1, response));
          this.d8_1 = 2;
          suspendResult = this.q4v_1.e30(call, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpClientEngine$install$slambda).y4o = function ($this$intercept, content, completion) {
  var i = new HttpClientEngine$install$slambda(this.o4v_1, this.p4v_1, completion);
  i.q4v_1 = $this$intercept;
  i.r4v_1 = content;
  return i;
};
function HttpClientEngine$install$slambda_0($client, this$0, resultContinuation) {
  var i = new HttpClientEngine$install$slambda($client, this$0, resultContinuation);
  var l = function ($this$intercept, content, $completion) {
    return i.x4o($this$intercept, content, $completion);
  };
  l.$arity = 2;
  return l;
}
function HttpClientEngine$executeWithinCallContext$slambda(this$0, $requestData, resultContinuation) {
  this.d4w_1 = this$0;
  this.e4w_1 = $requestData;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpClientEngine$executeWithinCallContext$slambda).g4w = function ($this$async, $completion) {
  var tmp = this.m2t($this$async, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpClientEngine$executeWithinCallContext$slambda).x8 = function (p1, $completion) {
  return this.g4w((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(HttpClientEngine$executeWithinCallContext$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          if (_get_closed__iwkfs1(this.d4w_1)) {
            throw new ClientEngineClosedException();
          }

          this.d8_1 = 1;
          suspendResult = this.d4w_1.h4w(this.e4w_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpClientEngine$executeWithinCallContext$slambda).m2t = function ($this$async, completion) {
  var i = new HttpClientEngine$executeWithinCallContext$slambda(this.d4w_1, this.e4w_1, completion);
  i.f4w_1 = $this$async;
  return i;
};
function HttpClientEngine$executeWithinCallContext$slambda_0(this$0, $requestData, resultContinuation) {
  var i = new HttpClientEngine$executeWithinCallContext$slambda(this$0, $requestData, resultContinuation);
  var l = function ($this$async, $completion) {
    return i.g4w($this$async, $completion);
  };
  l.$arity = 1;
  return l;
}
function $executeWithinCallContextCOROUTINE$(_this__u8e3s4, requestData, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.w4u_1 = _this__u8e3s4;
  this.x4u_1 = requestData;
}
protoOf($executeWithinCallContextCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          this.d8_1 = 1;
          suspendResult = createCallContext(this.w4u_1, this.x4u_1.c4v_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var callContext = suspendResult;
          var context = callContext.fh(new KtorCallContextElement(callContext));
          this.d8_1 = 2;
          suspendResult = async(this.w4u_1, context, VOID, HttpClientEngine$executeWithinCallContext$slambda_0(this.w4u_1, this.x4u_1, null)).a20(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function HttpClientEngine() {
}
function validateHeaders(request) {
  _init_properties_HttpClientEngine_kt__h91z5h();
  var requestHeaders = request.a4v_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = requestHeaders.f2x();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var _iterator__ex2g4s = tmp0.l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    if (HttpHeaders_getInstance().h39_1.q1(element)) {
      destination.j(element);
    }
  }
  var unsafeRequestHeaders = destination;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!unsafeRequestHeaders.q()) {
    throw new UnsafeHeaderException(toString(unsafeRequestHeaders));
  }
}
function createCallContext(_this__u8e3s4, parentJob, $completion) {
  var callJob = Job(parentJob);
  var callContext = _this__u8e3s4.f1x().fh(callJob).fh(get_CALL_COROUTINE());
  $l$block: {
    // Inline function 'io.ktor.client.engine.attachToUserJob' call
    // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp0_elvis_lhs = $completion.j8().q8(Key_instance);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break $l$block;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var userJob = tmp;
    var cleanupHandler = userJob.j1y(true, VOID, createCallContext$lambda(callJob));
    callJob.h1y(createCallContext$lambda_0(cleanupHandler));
  }
  return callContext;
}
function createCallContext$lambda($callJob) {
  return function (cause) {
    if (cause == null)
      return Unit_instance;
    $callJob.o1y(CancellationException_init_$Create$(cause.message));
    return Unit_instance;
  };
}
function createCallContext$lambda_0($cleanupHandler) {
  return function (it) {
    $cleanupHandler.t20();
    return Unit_instance;
  };
}
var properties_initialized_HttpClientEngine_kt_5uiebb;
function _init_properties_HttpClientEngine_kt__h91z5h() {
  if (!properties_initialized_HttpClientEngine_kt_5uiebb) {
    properties_initialized_HttpClientEngine_kt_5uiebb = true;
    CALL_COROUTINE = new CoroutineName('call-context');
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'client-config';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(HttpClientConfig);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(HttpClientConfig), arrayOf([getStarKTypeProjection()]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$0 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$0);
    CLIENT_CONFIG = new AttributeKey(name, tmp$ret$1);
  }
}
function HttpClientEngineBase$dispatcher$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.j4q().j4w_1;
    return tmp0_elvis_lhs == null ? ioDispatcher() : tmp0_elvis_lhs;
  };
}
function HttpClientEngineBase$_get_dispatcher_$ref_kz5x8v() {
  return function (p0) {
    return p0.q4w();
  };
}
function HttpClientEngineBase$coroutineContext$delegate$lambda(this$0) {
  return function () {
    return SilentSupervisor().fh(this$0.q4w()).fh(new CoroutineName(this$0.m4w_1 + '-context'));
  };
}
function HttpClientEngineBase$_get_coroutineContext_$ref_p82ehr() {
  return function (p0) {
    return p0.f1x();
  };
}
function HttpClientEngineBase(engineName) {
  this.m4w_1 = engineName;
  this.n4w_1 = atomic$boolean$1(false);
  var tmp = this;
  tmp.o4w_1 = lazy(HttpClientEngineBase$dispatcher$delegate$lambda(this));
  var tmp_0 = this;
  tmp_0.p4w_1 = lazy(HttpClientEngineBase$coroutineContext$delegate$lambda(this));
}
protoOf(HttpClientEngineBase).q4w = function () {
  var tmp0 = this.o4w_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('dispatcher', 1, tmp, HttpClientEngineBase$_get_dispatcher_$ref_kz5x8v(), null);
  return tmp0.w();
};
protoOf(HttpClientEngineBase).f1x = function () {
  var tmp0 = this.p4w_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('coroutineContext', 1, tmp, HttpClientEngineBase$_get_coroutineContext_$ref_p82ehr(), null);
  return tmp0.w();
};
protoOf(HttpClientEngineBase).i3 = function () {
  if (!this.n4w_1.atomicfu$compareAndSet(false, true))
    return Unit_instance;
  var tmp = this.f1x().q8(Key_instance);
  var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, CompletableJob) : false) ? tmp : null;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var requestJob = tmp_0;
  requestJob.b24();
};
function ClientEngineClosedException(cause) {
  cause = cause === VOID ? null : cause;
  IllegalStateException_init_$Init$_0('Client already closed', this);
  captureStack(this, ClientEngineClosedException);
  this.r4w_1 = cause;
  delete this.cause;
}
protoOf(ClientEngineClosedException).f = function () {
  return this.r4w_1;
};
function get_ENGINE_CAPABILITIES_KEY() {
  _init_properties_HttpClientEngineCapability_kt__ifvyst();
  return ENGINE_CAPABILITIES_KEY;
}
var ENGINE_CAPABILITIES_KEY;
var DEFAULT_CAPABILITIES;
function HttpClientEngineCapability() {
}
var properties_initialized_HttpClientEngineCapability_kt_qarzcf;
function _init_properties_HttpClientEngineCapability_kt__ifvyst() {
  if (!properties_initialized_HttpClientEngineCapability_kt_qarzcf) {
    properties_initialized_HttpClientEngineCapability_kt_qarzcf = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'EngineCapabilities';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(KtMutableMap);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(KtMutableMap), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpClientEngineCapability), arrayOf([getStarKTypeProjection()]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ab(), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$0 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$0);
    ENGINE_CAPABILITIES_KEY = new AttributeKey(name, tmp$ret$1);
    DEFAULT_CAPABILITIES = setOf(HttpTimeoutCapability_instance);
  }
}
function HttpClientEngineConfig() {
  this.i4w_1 = 4;
  this.j4w_1 = null;
  this.k4w_1 = false;
  this.l4w_1 = null;
}
function get_KTOR_DEFAULT_USER_AGENT() {
  _init_properties_Utils_kt__jo07cx();
  return KTOR_DEFAULT_USER_AGENT;
}
var KTOR_DEFAULT_USER_AGENT;
function get_DATE_HEADERS() {
  _init_properties_Utils_kt__jo07cx();
  return DATE_HEADERS;
}
var DATE_HEADERS;
function callContext($completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.j8();
  return ensureNotNull(tmp$ret$0.q8(Companion_instance_1)).s4w_1;
}
function Companion_0() {
}
var Companion_instance_1;
function Companion_getInstance_7() {
  return Companion_instance_1;
}
function KtorCallContextElement(callContext) {
  this.s4w_1 = callContext;
}
protoOf(KtorCallContextElement).v = function () {
  return Companion_instance_1;
};
function mergeHeaders(requestHeaders, content, block) {
  _init_properties_Utils_kt__jo07cx();
  var tmp = buildHeaders(mergeHeaders$lambda(requestHeaders, content));
  tmp.k2x(mergeHeaders$lambda_0(block));
  var missingAgent = requestHeaders.g1c(HttpHeaders_getInstance().j38_1) == null && content.q39().g1c(HttpHeaders_getInstance().j38_1) == null;
  if (missingAgent && needUserAgent()) {
    block(HttpHeaders_getInstance().j38_1, get_KTOR_DEFAULT_USER_AGENT());
  }
  var tmp0_safe_receiver = content.g3f();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? content.q39().g1c(HttpHeaders_getInstance().d36_1) : tmp1_elvis_lhs;
  var type = tmp2_elvis_lhs == null ? requestHeaders.g1c(HttpHeaders_getInstance().d36_1) : tmp2_elvis_lhs;
  var tmp3_safe_receiver = content.h3f();
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString();
  var tmp5_elvis_lhs = tmp4_elvis_lhs == null ? content.q39().g1c(HttpHeaders_getInstance().a36_1) : tmp4_elvis_lhs;
  var length = tmp5_elvis_lhs == null ? requestHeaders.g1c(HttpHeaders_getInstance().a36_1) : tmp5_elvis_lhs;
  if (type == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    block(HttpHeaders_getInstance().d36_1, type);
  }
  if (length == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    block(HttpHeaders_getInstance().a36_1, length);
  }
}
function needUserAgent() {
  _init_properties_Utils_kt__jo07cx();
  return !PlatformUtils_getInstance().p2w_1;
}
function mergeHeaders$lambda($requestHeaders, $content) {
  return function ($this$buildHeaders) {
    $this$buildHeaders.j2x($requestHeaders);
    $this$buildHeaders.j2x($content.q39());
    return Unit_instance;
  };
}
function mergeHeaders$lambda_0($block) {
  return function (key, values) {
    var tmp;
    if (HttpHeaders_getInstance().a36_1 === key) {
      return Unit_instance;
    }
    var tmp_0;
    if (HttpHeaders_getInstance().d36_1 === key) {
      return Unit_instance;
    }
    var tmp_1;
    if (get_DATE_HEADERS().q1(key)) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = values.l();
      while (_iterator__ex2g4s.m()) {
        var element = _iterator__ex2g4s.n();
        $block(key, element);
      }
      tmp_1 = Unit_instance;
    } else {
      var separator = HttpHeaders_getInstance().e36_1 === key ? '; ' : ',';
      tmp_1 = $block(key, joinToString(values, separator));
    }
    return Unit_instance;
  };
}
var properties_initialized_Utils_kt_xvi83j;
function _init_properties_Utils_kt__jo07cx() {
  if (!properties_initialized_Utils_kt_xvi83j) {
    properties_initialized_Utils_kt_xvi83j = true;
    KTOR_DEFAULT_USER_AGENT = 'ktor-client';
    DATE_HEADERS = setOf_0([HttpHeaders_getInstance().g36_1, HttpHeaders_getInstance().m36_1, HttpHeaders_getInstance().y36_1, HttpHeaders_getInstance().t36_1, HttpHeaders_getInstance().x36_1]);
  }
}
function get_UploadProgressListenerAttributeKey() {
  _init_properties_BodyProgress_kt__s0v569();
  return UploadProgressListenerAttributeKey;
}
var UploadProgressListenerAttributeKey;
function get_DownloadProgressListenerAttributeKey() {
  _init_properties_BodyProgress_kt__s0v569();
  return DownloadProgressListenerAttributeKey;
}
var DownloadProgressListenerAttributeKey;
function get_BodyProgress() {
  _init_properties_BodyProgress_kt__s0v569();
  return BodyProgress;
}
var BodyProgress;
function AfterRenderHook$install$slambda($handler, resultContinuation) {
  this.b4x_1 = $handler;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(AfterRenderHook$install$slambda).x4o = function ($this$intercept, content, $completion) {
  var tmp = this.y4o($this$intercept, content, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(AfterRenderHook$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(AfterRenderHook$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          var tmp_0 = this.d4x_1;
          if (!(tmp_0 instanceof OutgoingContent))
            return Unit_instance;
          this.d8_1 = 1;
          suspendResult = this.b4x_1(this.c4x_1.a31_1, this.d4x_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp0_elvis_lhs = suspendResult;
          var tmp_1;
          if (tmp0_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp_1 = tmp0_elvis_lhs;
          }

          var newContent = tmp_1;
          this.d8_1 = 2;
          suspendResult = this.c4x_1.e30(newContent, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(AfterRenderHook$install$slambda).y4o = function ($this$intercept, content, completion) {
  var i = new AfterRenderHook$install$slambda(this.b4x_1, completion);
  i.c4x_1 = $this$intercept;
  i.d4x_1 = content;
  return i;
};
function AfterRenderHook$install$slambda_0($handler, resultContinuation) {
  var i = new AfterRenderHook$install$slambda($handler, resultContinuation);
  var l = function ($this$intercept, content, $completion) {
    return i.x4o($this$intercept, content, $completion);
  };
  l.$arity = 2;
  return l;
}
function AfterRenderHook() {
}
protoOf(AfterRenderHook).e4x = function (client, handler) {
  var observableContentPhase = new PipelinePhase('ObservableContent');
  client.e4o_1.b31(Phases_getInstance().i4x_1, observableContentPhase);
  client.e4o_1.e31(observableContentPhase, AfterRenderHook$install$slambda_0(handler, null));
};
protoOf(AfterRenderHook).k4x = function (client, handler) {
  return this.e4x(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
};
var AfterRenderHook_instance;
function AfterRenderHook_getInstance() {
  return AfterRenderHook_instance;
}
function AfterReceiveHook$install$slambda($handler, resultContinuation) {
  this.t4x_1 = $handler;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(AfterReceiveHook$install$slambda).w4x = function ($this$intercept, response, $completion) {
  var tmp = this.x4x($this$intercept, response, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(AfterReceiveHook$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.w4x(tmp, p2 instanceof HttpResponse ? p2 : THROW_CCE(), $completion);
};
protoOf(AfterReceiveHook$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          this.d8_1 = 1;
          suspendResult = this.t4x_1(this.v4x_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var newResponse = suspendResult;
          if (!(newResponse == null)) {
            this.d8_1 = 2;
            suspendResult = this.u4x_1.e30(newResponse, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.d8_1 = 3;
            continue $sm;
          }

        case 2:
          this.d8_1 = 3;
          continue $sm;
        case 3:
          return Unit_instance;
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(AfterReceiveHook$install$slambda).x4x = function ($this$intercept, response, completion) {
  var i = new AfterReceiveHook$install$slambda(this.t4x_1, completion);
  i.u4x_1 = $this$intercept;
  i.v4x_1 = response;
  return i;
};
function AfterReceiveHook$install$slambda_0($handler, resultContinuation) {
  var i = new AfterReceiveHook$install$slambda($handler, resultContinuation);
  var l = function ($this$intercept, response, $completion) {
    return i.w4x($this$intercept, response, $completion);
  };
  l.$arity = 2;
  return l;
}
function AfterReceiveHook() {
}
protoOf(AfterReceiveHook).y4x = function (client, handler) {
  var tmp = Phases_getInstance_1().b4y_1;
  client.h4o_1.e31(tmp, AfterReceiveHook$install$slambda_0(handler, null));
};
protoOf(AfterReceiveHook).k4x = function (client, handler) {
  return this.y4x(client, (!(handler == null) ? isSuspendFunction(handler, 1) : false) ? handler : THROW_CCE());
};
var AfterReceiveHook_instance;
function AfterReceiveHook_getInstance() {
  return AfterReceiveHook_instance;
}
function withObservableDownload(_this__u8e3s4, listener) {
  _init_properties_BodyProgress_kt__s0v569();
  var tmp = _this__u8e3s4.s4r();
  return replaceResponse(tmp, VOID, withObservableDownload$lambda(listener)).m47();
}
function BodyProgress$lambda($this$createClientPlugin) {
  _init_properties_BodyProgress_kt__s0v569();
  var tmp = AfterRenderHook_instance;
  $this$createClientPlugin.h4y(tmp, BodyProgress$lambda$slambda_0(null));
  var tmp_0 = AfterReceiveHook_instance;
  $this$createClientPlugin.h4y(tmp_0, BodyProgress$lambda$slambda_2(null));
  return Unit_instance;
}
function BodyProgress$lambda$slambda(resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(BodyProgress$lambda$slambda).s4y = function (request, content, $completion) {
  var tmp = this.t4y(request, content, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(BodyProgress$lambda$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof HttpRequestBuilder ? p1 : THROW_CCE();
  return this.s4y(tmp, p2 instanceof OutgoingContent ? p2 : THROW_CCE(), $completion);
};
protoOf(BodyProgress$lambda$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      if (tmp === 0) {
        this.e8_1 = 1;
        var tmp0_elvis_lhs = this.q4y_1.i4q_1.m2v(get_UploadProgressListenerAttributeKey());
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var listener = tmp_0;
        return new ObservableContent(this.r4y_1, this.q4y_1.h4q_1, listener);
      } else if (tmp === 1) {
        throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
   while (true);
};
protoOf(BodyProgress$lambda$slambda).t4y = function (request, content, completion) {
  var i = new BodyProgress$lambda$slambda(completion);
  i.q4y_1 = request;
  i.r4y_1 = content;
  return i;
};
function BodyProgress$lambda$slambda_0(resultContinuation) {
  var i = new BodyProgress$lambda$slambda(resultContinuation);
  var l = function (request, content, $completion) {
    return i.s4y(request, content, $completion);
  };
  l.$arity = 2;
  return l;
}
function BodyProgress$lambda$slambda_1(resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(BodyProgress$lambda$slambda_1).d4z = function (response, $completion) {
  var tmp = this.e4z(response, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(BodyProgress$lambda$slambda_1).x8 = function (p1, $completion) {
  return this.d4z(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
};
protoOf(BodyProgress$lambda$slambda_1).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      if (tmp === 0) {
        this.e8_1 = 1;
        var tmp0_elvis_lhs = this.c4z_1.s4r().l4r().m4r().m2v(get_DownloadProgressListenerAttributeKey());
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var listener = tmp_0;
        return withObservableDownload(this.c4z_1, listener);
      } else if (tmp === 1) {
        throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
   while (true);
};
protoOf(BodyProgress$lambda$slambda_1).e4z = function (response, completion) {
  var i = new BodyProgress$lambda$slambda_1(completion);
  i.c4z_1 = response;
  return i;
};
function BodyProgress$lambda$slambda_2(resultContinuation) {
  var i = new BodyProgress$lambda$slambda_1(resultContinuation);
  var l = function (response, $completion) {
    return i.d4z(response, $completion);
  };
  l.$arity = 1;
  return l;
}
function withObservableDownload$lambda($listener) {
  return function ($this$replaceResponse) {
    return observable($this$replaceResponse.z4r(), $this$replaceResponse.f1x(), contentLength($this$replaceResponse), $listener);
  };
}
var properties_initialized_BodyProgress_kt_pmfrhr;
function _init_properties_BodyProgress_kt__s0v569() {
  if (!properties_initialized_BodyProgress_kt_pmfrhr) {
    properties_initialized_BodyProgress_kt_pmfrhr = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'UploadProgressListenerAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(ProgressListener);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(ProgressListener), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$0 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$0);
    UploadProgressListenerAttributeKey = new AttributeKey(name, tmp$ret$1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_0 = 'DownloadProgressListenerAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_2 = getKClass(ProgressListener);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_3;
    try {
      tmp_3 = createKType(getKClass(ProgressListener), arrayOf([]), false);
    } catch ($p) {
      var tmp_4;
      if ($p instanceof Error) {
        var _unused_var__etf5q3_0 = $p;
        tmp_4 = null;
      } else {
        throw $p;
      }
      tmp_3 = tmp_4;
    }
    var tmp$ret$0_0 = tmp_3;
    var tmp$ret$1_0 = new TypeInfo(tmp_2, tmp$ret$0_0);
    DownloadProgressListenerAttributeKey = new AttributeKey(name_0, tmp$ret$1_0);
    BodyProgress = createClientPlugin_0('BodyProgress', BodyProgress$lambda);
  }
}
function get_LOGGER() {
  _init_properties_DefaultRequest_kt__yzsodq();
  return LOGGER;
}
var LOGGER;
function defaultRequest(_this__u8e3s4, block) {
  _init_properties_DefaultRequest_kt__yzsodq();
  var tmp = Plugin_getInstance();
  _this__u8e3s4.k4r(tmp, defaultRequest$lambda(block));
}
function mergeUrls($this, baseUrl, requestUrl) {
  if (requestUrl.w3c_1 == null) {
    requestUrl.w3c_1 = baseUrl.r3d_1;
  }
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = requestUrl.t3c_1;
  if (charSequenceLength(this_0) > 0)
    return Unit_instance;
  var resultUrl = URLBuilder(baseUrl);
  // Inline function 'kotlin.with' call
  resultUrl.w3c_1 = requestUrl.w3c_1;
  if (!(requestUrl.v3c_1 === 0)) {
    resultUrl.b3e(requestUrl.v3c_1);
  }
  resultUrl.a3d_1 = concatenatePath(Plugin_getInstance(), resultUrl.a3d_1, requestUrl.a3d_1);
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_1 = requestUrl.z3c_1;
  if (charSequenceLength(this_1) > 0) {
    resultUrl.z3c_1 = requestUrl.z3c_1;
  }
  // Inline function 'kotlin.apply' call
  var this_2 = ParametersBuilder();
  appendAll(this_2, resultUrl.b3d_1);
  var defaultParameters = this_2;
  resultUrl.p3e(requestUrl.b3d_1);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = defaultParameters.x2w().l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    // Inline function 'kotlin.collections.component1' call
    var key = element.v();
    // Inline function 'kotlin.collections.component2' call
    var values = element.w();
    if (!resultUrl.b3d_1.e2x(key)) {
      resultUrl.b3d_1.y2w(key, values);
    }
  }
  takeFrom(requestUrl, resultUrl);
}
function concatenatePath($this, parent, child) {
  if (child.q())
    return parent;
  if (parent.q())
    return child;
  // Inline function 'kotlin.text.isEmpty' call
  var this_0 = first(child);
  if (charSequenceLength(this_0) === 0)
    return child;
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  var capacity = (parent.o() + child.o() | 0) - 1 | 0;
  checkBuilderCapacity(capacity);
  // Inline function 'kotlin.apply' call
  var this_1 = ArrayList_init_$Create$_0(capacity);
  var inductionVariable = 0;
  var last = parent.o() - 1 | 0;
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this_1.j(parent.p(index));
    }
     while (inductionVariable < last);
  this_1.s(child);
  return this_1.u2();
}
function DefaultRequest$Plugin$install$slambda($plugin, resultContinuation) {
  this.n4z_1 = $plugin;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DefaultRequest$Plugin$install$slambda).x4o = function ($this$intercept, it, $completion) {
  var tmp = this.y4o($this$intercept, it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(DefaultRequest$Plugin$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(DefaultRequest$Plugin$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      if (tmp === 0) {
        this.e8_1 = 1;
        var originalUrlString = this.o4z_1.a31_1.d4q_1.toString();
        var this_0 = new DefaultRequestBuilder();
        appendAll(this_0.q4z_1, this.o4z_1.a31_1.f4q_1);
        var userHeaders = this_0.q4z_1.z1m();
        this.n4z_1.t4z_1(this_0);
        var _iterator__ex2g4s = userHeaders.x2w().l();
        while (_iterator__ex2g4s.m()) {
          var element = _iterator__ex2g4s.n();
          l$ret$1: do {
            var key = element.v();
            var oldValues = element.w();
            var newValues = this_0.q4z_1.d2x(key);
            if (newValues == null) {
              this_0.q4z_1.y2w(key, oldValues);
              break l$ret$1;
            }
            if (equals(newValues, oldValues) || key === HttpHeaders_getInstance().e36_1) {
              break l$ret$1;
            }
            this_0.q4z_1.m2x(key);
            this_0.q4z_1.y2w(key, oldValues);
            this_0.q4z_1.l2x(key, newValues);
          }
           while (false);
        }
        var defaultRequest = this_0;
        var defaultUrl = defaultRequest.r4z_1.z1m();
        mergeUrls(Plugin_getInstance(), defaultUrl, this.o4z_1.a31_1.d4q_1);
        var _iterator__ex2g4s_0 = defaultRequest.s4z_1.r2v().l();
        while (_iterator__ex2g4s_0.m()) {
          var element_0 = _iterator__ex2g4s_0.n();
          if (!this.o4z_1.a31_1.i4q_1.n2v(element_0)) {
            this.o4z_1.a31_1.i4q_1.o2v(element_0 instanceof AttributeKey ? element_0 : THROW_CCE(), defaultRequest.s4z_1.l2v(element_0));
          }
        }
        this.o4z_1.a31_1.f4q_1.w1();
        this.o4z_1.a31_1.f4q_1.j2x(defaultRequest.q4z_1.z1m());
        get_LOGGER().y31('Applied DefaultRequest to ' + originalUrlString + '. New url: ' + this.o4z_1.a31_1.d4q_1.toString());
        return Unit_instance;
      } else if (tmp === 1) {
        throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
   while (true);
};
protoOf(DefaultRequest$Plugin$install$slambda).y4o = function ($this$intercept, it, completion) {
  var i = new DefaultRequest$Plugin$install$slambda(this.n4z_1, completion);
  i.o4z_1 = $this$intercept;
  i.p4z_1 = it;
  return i;
};
function DefaultRequest$Plugin$install$slambda_0($plugin, resultContinuation) {
  var i = new DefaultRequest$Plugin$install$slambda($plugin, resultContinuation);
  var l = function ($this$intercept, it, $completion) {
    return i.x4o($this$intercept, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function Plugin() {
  Plugin_instance = this;
  var tmp = this;
  // Inline function 'io.ktor.util.AttributeKey' call
  var name = 'DefaultRequest';
  // Inline function 'io.ktor.util.reflect.typeInfo' call
  var tmp_0 = getKClass(DefaultRequest);
  // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
  var tmp_1;
  try {
    tmp_1 = createKType(getKClass(DefaultRequest), arrayOf([]), false);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_1 = tmp_2;
  }
  var tmp$ret$0 = tmp_1;
  var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$0);
  tmp.u4z_1 = new AttributeKey(name, tmp$ret$1);
}
protoOf(Plugin).v = function () {
  return this.u4z_1;
};
protoOf(Plugin).v4z = function (block) {
  return new DefaultRequest(block);
};
protoOf(Plugin).i4r = function (block) {
  return this.v4z(block);
};
protoOf(Plugin).w4z = function (plugin, scope) {
  var tmp = Phases_getInstance().f4x_1;
  scope.e4o_1.e31(tmp, DefaultRequest$Plugin$install$slambda_0(plugin, null));
};
protoOf(Plugin).j4r = function (plugin, scope) {
  return this.w4z(plugin instanceof DefaultRequest ? plugin : THROW_CCE(), scope);
};
var Plugin_instance;
function Plugin_getInstance() {
  if (Plugin_instance == null)
    new Plugin();
  return Plugin_instance;
}
function DefaultRequestBuilder() {
  this.q4z_1 = new HeadersBuilder();
  this.r4z_1 = new URLBuilder_0();
  this.s4z_1 = AttributesJsFn(true);
}
protoOf(DefaultRequestBuilder).q39 = function () {
  return this.q4z_1;
};
protoOf(DefaultRequestBuilder).x4z = function (urlString) {
  takeFrom_0(this.r4z_1, urlString);
};
function DefaultRequest(block) {
  Plugin_getInstance();
  this.t4z_1 = block;
}
function defaultRequest$lambda($block) {
  return function ($this$install) {
    $block($this$install);
    return Unit_instance;
  };
}
var properties_initialized_DefaultRequest_kt_au5efk;
function _init_properties_DefaultRequest_kt__yzsodq() {
  if (!properties_initialized_DefaultRequest_kt_au5efk) {
    properties_initialized_DefaultRequest_kt_au5efk = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.DefaultRequest');
  }
}
function get_ValidateMark() {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  return ValidateMark;
}
var ValidateMark;
function get_LOGGER_0() {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  return LOGGER_0;
}
var LOGGER_0;
function addDefaultResponseValidation(_this__u8e3s4) {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  HttpResponseValidator(_this__u8e3s4, addDefaultResponseValidation$lambda(_this__u8e3s4));
}
function ResponseException(response, cachedResponseText) {
  IllegalStateException_init_$Init$_0('Bad response: ' + response.toString() + '. Text: "' + cachedResponseText + '"', this);
  captureStack(this, ResponseException);
  this.y4z_1 = response;
}
function RedirectResponseException(response, cachedResponseText) {
  ResponseException.call(this, response, cachedResponseText);
  captureStack(this, RedirectResponseException);
  this.a50_1 = 'Unhandled redirect: ' + response.s4r().l4r().t4r().z39_1 + ' ' + response.s4r().l4r().b3p().toString() + '. ' + ('Status: ' + response.r3w().toString() + '. Text: "' + cachedResponseText + '"');
  delete this.message;
}
protoOf(RedirectResponseException).e = function () {
  return this.a50_1;
};
function ClientRequestException(response, cachedResponseText) {
  ResponseException.call(this, response, cachedResponseText);
  captureStack(this, ClientRequestException);
  this.c50_1 = 'Client request(' + response.s4r().l4r().t4r().z39_1 + ' ' + response.s4r().l4r().b3p().toString() + ') ' + ('invalid: ' + response.r3w().toString() + '. Text: "' + cachedResponseText + '"');
  delete this.message;
}
protoOf(ClientRequestException).e = function () {
  return this.c50_1;
};
function ServerResponseException(response, cachedResponseText) {
  ResponseException.call(this, response, cachedResponseText);
  captureStack(this, ServerResponseException);
  this.e50_1 = 'Server error(' + response.s4r().l4r().t4r().z39_1 + ' ' + response.s4r().l4r().b3p().toString() + ': ' + (response.r3w().toString() + '. Text: "' + cachedResponseText + '"');
  delete this.message;
}
protoOf(ServerResponseException).e = function () {
  return this.e50_1;
};
function addDefaultResponseValidation$lambda$slambda(resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(addDefaultResponseValidation$lambda$slambda).r50 = function (response, $completion) {
  var tmp = this.e4z(response, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(addDefaultResponseValidation$lambda$slambda).x8 = function (p1, $completion) {
  return this.r50(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
};
protoOf(addDefaultResponseValidation$lambda$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 5;
          var expectSuccess = this.n50_1.s4r().m4r().l2v(get_ExpectSuccessAttributeKey());
          if (!expectSuccess) {
            get_LOGGER_0().y31('Skipping default response validation for ' + this.n50_1.s4r().l4r().b3p().toString());
            return Unit_instance;
          }

          this.p50_1 = this.n50_1.r3w().m3c_1;
          var originCall = this.n50_1.s4r();
          if (this.p50_1 < 300 || originCall.m4r().n2v(get_ValidateMark())) {
            return Unit_instance;
          }

          this.d8_1 = 1;
          suspendResult = save(originCall, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var this_0 = suspendResult;
          this_0.m4r().o2v(get_ValidateMark(), Unit_instance);
          var exceptionCall = this_0;
          this.o50_1 = exceptionCall.m47();
          this.e8_1 = 3;
          this.d8_1 = 2;
          suspendResult = bodyAsText(this.o50_1, VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.q50_1 = suspendResult;
          this.e8_1 = 5;
          this.d8_1 = 4;
          continue $sm;
        case 3:
          this.e8_1 = 5;
          var tmp_0 = this.g8_1;
          if (tmp_0 instanceof MalformedInputException) {
            var _unused_var__etf5q3 = this.g8_1;
            var tmp_1 = this;
            tmp_1.q50_1 = '<body failed decoding>';
            this.d8_1 = 4;
            continue $sm;
          } else {
            throw this.g8_1;
          }

        case 4:
          this.e8_1 = 5;
          var exceptionResponseText = this.q50_1;
          var tmp0_subject = this.p50_1;
          var exception = (300 <= tmp0_subject ? tmp0_subject <= 399 : false) ? new RedirectResponseException(this.o50_1, exceptionResponseText) : (400 <= tmp0_subject ? tmp0_subject <= 499 : false) ? new ClientRequestException(this.o50_1, exceptionResponseText) : (500 <= tmp0_subject ? tmp0_subject <= 599 : false) ? new ServerResponseException(this.o50_1, exceptionResponseText) : new ResponseException(this.o50_1, exceptionResponseText);
          get_LOGGER_0().y31('Default response validation for ' + this.n50_1.s4r().l4r().b3p().toString() + ' failed with ' + exception.toString());
          throw exception;
        case 5:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 5) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(addDefaultResponseValidation$lambda$slambda).e4z = function (response, completion) {
  var i = new addDefaultResponseValidation$lambda$slambda(completion);
  i.n50_1 = response;
  return i;
};
function addDefaultResponseValidation$lambda$slambda_0(resultContinuation) {
  var i = new addDefaultResponseValidation$lambda$slambda(resultContinuation);
  var l = function (response, $completion) {
    return i.r50(response, $completion);
  };
  l.$arity = 1;
  return l;
}
function addDefaultResponseValidation$lambda($this_addDefaultResponseValidation) {
  return function ($this$HttpResponseValidator) {
    $this$HttpResponseValidator.u50_1 = $this_addDefaultResponseValidation.w4q_1;
    $this$HttpResponseValidator.v50(addDefaultResponseValidation$lambda$slambda_0(null));
    return Unit_instance;
  };
}
var properties_initialized_DefaultResponseValidation_kt_akvzqt;
function _init_properties_DefaultResponseValidation_kt__wcn8vr() {
  if (!properties_initialized_DefaultResponseValidation_kt_akvzqt) {
    properties_initialized_DefaultResponseValidation_kt_akvzqt = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ValidateMark';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(Unit);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(Unit), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$0 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$0);
    ValidateMark = new AttributeKey(name, tmp$ret$1);
    LOGGER_0 = KtorSimpleLogger('io.ktor.client.plugins.DefaultResponseValidation');
  }
}
function get_LOGGER_1() {
  _init_properties_DefaultTransform_kt__20knxx();
  return LOGGER_1;
}
var LOGGER_1;
function defaultTransformers(_this__u8e3s4) {
  _init_properties_DefaultTransform_kt__20knxx();
  var tmp = Phases_getInstance().i4x_1;
  _this__u8e3s4.e4o_1.e31(tmp, defaultTransformers$slambda_0(null));
  var tmp_0 = Phases_getInstance_2().c4r_1;
  _this__u8e3s4.f4o_1.e31(tmp_0, defaultTransformers$slambda_2(_this__u8e3s4, null));
  platformResponseDefaultTransformers(_this__u8e3s4);
}
function defaultTransformers$2$content$1($contentType, $body) {
  this.z50_1 = $body;
  ByteArrayContent.call(this);
  var tmp = this;
  tmp.x50_1 = $contentType == null ? Application_getInstance().p32_1 : $contentType;
  this.y50_1 = fromInt($body.length);
}
protoOf(defaultTransformers$2$content$1).g3f = function () {
  return this.x50_1;
};
protoOf(defaultTransformers$2$content$1).h3f = function () {
  return this.y50_1;
};
protoOf(defaultTransformers$2$content$1).i3f = function () {
  return this.z50_1;
};
function defaultTransformers$2$content$2($this_intercept, $contentType, $body) {
  this.d51_1 = $body;
  ReadChannelContent.call(this);
  var tmp = this;
  var tmp0_safe_receiver = $this_intercept.a31_1.f4q_1.g1c(HttpHeaders_getInstance().a36_1);
  tmp.b51_1 = tmp0_safe_receiver == null ? null : toLong(tmp0_safe_receiver);
  var tmp_0 = this;
  tmp_0.c51_1 = $contentType == null ? Application_getInstance().p32_1 : $contentType;
}
protoOf(defaultTransformers$2$content$2).h3f = function () {
  return this.b51_1;
};
protoOf(defaultTransformers$2$content$2).g3f = function () {
  return this.c51_1;
};
protoOf(defaultTransformers$2$content$2).l3f = function () {
  return this.d51_1;
};
function defaultTransformers$slambda(resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(defaultTransformers$slambda).x4o = function ($this$intercept, body, $completion) {
  var tmp = this.y4o($this$intercept, body, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(defaultTransformers$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(defaultTransformers$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          if (this.m51_1.a31_1.f4q_1.g1c(HttpHeaders_getInstance().l35_1) == null) {
            this.m51_1.a31_1.f4q_1.i2x(HttpHeaders_getInstance().l35_1, '*/*');
          }

          var contentType_0 = contentType(this.m51_1.a31_1);
          var tmp0_subject = this.n51_1;
          var tmp_0;
          if (typeof tmp0_subject === 'string') {
            tmp_0 = new TextContent(this.n51_1, contentType_0 == null ? Text_getInstance().s33_1 : contentType_0);
          } else {
            if (isByteArray(tmp0_subject)) {
              tmp_0 = new defaultTransformers$2$content$1(contentType_0, this.n51_1);
            } else {
              if (isInterface(tmp0_subject, ByteReadChannel)) {
                tmp_0 = new defaultTransformers$2$content$2(this.m51_1, contentType_0, this.n51_1);
              } else {
                if (tmp0_subject instanceof OutgoingContent) {
                  tmp_0 = this.n51_1;
                } else {
                  tmp_0 = platformRequestDefaultTransform(contentType_0, this.m51_1.a31_1, this.n51_1);
                }
              }
            }
          }

          var content = tmp_0;
          if (!((content == null ? null : content.g3f()) == null)) {
            this.m51_1.a31_1.f4q_1.m2x(HttpHeaders_getInstance().d36_1);
            get_LOGGER_1().y31('Transformed with default transformers request body for ' + this.m51_1.a31_1.d4q_1.toString() + ' from ' + toString(getKClassFromExpression(this.n51_1)));
            this.d8_1 = 1;
            suspendResult = this.m51_1.e30(content, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.d8_1 = 2;
            continue $sm;
          }

        case 1:
          this.d8_1 = 2;
          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(defaultTransformers$slambda).y4o = function ($this$intercept, body, completion) {
  var i = new defaultTransformers$slambda(completion);
  i.m51_1 = $this$intercept;
  i.n51_1 = body;
  return i;
};
function defaultTransformers$slambda_0(resultContinuation) {
  var i = new defaultTransformers$slambda(resultContinuation);
  var l = function ($this$intercept, body, $completion) {
    return i.x4o($this$intercept, body, $completion);
  };
  l.$arity = 2;
  return l;
}
function defaultTransformers$slambda$slambda($body, $response, resultContinuation) {
  this.w51_1 = $body;
  this.x51_1 = $response;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(defaultTransformers$slambda$slambda).n4m = function ($this$writer, $completion) {
  var tmp = this.o4m($this$writer, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(defaultTransformers$slambda$slambda).x8 = function (p1, $completion) {
  return this.n4m(p1 instanceof WriterScope ? p1 : THROW_CCE(), $completion);
};
protoOf(defaultTransformers$slambda$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = copyTo(this.w51_1, this.y51_1.p2s_1, 9223372036854775807n, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.z51_1 = suspendResult;
          this.e8_1 = 3;
          this.d8_1 = 4;
          continue $sm;
        case 2:
          this.e8_1 = 3;
          var tmp_0 = this.g8_1;
          if (tmp_0 instanceof CancellationException) {
            var cause = this.g8_1;
            var tmp_1 = this;
            cancel(this.x51_1, cause);
            throw cause;
          } else {
            var tmp_2 = this.g8_1;
            if (tmp_2 instanceof Error) {
              var cause_0 = this.g8_1;
              var tmp_3 = this;
              cancel_0(this.x51_1, 'Receive failed', cause_0);
              throw cause_0;
            } else {
              throw this.g8_1;
            }
          }

        case 3:
          throw this.g8_1;
        case 4:
          this.e8_1 = 3;
          return Unit_instance;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(defaultTransformers$slambda$slambda).o4m = function ($this$writer, completion) {
  var i = new defaultTransformers$slambda$slambda(this.w51_1, this.x51_1, completion);
  i.y51_1 = $this$writer;
  return i;
};
function defaultTransformers$slambda$slambda_0($body, $response, resultContinuation) {
  var i = new defaultTransformers$slambda$slambda($body, $response, resultContinuation);
  var l = function ($this$writer, $completion) {
    return i.n4m($this$writer, $completion);
  };
  l.$arity = 1;
  return l;
}
function defaultTransformers$slambda$lambda($responseJobHolder) {
  return function (it) {
    $responseJobHolder.b24();
    return Unit_instance;
  };
}
function defaultTransformers$slambda_1($this_defaultTransformers, resultContinuation) {
  this.i52_1 = $this_defaultTransformers;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(defaultTransformers$slambda_1).r4p = function ($this$intercept, _destruct__k2r9zo, $completion) {
  var tmp = this.s4p($this$intercept, _destruct__k2r9zo, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(defaultTransformers$slambda_1).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.r4p(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
};
protoOf(defaultTransformers$slambda_1).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 12;
          this.l52_1 = this.k52_1.wf();
          var body = this.k52_1.xf();
          if (!isInterface(body, ByteReadChannel))
            return Unit_instance;
          var response = this.j52_1.a31_1.m47();
          var tmp0_subject = this.l52_1.r31_1;
          if (tmp0_subject.equals(getKClass(Unit))) {
            cancel_3(body);
            this.d8_1 = 10;
            suspendResult = this.j52_1.e30(new HttpResponseContainer(this.l52_1, Unit_instance), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            if (tmp0_subject.equals(PrimitiveClasses_getInstance().gb())) {
              this.d8_1 = 8;
              suspendResult = readRemaining(body, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject.equals(getKClass(Source)) || tmp0_subject.equals(getKClass(Source))) {
                this.d8_1 = 6;
                suspendResult = readRemaining(body, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (tmp0_subject.equals(PrimitiveClasses_getInstance().pb())) {
                  this.d8_1 = 4;
                  suspendResult = toByteArray(body, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (tmp0_subject.equals(getKClass(ByteReadChannel))) {
                    var responseJobHolder = Job(response.f1x().q8(Key_instance));
                    var this_0 = writer(this.j52_1, this.i52_1.d4o_1, VOID, defaultTransformers$slambda$slambda_0(body, response, null));
                    invokeOnCompletion(this_0, defaultTransformers$slambda$lambda(responseJobHolder));
                    var channel = this_0.n2s_1;
                    this.d8_1 = 3;
                    suspendResult = this.j52_1.e30(new HttpResponseContainer(this.l52_1, channel), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (tmp0_subject.equals(getKClass(HttpStatusCode))) {
                      cancel_3(body);
                      this.d8_1 = 2;
                      suspendResult = this.j52_1.e30(new HttpResponseContainer(this.l52_1, response.r3w()), this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      if (tmp0_subject.equals(getKClass(MultiPartData))) {
                        var tmp0 = this.j52_1.a31_1.m47().q39().g1c(HttpHeaders_getInstance().d36_1);
                        var tmp$ret$0;
                        l$ret$1: do {
                          if (tmp0 == null) {
                            var message = 'No content type provided for multipart';
                            throw IllegalStateException_init_$Create$(toString(message));
                          } else {
                            tmp$ret$0 = tmp0;
                            break l$ret$1;
                          }
                        }
                         while (false);
                        var rawContentType = tmp$ret$0;
                        var contentType = Companion_getInstance_0().in(rawContentType);
                        if (!contentType.g34(MultiPart_getInstance().m33_1)) {
                          var message_0 = 'Expected multipart/form-data, got ' + contentType.toString();
                          throw IllegalStateException_init_$Create$(toString(message_0));
                        }
                        var tmp1_safe_receiver = this.j52_1.a31_1.m47().q39().g1c(HttpHeaders_getInstance().a36_1);
                        var contentLength_0 = tmp1_safe_receiver == null ? null : toLong(tmp1_safe_receiver);
                        var body_0 = new CIOMultipartDataBase(this.j52_1.f1x(), body, rawContentType, contentLength_0);
                        var parsedResponse = new HttpResponseContainer(this.l52_1, body_0);
                        this.d8_1 = 1;
                        suspendResult = this.j52_1.e30(parsedResponse, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      } else {
                        this.m52_1 = null;
                        this.d8_1 = 11;
                        continue $sm;
                      }
                    }
                  }
                }
              }
            }
          }

        case 1:
          this.m52_1 = suspendResult;
          this.d8_1 = 11;
          continue $sm;
        case 2:
          this.m52_1 = suspendResult;
          this.d8_1 = 11;
          continue $sm;
        case 3:
          this.m52_1 = suspendResult;
          this.d8_1 = 11;
          continue $sm;
        case 4:
          var bytes = suspendResult;
          checkContentLength(contentLength(this.j52_1.a31_1.m47()), fromInt(bytes.length), this.j52_1.a31_1.l4r().t4r());
          this.d8_1 = 5;
          suspendResult = this.j52_1.e30(new HttpResponseContainer(this.l52_1, bytes), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          this.m52_1 = suspendResult;
          this.d8_1 = 11;
          continue $sm;
        case 6:
          var ARGUMENT = suspendResult;
          var ARGUMENT_0 = new HttpResponseContainer(this.l52_1, ARGUMENT);
          this.d8_1 = 7;
          suspendResult = this.j52_1.e30(ARGUMENT_0, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 7:
          this.m52_1 = suspendResult;
          this.d8_1 = 11;
          continue $sm;
        case 8:
          var ARGUMENT_1 = suspendResult;
          var ARGUMENT_2 = readText(ARGUMENT_1);
          var ARGUMENT_3 = toInt(ARGUMENT_2);
          var ARGUMENT_4 = new HttpResponseContainer(this.l52_1, ARGUMENT_3);
          this.d8_1 = 9;
          suspendResult = this.j52_1.e30(ARGUMENT_4, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 9:
          this.m52_1 = suspendResult;
          this.d8_1 = 11;
          continue $sm;
        case 10:
          this.m52_1 = suspendResult;
          this.d8_1 = 11;
          continue $sm;
        case 11:
          var result = this.m52_1;
          if (!(result == null)) {
            get_LOGGER_1().y31('Transformed with default transformers response body ' + ('for ' + this.j52_1.a31_1.l4r().b3p().toString() + ' to ' + toString(this.l52_1.r31_1)));
          }

          return Unit_instance;
        case 12:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 12) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(defaultTransformers$slambda_1).s4p = function ($this$intercept, _destruct__k2r9zo, completion) {
  var i = new defaultTransformers$slambda_1(this.i52_1, completion);
  i.j52_1 = $this$intercept;
  i.k52_1 = _destruct__k2r9zo;
  return i;
};
function defaultTransformers$slambda_2($this_defaultTransformers, resultContinuation) {
  var i = new defaultTransformers$slambda_1($this_defaultTransformers, resultContinuation);
  var l = function ($this$intercept, _destruct__k2r9zo, $completion) {
    return i.r4p($this$intercept, _destruct__k2r9zo, $completion);
  };
  l.$arity = 2;
  return l;
}
var properties_initialized_DefaultTransform_kt_ossax9;
function _init_properties_DefaultTransform_kt__20knxx() {
  if (!properties_initialized_DefaultTransform_kt_ossax9) {
    properties_initialized_DefaultTransform_kt_ossax9 = true;
    LOGGER_1 = KtorSimpleLogger('io.ktor.client.plugins.defaultTransformers');
  }
}
function get_LOGGER_2() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return LOGGER_2;
}
var LOGGER_2;
function get_HttpCallValidator() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return HttpCallValidator;
}
var HttpCallValidator;
function get_ExpectSuccessAttributeKey() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return ExpectSuccessAttributeKey;
}
var ExpectSuccessAttributeKey;
function HttpCallValidatorConfig() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.s50_1 = ArrayList_init_$Create$();
  var tmp_0 = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp_0.t50_1 = ArrayList_init_$Create$();
  this.u50_1 = true;
}
protoOf(HttpCallValidatorConfig).v50 = function (block) {
  // Inline function 'kotlin.collections.plusAssign' call
  this.s50_1.j(block);
};
function ExceptionHandlerWrapper() {
}
function RequestExceptionHandlerWrapper() {
}
function RequestError$install$slambda($handler, resultContinuation) {
  this.v52_1 = $handler;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(RequestError$install$slambda).x4o = function ($this$intercept, it, $completion) {
  var tmp = this.y4o($this$intercept, it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(RequestError$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(RequestError$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 5;
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.w52_1.f30(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.y52_1 = suspendResult;
          this.e8_1 = 5;
          this.d8_1 = 4;
          continue $sm;
        case 2:
          this.e8_1 = 5;
          var tmp_0 = this.g8_1;
          if (tmp_0 instanceof Error) {
            var cause = this.g8_1;
            this.d8_1 = 3;
            suspendResult = this.v52_1(HttpRequest(this.w52_1.a31_1), cause, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            throw this.g8_1;
          }

        case 3:
          var error = suspendResult;
          var tmp_1 = this;
          if (!(error == null))
            throw error;
          tmp_1.y52_1 = Unit_instance;
          this.d8_1 = 4;
          continue $sm;
        case 4:
          this.e8_1 = 5;
          return Unit_instance;
        case 5:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 5) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(RequestError$install$slambda).y4o = function ($this$intercept, it, completion) {
  var i = new RequestError$install$slambda(this.v52_1, completion);
  i.w52_1 = $this$intercept;
  i.x52_1 = it;
  return i;
};
function RequestError$install$slambda_0($handler, resultContinuation) {
  var i = new RequestError$install$slambda($handler, resultContinuation);
  var l = function ($this$intercept, it, $completion) {
    return i.x4o($this$intercept, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function RequestError() {
}
protoOf(RequestError).z52 = function (client, handler) {
  var tmp = Phases_getInstance().f4x_1;
  client.e4o_1.e31(tmp, RequestError$install$slambda_0(handler, null));
};
protoOf(RequestError).k4x = function (client, handler) {
  return this.z52(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
};
var RequestError_instance;
function RequestError_getInstance() {
  return RequestError_instance;
}
function ReceiveError$install$slambda($handler, resultContinuation) {
  this.i53_1 = $handler;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(ReceiveError$install$slambda).r4p = function ($this$intercept, it, $completion) {
  var tmp = this.s4p($this$intercept, it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(ReceiveError$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.r4p(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
};
protoOf(ReceiveError$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 5;
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.j53_1.f30(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.l53_1 = suspendResult;
          this.e8_1 = 5;
          this.d8_1 = 4;
          continue $sm;
        case 2:
          this.e8_1 = 5;
          var tmp_0 = this.g8_1;
          if (tmp_0 instanceof Error) {
            var cause = this.g8_1;
            this.d8_1 = 3;
            suspendResult = this.i53_1(this.j53_1.a31_1.l4r(), cause, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            throw this.g8_1;
          }

        case 3:
          var error = suspendResult;
          var tmp_1 = this;
          if (!(error == null))
            throw error;
          tmp_1.l53_1 = Unit_instance;
          this.d8_1 = 4;
          continue $sm;
        case 4:
          this.e8_1 = 5;
          return Unit_instance;
        case 5:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 5) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(ReceiveError$install$slambda).s4p = function ($this$intercept, it, completion) {
  var i = new ReceiveError$install$slambda(this.i53_1, completion);
  i.j53_1 = $this$intercept;
  i.k53_1 = it;
  return i;
};
function ReceiveError$install$slambda_0($handler, resultContinuation) {
  var i = new ReceiveError$install$slambda($handler, resultContinuation);
  var l = function ($this$intercept, it, $completion) {
    return i.r4p($this$intercept, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function ReceiveError() {
}
protoOf(ReceiveError).z52 = function (client, handler) {
  var BeforeReceive = new PipelinePhase('BeforeReceive');
  client.f4o_1.d31(Phases_getInstance_2().b4r_1, BeforeReceive);
  client.f4o_1.e31(BeforeReceive, ReceiveError$install$slambda_0(handler, null));
};
protoOf(ReceiveError).k4x = function (client, handler) {
  return this.z52(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
};
var ReceiveError_instance;
function ReceiveError_getInstance() {
  return ReceiveError_instance;
}
function HttpRequest(builder) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return new HttpRequest$1(builder);
}
function HttpResponseValidator(_this__u8e3s4, block) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  _this__u8e3s4.k4r(get_HttpCallValidator(), block);
}
function HttpCallValidatorConfig$_init_$ref_m1o2g9() {
  var l = function () {
    return new HttpCallValidatorConfig();
  };
  l.callableName = '<init>';
  return l;
}
function HttpCallValidator$lambda($this$createClientPlugin) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  var responseValidators = reversed($this$createClientPlugin.e4y_1.s50_1);
  var callExceptionHandlers = reversed($this$createClientPlugin.e4y_1.t50_1);
  var expectSuccess = $this$createClientPlugin.e4y_1.u50_1;
  var tmp = SetupRequest_instance;
  $this$createClientPlugin.h4y(tmp, HttpCallValidator$lambda$slambda_0(expectSuccess, null));
  var tmp_0 = Send_instance;
  $this$createClientPlugin.h4y(tmp_0, HttpCallValidator$lambda$slambda_2(responseValidators, null));
  var tmp_1 = RequestError_instance;
  $this$createClientPlugin.h4y(tmp_1, HttpCallValidator$lambda$slambda_4(callExceptionHandlers, null));
  var tmp_2 = ReceiveError_instance;
  $this$createClientPlugin.h4y(tmp_2, HttpCallValidator$lambda$slambda_6(callExceptionHandlers, null));
  return Unit_instance;
}
function invoke$validateResponse(responseValidators, response, $completion) {
  var tmp = new $invoke$validateResponseCOROUTINE$(responseValidators, response, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function invoke$processException(callExceptionHandlers, cause, request, $completion) {
  var tmp = new $invoke$processExceptionCOROUTINE$(callExceptionHandlers, cause, request, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function HttpCallValidator$lambda$slambda$lambda($expectSuccess) {
  return function () {
    return $expectSuccess;
  };
}
function HttpCallValidator$lambda$slambda($expectSuccess, resultContinuation) {
  this.r54_1 = $expectSuccess;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpCallValidator$lambda$slambda).t54 = function (request, $completion) {
  var tmp = this.u54(request, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpCallValidator$lambda$slambda).x8 = function (p1, $completion) {
  return this.t54(p1 instanceof HttpRequestBuilder ? p1 : THROW_CCE(), $completion);
};
protoOf(HttpCallValidator$lambda$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      if (tmp === 0) {
        this.e8_1 = 1;
        var tmp_0 = get_ExpectSuccessAttributeKey();
        this.s54_1.i4q_1.q2v(tmp_0, HttpCallValidator$lambda$slambda$lambda(this.r54_1));
        return Unit_instance;
      } else if (tmp === 1) {
        throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
   while (true);
};
protoOf(HttpCallValidator$lambda$slambda).u54 = function (request, completion) {
  var i = new HttpCallValidator$lambda$slambda(this.r54_1, completion);
  i.s54_1 = request;
  return i;
};
function HttpCallValidator$lambda$slambda_0($expectSuccess, resultContinuation) {
  var i = new HttpCallValidator$lambda$slambda($expectSuccess, resultContinuation);
  var l = function (request, $completion) {
    return i.t54(request, $completion);
  };
  l.$arity = 1;
  return l;
}
function HttpCallValidator$lambda$slambda_1($responseValidators, resultContinuation) {
  this.d55_1 = $responseValidators;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpCallValidator$lambda$slambda_1).h55 = function ($this$on, request, $completion) {
  var tmp = this.i55($this$on, request, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpCallValidator$lambda$slambda_1).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof Sender_0 ? p1 : THROW_CCE();
  return this.h55(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpCallValidator$lambda$slambda_1).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          this.d8_1 = 1;
          suspendResult = this.e55_1.l55(this.f55_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.g55_1 = suspendResult;
          this.d8_1 = 2;
          suspendResult = invoke$validateResponse(this.d55_1, this.g55_1.m47(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return this.g55_1;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpCallValidator$lambda$slambda_1).i55 = function ($this$on, request, completion) {
  var i = new HttpCallValidator$lambda$slambda_1(this.d55_1, completion);
  i.e55_1 = $this$on;
  i.f55_1 = request;
  return i;
};
function HttpCallValidator$lambda$slambda_2($responseValidators, resultContinuation) {
  var i = new HttpCallValidator$lambda$slambda_1($responseValidators, resultContinuation);
  var l = function ($this$on, request, $completion) {
    return i.h55($this$on, request, $completion);
  };
  l.$arity = 2;
  return l;
}
function HttpCallValidator$lambda$slambda_3($callExceptionHandlers, resultContinuation) {
  this.u55_1 = $callExceptionHandlers;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpCallValidator$lambda$slambda_3).y55 = function (request, cause, $completion) {
  var tmp = this.z55(request, cause, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpCallValidator$lambda$slambda_3).y8 = function (p1, p2, $completion) {
  var tmp = (!(p1 == null) ? isInterface(p1, HttpRequest_0) : false) ? p1 : THROW_CCE();
  return this.y55(tmp, p2 instanceof Error ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpCallValidator$lambda$slambda_3).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.x55_1 = unwrapCancellationException(this.w55_1);
          this.d8_1 = 1;
          suspendResult = invoke$processException(this.u55_1, this.x55_1, this.v55_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return this.x55_1;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpCallValidator$lambda$slambda_3).z55 = function (request, cause, completion) {
  var i = new HttpCallValidator$lambda$slambda_3(this.u55_1, completion);
  i.v55_1 = request;
  i.w55_1 = cause;
  return i;
};
function HttpCallValidator$lambda$slambda_4($callExceptionHandlers, resultContinuation) {
  var i = new HttpCallValidator$lambda$slambda_3($callExceptionHandlers, resultContinuation);
  var l = function (request, cause, $completion) {
    return i.y55(request, cause, $completion);
  };
  l.$arity = 2;
  return l;
}
function HttpCallValidator$lambda$slambda_5($callExceptionHandlers, resultContinuation) {
  this.i56_1 = $callExceptionHandlers;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpCallValidator$lambda$slambda_5).y55 = function (request, cause, $completion) {
  var tmp = this.z55(request, cause, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpCallValidator$lambda$slambda_5).y8 = function (p1, p2, $completion) {
  var tmp = (!(p1 == null) ? isInterface(p1, HttpRequest_0) : false) ? p1 : THROW_CCE();
  return this.y55(tmp, p2 instanceof Error ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpCallValidator$lambda$slambda_5).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.l56_1 = unwrapCancellationException(this.k56_1);
          this.d8_1 = 1;
          suspendResult = invoke$processException(this.i56_1, this.l56_1, this.j56_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return this.l56_1;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpCallValidator$lambda$slambda_5).z55 = function (request, cause, completion) {
  var i = new HttpCallValidator$lambda$slambda_5(this.i56_1, completion);
  i.j56_1 = request;
  i.k56_1 = cause;
  return i;
};
function HttpCallValidator$lambda$slambda_6($callExceptionHandlers, resultContinuation) {
  var i = new HttpCallValidator$lambda$slambda_5($callExceptionHandlers, resultContinuation);
  var l = function (request, cause, $completion) {
    return i.y55(request, cause, $completion);
  };
  l.$arity = 2;
  return l;
}
function $invoke$validateResponseCOROUTINE$(responseValidators, response, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.u53_1 = responseValidators;
  this.v53_1 = response;
}
protoOf($invoke$validateResponseCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          get_LOGGER_2().y31('Validating response for request ' + this.v53_1.s4r().l4r().b3p().toString());
          this.w53_1 = this.u53_1.l();
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!this.w53_1.m()) {
            this.d8_1 = 3;
            continue $sm;
          }

          var element = this.w53_1.n();
          this.d8_1 = 2;
          suspendResult = element(this.v53_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.d8_1 = 1;
          continue $sm;
        case 3:
          return Unit_instance;
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $invoke$processExceptionCOROUTINE$(callExceptionHandlers, cause, request, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.f54_1 = callExceptionHandlers;
  this.g54_1 = cause;
  this.h54_1 = request;
}
protoOf($invoke$processExceptionCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 6;
          get_LOGGER_2().y31('Processing exception ' + this.g54_1.toString() + ' for request ' + this.h54_1.b3p().toString());
          this.i54_1 = this.f54_1.l();
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!this.i54_1.m()) {
            this.d8_1 = 5;
            continue $sm;
          }

          var element = this.i54_1.n();
          if (element instanceof ExceptionHandlerWrapper) {
            this.d8_1 = 3;
            suspendResult = element.n56_1(this.g54_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            if (element instanceof RequestExceptionHandlerWrapper) {
              this.d8_1 = 2;
              suspendResult = element.m56_1(this.g54_1, this.h54_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              noWhenBranchMatchedException();
            }
          }

          break;
        case 2:
          this.d8_1 = 4;
          continue $sm;
        case 3:
          this.d8_1 = 4;
          continue $sm;
        case 4:
          this.d8_1 = 1;
          continue $sm;
        case 5:
          return Unit_instance;
        case 6:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 6) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function HttpRequest$1($builder) {
  this.s56_1 = $builder;
  this.o56_1 = $builder.e4q_1;
  this.p56_1 = $builder.d4q_1.z1m();
  this.q56_1 = $builder.i4q_1;
  this.r56_1 = $builder.f4q_1.z1m();
}
protoOf(HttpRequest$1).s4r = function () {
  var message = 'Call is not initialized';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(HttpRequest$1).t4r = function () {
  return this.o56_1;
};
protoOf(HttpRequest$1).b3p = function () {
  return this.p56_1;
};
protoOf(HttpRequest$1).m4r = function () {
  return this.q56_1;
};
protoOf(HttpRequest$1).q39 = function () {
  return this.r56_1;
};
var properties_initialized_HttpCallValidator_kt_xrx49w;
function _init_properties_HttpCallValidator_kt__r6yh2y() {
  if (!properties_initialized_HttpCallValidator_kt_xrx49w) {
    properties_initialized_HttpCallValidator_kt_xrx49w = true;
    LOGGER_2 = KtorSimpleLogger('io.ktor.client.plugins.HttpCallValidator');
    var tmp = HttpCallValidatorConfig$_init_$ref_m1o2g9();
    HttpCallValidator = createClientPlugin('HttpResponseValidator', tmp, HttpCallValidator$lambda);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ExpectSuccessAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = PrimitiveClasses_getInstance().db();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(PrimitiveClasses_getInstance().db(), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$0 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$0);
    ExpectSuccessAttributeKey = new AttributeKey(name, tmp$ret$1);
  }
}
function get_PLUGIN_INSTALLED_LIST() {
  _init_properties_HttpClientPlugin_kt__cypu1m();
  return PLUGIN_INSTALLED_LIST;
}
var PLUGIN_INSTALLED_LIST;
function plugin(_this__u8e3s4, plugin) {
  _init_properties_HttpClientPlugin_kt__cypu1m();
  var tmp0_elvis_lhs = pluginOrNull(_this__u8e3s4, plugin);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException_init_$Create$('Plugin ' + toString(plugin) + ' is not installed. Consider using `install(' + plugin.v().toString() + ')` in client config first.');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function pluginOrNull(_this__u8e3s4, plugin) {
  _init_properties_HttpClientPlugin_kt__cypu1m();
  var tmp0_safe_receiver = _this__u8e3s4.i4o_1.m2v(get_PLUGIN_INSTALLED_LIST());
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m2v(plugin.v());
}
var properties_initialized_HttpClientPlugin_kt_p98320;
function _init_properties_HttpClientPlugin_kt__cypu1m() {
  if (!properties_initialized_HttpClientPlugin_kt_p98320) {
    properties_initialized_HttpClientPlugin_kt_p98320 = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ApplicationPluginRegistry';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(Attributes);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(Attributes), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$0 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$0);
    PLUGIN_INSTALLED_LIST = new AttributeKey(name, tmp$ret$1);
  }
}
function get_LOGGER_3() {
  _init_properties_HttpPlainText_kt__iy89z1();
  return LOGGER_3;
}
var LOGGER_3;
function get_HttpPlainText() {
  _init_properties_HttpPlainText_kt__iy89z1();
  return HttpPlainText;
}
var HttpPlainText;
function HttpPlainTextConfig() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableSetOf' call
  tmp.t56_1 = LinkedHashSet_init_$Create$();
  var tmp_0 = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp_0.u56_1 = LinkedHashMap_init_$Create$();
  this.v56_1 = null;
  this.w56_1 = Charsets_getInstance().g2u_1;
}
function RenderRequestHook$install$slambda($handler, resultContinuation) {
  this.f57_1 = $handler;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(RenderRequestHook$install$slambda).x4o = function ($this$intercept, content, $completion) {
  var tmp = this.y4o($this$intercept, content, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(RenderRequestHook$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(RenderRequestHook$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          this.d8_1 = 1;
          suspendResult = this.f57_1(this.g57_1.a31_1, this.h57_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          if (!(result == null)) {
            this.d8_1 = 2;
            suspendResult = this.g57_1.e30(result, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.d8_1 = 3;
            continue $sm;
          }

        case 2:
          this.d8_1 = 3;
          continue $sm;
        case 3:
          return Unit_instance;
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(RenderRequestHook$install$slambda).y4o = function ($this$intercept, content, completion) {
  var i = new RenderRequestHook$install$slambda(this.f57_1, completion);
  i.g57_1 = $this$intercept;
  i.h57_1 = content;
  return i;
};
function RenderRequestHook$install$slambda_0($handler, resultContinuation) {
  var i = new RenderRequestHook$install$slambda($handler, resultContinuation);
  var l = function ($this$intercept, content, $completion) {
    return i.x4o($this$intercept, content, $completion);
  };
  l.$arity = 2;
  return l;
}
function RenderRequestHook() {
}
protoOf(RenderRequestHook).i57 = function (client, handler) {
  var tmp = Phases_getInstance().i4x_1;
  client.e4o_1.e31(tmp, RenderRequestHook$install$slambda_0(handler, null));
};
protoOf(RenderRequestHook).k4x = function (client, handler) {
  return this.i57(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
};
var RenderRequestHook_instance;
function RenderRequestHook_getInstance() {
  return RenderRequestHook_instance;
}
function HttpPlainTextConfig$_init_$ref_isjudo() {
  var l = function () {
    return new HttpPlainTextConfig();
  };
  l.callableName = '<init>';
  return l;
}
function HttpPlainText$lambda($this$createClientPlugin) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.collections.sortedByDescending' call
  var this_0 = toList($this$createClientPlugin.e4y_1.u56_1);
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = HttpPlainText$lambda$lambda;
  var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
  var withQuality = sortedWith(this_0, tmp$ret$0);
  var responseCharsetFallback = $this$createClientPlugin.e4y_1.w56_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this$createClientPlugin.e4y_1.t56_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var _iterator__ex2g4s = tmp0.l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    if (!$this$createClientPlugin.e4y_1.u56_1.f2(element)) {
      destination.j(element);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = HttpPlainText$lambda$lambda_0;
  var tmp$ret$5 = new sam$kotlin_Comparator$0(tmp_0);
  var withoutQuality = sortedWith(destination, tmp$ret$5);
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_1 = StringBuilder_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = withoutQuality.l();
  while (_iterator__ex2g4s_0.m()) {
    var element_0 = _iterator__ex2g4s_0.n();
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(this_1) > 0) {
      this_1.k7(',');
    }
    this_1.k7(get_name(element_0));
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = withQuality.l();
  while (_iterator__ex2g4s_1.m()) {
    var element_1 = _iterator__ex2g4s_1.n();
    var charset = element_1.wf();
    var quality = element_1.xf();
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(this_1) > 0) {
      this_1.k7(',');
    }
    // Inline function 'kotlin.check' call
    if (!(0.0 <= quality ? quality <= 1.0 : false)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    // Inline function 'kotlin.math.roundToInt' call
    var this_2 = 100 * quality;
    var truncatedQuality = roundToInt(this_2) / 100.0;
    this_1.k7(get_name(charset) + ';q=' + truncatedQuality);
  }
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(this_1) === 0) {
    this_1.k7(get_name(responseCharsetFallback));
  }
  var acceptCharsetHeader = this_1.toString();
  var tmp0_elvis_lhs = $this$createClientPlugin.e4y_1.v56_1;
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? firstOrNull(withoutQuality) : tmp0_elvis_lhs;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = firstOrNull(withQuality);
    tmp_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.uf_1;
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var tmp3_elvis_lhs = tmp_1;
  var requestCharset = tmp3_elvis_lhs == null ? Charsets_getInstance().g2u_1 : tmp3_elvis_lhs;
  var tmp_2 = RenderRequestHook_instance;
  $this$createClientPlugin.h4y(tmp_2, HttpPlainText$lambda$slambda_0(acceptCharsetHeader, requestCharset, null));
  $this$createClientPlugin.j57(HttpPlainText$lambda$slambda_2(responseCharsetFallback, null));
  return Unit_instance;
}
function sam$kotlin_Comparator$0(function_0) {
  this.k57_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0).od = function (a, b) {
  return this.k57_1(a, b);
};
protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
  return this.od(a, b);
};
protoOf(sam$kotlin_Comparator$0).r2 = function () {
  return this.k57_1;
};
protoOf(sam$kotlin_Comparator$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.r2(), other.r2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0).hashCode = function () {
  return hashCode(this.r2());
};
function invoke$wrapContent(requestCharset, request, content, requestContentType) {
  var contentType = requestContentType == null ? Text_getInstance().s33_1 : requestContentType;
  var tmp2_elvis_lhs = requestContentType == null ? null : charset(requestContentType);
  var charset_0 = tmp2_elvis_lhs == null ? requestCharset : tmp2_elvis_lhs;
  get_LOGGER_3().y31('Sending request body to ' + request.d4q_1.toString() + ' as text/plain with charset ' + charset_0.toString());
  return new TextContent(content, withCharset(contentType, charset_0));
}
function invoke$read(responseCharsetFallback, call, body) {
  var tmp0_elvis_lhs = charset_0(call.m47());
  var actualCharset = tmp0_elvis_lhs == null ? responseCharsetFallback : tmp0_elvis_lhs;
  get_LOGGER_3().y31('Reading response body for ' + call.l4r().b3p().toString() + ' as String with charset ' + actualCharset.toString());
  return readText_0(body, actualCharset);
}
function invoke$addCharsetHeaders(acceptCharsetHeader, context) {
  if (!(context.f4q_1.g1c(HttpHeaders_getInstance().m35_1) == null))
    return Unit_instance;
  get_LOGGER_3().y31('Adding Accept-Charset=' + acceptCharsetHeader + ' to ' + context.d4q_1.toString());
  context.f4q_1.g2x(HttpHeaders_getInstance().m35_1, acceptCharsetHeader);
}
function HttpPlainText$lambda$lambda(a, b) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.vf_1;
  var tmp$ret$1 = a.vf_1;
  return compareValues(tmp, tmp$ret$1);
}
function HttpPlainText$lambda$lambda_0(a, b) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = get_name(a);
  var tmp$ret$1 = get_name(b);
  return compareValues(tmp, tmp$ret$1);
}
function HttpPlainText$lambda$slambda($acceptCharsetHeader, $requestCharset, resultContinuation) {
  this.t57_1 = $acceptCharsetHeader;
  this.u57_1 = $requestCharset;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpPlainText$lambda$slambda).x57 = function (request, content, $completion) {
  var tmp = this.y57(request, content, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpPlainText$lambda$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof HttpRequestBuilder ? p1 : THROW_CCE();
  return this.x57(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpPlainText$lambda$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      if (tmp === 0) {
        this.e8_1 = 1;
        invoke$addCharsetHeaders(this.t57_1, this.v57_1);
        var tmp_0 = this.w57_1;
        if (!(typeof tmp_0 === 'string'))
          return null;
        var contentType_0 = contentType(this.v57_1);
        if (!(contentType_0 == null) && !(contentType_0.c34_1 === Text_getInstance().s33_1.c34_1)) {
          return null;
        }
        return invoke$wrapContent(this.u57_1, this.v57_1, this.w57_1, contentType_0);
      } else if (tmp === 1) {
        throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
   while (true);
};
protoOf(HttpPlainText$lambda$slambda).y57 = function (request, content, completion) {
  var i = new HttpPlainText$lambda$slambda(this.t57_1, this.u57_1, completion);
  i.v57_1 = request;
  i.w57_1 = content;
  return i;
};
function HttpPlainText$lambda$slambda_0($acceptCharsetHeader, $requestCharset, resultContinuation) {
  var i = new HttpPlainText$lambda$slambda($acceptCharsetHeader, $requestCharset, resultContinuation);
  var l = function (request, content, $completion) {
    return i.x57(request, content, $completion);
  };
  l.$arity = 2;
  return l;
}
function HttpPlainText$lambda$slambda_1($responseCharsetFallback, resultContinuation) {
  this.h58_1 = $responseCharsetFallback;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpPlainText$lambda$slambda_1).m58 = function ($this$transformResponseBody, response, content, requestedType, $completion) {
  var tmp = this.n58($this$transformResponseBody, response, content, requestedType, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpPlainText$lambda$slambda_1).o58 = function (p1, p2, p3, p4, $completion) {
  var tmp = p1 instanceof TransformResponseBodyContext ? p1 : THROW_CCE();
  var tmp_0 = p2 instanceof HttpResponse ? p2 : THROW_CCE();
  var tmp_1 = (!(p3 == null) ? isInterface(p3, ByteReadChannel) : false) ? p3 : THROW_CCE();
  return this.m58(tmp, tmp_0, tmp_1, p4 instanceof TypeInfo ? p4 : THROW_CCE(), $completion);
};
protoOf(HttpPlainText$lambda$slambda_1).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          if (!this.l58_1.r31_1.equals(PrimitiveClasses_getInstance().lb()))
            return null;
          this.d8_1 = 1;
          suspendResult = readRemaining(this.k58_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var bodyBytes = suspendResult;
          return invoke$read(this.h58_1, this.j58_1.s4r(), bodyBytes);
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpPlainText$lambda$slambda_1).n58 = function ($this$transformResponseBody, response, content, requestedType, completion) {
  var i = new HttpPlainText$lambda$slambda_1(this.h58_1, completion);
  i.i58_1 = $this$transformResponseBody;
  i.j58_1 = response;
  i.k58_1 = content;
  i.l58_1 = requestedType;
  return i;
};
function HttpPlainText$lambda$slambda_2($responseCharsetFallback, resultContinuation) {
  var i = new HttpPlainText$lambda$slambda_1($responseCharsetFallback, resultContinuation);
  var l = function ($this$transformResponseBody, response, content, requestedType, $completion) {
    return i.m58($this$transformResponseBody, response, content, requestedType, $completion);
  };
  l.$arity = 4;
  return l;
}
var properties_initialized_HttpPlainText_kt_2nx4ox;
function _init_properties_HttpPlainText_kt__iy89z1() {
  if (!properties_initialized_HttpPlainText_kt_2nx4ox) {
    properties_initialized_HttpPlainText_kt_2nx4ox = true;
    LOGGER_3 = KtorSimpleLogger('io.ktor.client.plugins.HttpPlainText');
    var tmp = HttpPlainTextConfig$_init_$ref_isjudo();
    HttpPlainText = createClientPlugin('HttpPlainText', tmp, HttpPlainText$lambda);
  }
}
function get_ALLOWED_FOR_REDIRECT() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return ALLOWED_FOR_REDIRECT;
}
var ALLOWED_FOR_REDIRECT;
function get_LOGGER_4() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return LOGGER_4;
}
var LOGGER_4;
function get_HttpResponseRedirectEvent() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpResponseRedirectEvent;
}
var HttpResponseRedirectEvent;
function get_HttpRedirect() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpRedirect;
}
var HttpRedirect;
function HttpRedirectConfig() {
  this.p58_1 = true;
  this.q58_1 = false;
}
function isRedirect(_this__u8e3s4) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var tmp0_subject = _this__u8e3s4.m3c_1;
  return tmp0_subject === Companion_getInstance_1().v3a_1.m3c_1 || tmp0_subject === Companion_getInstance_1().w3a_1.m3c_1 || (tmp0_subject === Companion_getInstance_1().b3b_1.m3c_1 || (tmp0_subject === Companion_getInstance_1().c3b_1.m3c_1 || tmp0_subject === Companion_getInstance_1().x3a_1.m3c_1)) ? true : false;
}
function HttpRedirectConfig$_init_$ref_rhym9t() {
  var l = function () {
    return new HttpRedirectConfig();
  };
  l.callableName = '<init>';
  return l;
}
function HttpRedirect$lambda($this$createClientPlugin) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var checkHttpMethod = $this$createClientPlugin.e4y_1.p58_1;
  var allowHttpsDowngrade = $this$createClientPlugin.e4y_1.q58_1;
  var tmp = Send_instance;
  $this$createClientPlugin.h4y(tmp, HttpRedirect$lambda$slambda_0(checkHttpMethod, allowHttpsDowngrade, $this$createClientPlugin, null));
  return Unit_instance;
}
function invoke$handleCall(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion) {
  var tmp = new $invoke$handleCallCOROUTINE$(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function HttpRedirect$lambda$slambda($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin, resultContinuation) {
  this.o59_1 = $checkHttpMethod;
  this.p59_1 = $allowHttpsDowngrade;
  this.q59_1 = $this_createClientPlugin;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpRedirect$lambda$slambda).h55 = function ($this$on, request, $completion) {
  var tmp = this.i55($this$on, request, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpRedirect$lambda$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof Sender_0 ? p1 : THROW_CCE();
  return this.h55(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpRedirect$lambda$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          this.d8_1 = 1;
          suspendResult = this.r59_1.l55(this.s59_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var origin = suspendResult;
          if (this.o59_1 && !get_ALLOWED_FOR_REDIRECT().q1(origin.l4r().t4r())) {
            return origin;
          }

          this.d8_1 = 2;
          suspendResult = invoke$handleCall(this.r59_1, this.s59_1, origin, this.p59_1, this.q59_1.d4y_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpRedirect$lambda$slambda).i55 = function ($this$on, request, completion) {
  var i = new HttpRedirect$lambda$slambda(this.o59_1, this.p59_1, this.q59_1, completion);
  i.r59_1 = $this$on;
  i.s59_1 = request;
  return i;
};
function HttpRedirect$lambda$slambda_0($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin, resultContinuation) {
  var i = new HttpRedirect$lambda$slambda($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin, resultContinuation);
  var l = function ($this$on, request, $completion) {
    return i.h55($this$on, request, $completion);
  };
  l.$arity = 2;
  return l;
}
function $invoke$handleCallCOROUTINE$(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.z58_1 = _this__u8e3s4;
  this.a59_1 = context;
  this.b59_1 = origin;
  this.c59_1 = allowHttpsDowngrade;
  this.d59_1 = client;
}
protoOf($invoke$handleCallCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          this.e59_1 = this.b59_1;
          this.f59_1 = this.a59_1;
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!true) {
            this.d8_1 = 4;
            continue $sm;
          }

          var previousProtocol = this.e59_1.l4r().b3p().s3d_1;
          var previousAuthority = get_authority(this.e59_1.l4r().b3p());
          if (!isRedirect(this.e59_1.m47().r3w()))
            return this.e59_1;
          var location = this.e59_1.m47().q39().g1c(HttpHeaders_getInstance().z36_1);
          if (location == null) {
            get_LOGGER_4().w31('Location header missing from redirect response ' + this.e59_1.l4r().b3p().toString() + '; returning response as is');
            return this.e59_1;
          }

          this.d59_1.k4o_1.w4e(get_HttpResponseRedirectEvent(), this.e59_1.m47());
          get_LOGGER_4().y31('Received redirect response to ' + location + ' for request ' + this.e59_1.l4r().b3p().toString());
          var tmp_0 = this;
          var this_0 = new HttpRequestBuilder();
          this_0.t4v(this.f59_1);
          this_0.d4q_1.c3d_1.w1();
          takeFrom_0(this_0.d4q_1, location);
          if (!this.c59_1 && isSecure(previousProtocol) && !isSecure(this_0.d4q_1.f3d())) {
            get_LOGGER_4().y31('Blocked redirect from ' + this.e59_1.l4r().b3p().toString() + ' to ' + location + ' due to HTTPS downgrade');
            return this.e59_1;
          }

          if (!(previousAuthority === get_authority_0(this_0.d4q_1))) {
            this_0.f4q_1.m2x(HttpHeaders_getInstance().u35_1);
            get_LOGGER_4().y31('Removing Authorization header for cross-authority redirect: ' + (previousAuthority + ' -> ' + this_0.d4q_1.q3e()));
          }

          tmp_0.f59_1 = this_0;
          this.d8_1 = 2;
          suspendResult = this.z58_1.l55(this.f59_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.e59_1 = suspendResult;
          this.d8_1 = 1;
          continue $sm;
        case 3:
          throw this.g8_1;
        case 4:
          return Unit_instance;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
var properties_initialized_HttpRedirect_kt_klj746;
function _init_properties_HttpRedirect_kt__ure7fo() {
  if (!properties_initialized_HttpRedirect_kt_klj746) {
    properties_initialized_HttpRedirect_kt_klj746 = true;
    ALLOWED_FOR_REDIRECT = setOf_0([Companion_getInstance_2().r39_1, Companion_getInstance_2().w39_1]);
    LOGGER_4 = KtorSimpleLogger('io.ktor.client.plugins.HttpRedirect');
    HttpResponseRedirectEvent = new EventDefinition();
    var tmp = HttpRedirectConfig$_init_$ref_rhym9t();
    HttpRedirect = createClientPlugin('HttpRedirect', tmp, HttpRedirect$lambda);
  }
}
function get_LOGGER_5() {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  return LOGGER_5;
}
var LOGGER_5;
function get_HttpRequestLifecycle() {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  return HttpRequestLifecycle;
}
var HttpRequestLifecycle;
function $invokeCOROUTINE$(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.b5a_1 = _this__u8e3s4;
}
protoOf($invokeCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          var tmp0 = this.b5a_1.c5a_1;
          this.d8_1 = 1;
          suspendResult = tmp0.f30(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function PipelineContext$proceed$ref(p0) {
  this.c5a_1 = p0;
}
protoOf(PipelineContext$proceed$ref).t2s = function ($completion) {
  var tmp = new $invokeCOROUTINE$(this, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(PipelineContext$proceed$ref).u9 = function ($completion) {
  return this.t2s($completion);
};
function PipelineContext$proceed$ref_0(p0) {
  var i = new PipelineContext$proceed$ref(p0);
  var l = function ($completion) {
    return i.t2s($completion);
  };
  l.$arity = 0;
  return l;
}
function SetupRequestContext$install$slambda($handler, resultContinuation) {
  this.l5a_1 = $handler;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(SetupRequestContext$install$slambda).x4o = function ($this$intercept, it, $completion) {
  var tmp = this.y4o($this$intercept, it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(SetupRequestContext$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(SetupRequestContext$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.l5a_1(this.m5a_1.a31_1, PipelineContext$proceed$ref_0(this.m5a_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(SetupRequestContext$install$slambda).y4o = function ($this$intercept, it, completion) {
  var i = new SetupRequestContext$install$slambda(this.l5a_1, completion);
  i.m5a_1 = $this$intercept;
  i.n5a_1 = it;
  return i;
};
function SetupRequestContext$install$slambda_0($handler, resultContinuation) {
  var i = new SetupRequestContext$install$slambda($handler, resultContinuation);
  var l = function ($this$intercept, it, $completion) {
    return i.x4o($this$intercept, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function SetupRequestContext() {
}
protoOf(SetupRequestContext).o5a = function (client, handler) {
  var tmp = Phases_getInstance().f4x_1;
  client.e4o_1.e31(tmp, SetupRequestContext$install$slambda_0(handler, null));
};
protoOf(SetupRequestContext).k4x = function (client, handler) {
  return this.o5a(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
};
var SetupRequestContext_instance;
function SetupRequestContext_getInstance() {
  return SetupRequestContext_instance;
}
function attachToClientEngineJob(requestJob, clientEngineJob) {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  var handler = clientEngineJob.h1y(attachToClientEngineJob$lambda(requestJob));
  requestJob.h1y(attachToClientEngineJob$lambda_0(handler));
}
function HttpRequestLifecycle$lambda($this$createClientPlugin) {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  var tmp = SetupRequestContext_instance;
  $this$createClientPlugin.h4y(tmp, HttpRequestLifecycle$lambda$slambda_0($this$createClientPlugin, null));
  return Unit_instance;
}
function HttpRequestLifecycle$lambda$slambda($this_createClientPlugin, resultContinuation) {
  this.x5a_1 = $this_createClientPlugin;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpRequestLifecycle$lambda$slambda).b5b = function (request, proceed, $completion) {
  var tmp = this.c5b(request, proceed, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpRequestLifecycle$lambda$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof HttpRequestBuilder ? p1 : THROW_CCE();
  return this.b5b(tmp, (!(p2 == null) ? isSuspendFunction(p2, 0) : false) ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpRequestLifecycle$lambda$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 6;
          this.a5b_1 = SupervisorJob(this.y5a_1.h4q_1);
          attachToClientEngineJob(this.a5b_1, ensureNotNull(this.x5a_1.d4y_1.d4o_1.q8(Key_instance)));
          this.d8_1 = 1;
          continue $sm;
        case 1:
          this.e8_1 = 4;
          this.e8_1 = 3;
          this.y5a_1.h4q_1 = this.a5b_1;
          this.d8_1 = 2;
          suspendResult = this.z5a_1(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.e8_1 = 6;
          this.d8_1 = 5;
          continue $sm;
        case 3:
          this.e8_1 = 4;
          var tmp_0 = this.g8_1;
          if (tmp_0 instanceof Error) {
            var cause = this.g8_1;
            this.a5b_1.a24(cause);
            throw cause;
          } else {
            throw this.g8_1;
          }

        case 4:
          this.e8_1 = 6;
          var t = this.g8_1;
          this.a5b_1.b24();
          throw t;
        case 5:
          this.e8_1 = 6;
          this.a5b_1.b24();
          return Unit_instance;
        case 6:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 6) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpRequestLifecycle$lambda$slambda).c5b = function (request, proceed, completion) {
  var i = new HttpRequestLifecycle$lambda$slambda(this.x5a_1, completion);
  i.y5a_1 = request;
  i.z5a_1 = proceed;
  return i;
};
function HttpRequestLifecycle$lambda$slambda_0($this_createClientPlugin, resultContinuation) {
  var i = new HttpRequestLifecycle$lambda$slambda($this_createClientPlugin, resultContinuation);
  var l = function (request, proceed, $completion) {
    return i.b5b(request, proceed, $completion);
  };
  l.$arity = 2;
  return l;
}
function attachToClientEngineJob$lambda($requestJob) {
  return function (cause) {
    if (!(cause == null)) {
      get_LOGGER_5().y31('Cancelling request because engine Job failed with error: ' + cause.toString());
      cancel_1($requestJob, 'Engine failed', cause);
    } else {
      get_LOGGER_5().y31('Cancelling request because engine Job completed');
      $requestJob.b24();
    }
    return Unit_instance;
  };
}
function attachToClientEngineJob$lambda_0($handler) {
  return function (it) {
    $handler.t20();
    return Unit_instance;
  };
}
var properties_initialized_HttpRequestLifecycle_kt_3hmcrf;
function _init_properties_HttpRequestLifecycle_kt__jgkmfx() {
  if (!properties_initialized_HttpRequestLifecycle_kt_3hmcrf) {
    properties_initialized_HttpRequestLifecycle_kt_3hmcrf = true;
    LOGGER_5 = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestLifecycle');
    HttpRequestLifecycle = createClientPlugin_0('RequestLifecycle', HttpRequestLifecycle$lambda);
  }
}
function get_LOGGER_6() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return LOGGER_6;
}
var LOGGER_6;
function get_HttpRequestRetryEvent() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return HttpRequestRetryEvent;
}
var HttpRequestRetryEvent;
var HttpRequestRetry;
function get_MaxRetriesPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return MaxRetriesPerRequestAttributeKey;
}
var MaxRetriesPerRequestAttributeKey;
function get_ShouldRetryPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return ShouldRetryPerRequestAttributeKey;
}
var ShouldRetryPerRequestAttributeKey;
function get_ShouldRetryOnExceptionPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return ShouldRetryOnExceptionPerRequestAttributeKey;
}
var ShouldRetryOnExceptionPerRequestAttributeKey;
function get_ModifyRequestPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return ModifyRequestPerRequestAttributeKey;
}
var ModifyRequestPerRequestAttributeKey;
function get_RetryDelayPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return RetryDelayPerRequestAttributeKey;
}
var RetryDelayPerRequestAttributeKey;
function HttpRetryEventData(request, retryCount, response, cause) {
  this.d5b_1 = request;
  this.e5b_1 = retryCount;
  this.f5b_1 = response;
  this.g5b_1 = cause;
}
function randomMs($this, randomizationMs) {
  return randomizationMs === 0n ? 0n : Default_getInstance().ui(randomizationMs);
}
function HttpRequestRetryConfig$delay$slambda(resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpRequestRetryConfig$delay$slambda).q5b = function (it, $completion) {
  var tmp = this.r5b(it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpRequestRetryConfig$delay$slambda).x8 = function (p1, $completion) {
  return this.q5b((!(p1 == null) ? typeof p1 === 'bigint' : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(HttpRequestRetryConfig$delay$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = delay(this.p5b_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpRequestRetryConfig$delay$slambda).r5b = function (it, completion) {
  var i = new HttpRequestRetryConfig$delay$slambda(completion);
  i.p5b_1 = it;
  return i;
};
function HttpRequestRetryConfig$delay$slambda_0(resultContinuation) {
  var i = new HttpRequestRetryConfig$delay$slambda(resultContinuation);
  var l = function (it, $completion) {
    return i.q5b(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function HttpRequestRetryConfig$modifyRequest$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function HttpRequestRetryConfig$retryOnException$lambda($retryOnTimeout) {
  return function ($this$retryOnExceptionIf, _unused_var__etf5q3, cause) {
    var tmp;
    if (isTimeoutException(cause)) {
      tmp = $retryOnTimeout;
    } else {
      if (cause instanceof CancellationException) {
        tmp = false;
      } else {
        tmp = true;
      }
    }
    return tmp;
  };
}
function HttpRequestRetryConfig$retryOnServerErrors$lambda($this$retryIf, _unused_var__etf5q3, response) {
  // Inline function 'kotlin.let' call
  var it = response.r3w().m3c_1;
  return 500 <= it ? it <= 599 : false;
}
function HttpRequestRetryConfig$delayMillis$lambda($respectRetryAfterHeader, $block) {
  return function (_this__u8e3s4, it) {
    var tmp;
    if ($respectRetryAfterHeader) {
      var tmp0_safe_receiver = _this__u8e3s4.t5b_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q39();
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.g1c(HttpHeaders_getInstance().s37_1);
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : toLongOrNull(tmp2_safe_receiver);
      var tmp_0;
      if (tmp3_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.Long.times' call
        tmp_0 = multiply(tmp3_safe_receiver, fromInt(1000));
      }
      var retryAfter = tmp_0;
      var tmp0 = $block(_this__u8e3s4, it);
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = retryAfter == null ? 0n : retryAfter;
      tmp = tmp0 >= b ? tmp0 : b;
    } else {
      tmp = $block(_this__u8e3s4, it);
    }
    return tmp;
  };
}
function HttpRequestRetryConfig$exponentialDelay$lambda($base, $baseDelayMs, $maxDelayMs, this$0, $randomizationMs) {
  return function ($this$delayMillis, retry) {
    var tmp0 = $base;
    // Inline function 'kotlin.math.pow' call
    var n = retry - 1 | 0;
    var tmp$ret$0 = Math.pow(tmp0, n);
    var tmp0_0 = numberToLong(tmp$ret$0 * toNumber($baseDelayMs));
    // Inline function 'kotlin.comparisons.minOf' call
    var b = $maxDelayMs;
    var delay = tmp0_0 <= b ? tmp0_0 : b;
    return add(delay, randomMs(this$0, $randomizationMs));
  };
}
function HttpRequestRetryConfig() {
  var tmp = this;
  tmp.y5b_1 = HttpRequestRetryConfig$delay$slambda_0(null);
  var tmp_0 = this;
  tmp_0.z5b_1 = HttpRequestRetryConfig$modifyRequest$lambda;
  this.a5c_1 = 0;
  this.b5c(3);
  this.c5c();
}
protoOf(HttpRequestRetryConfig).d5c = function () {
  var tmp = this.v5b_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('shouldRetry');
  }
};
protoOf(HttpRequestRetryConfig).e5c = function () {
  var tmp = this.w5b_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('shouldRetryOnException');
  }
};
protoOf(HttpRequestRetryConfig).f5c = function () {
  var tmp = this.x5b_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('delayMillis');
  }
};
protoOf(HttpRequestRetryConfig).g5c = function (maxRetries, block) {
  if (!(maxRetries === -1))
    this.a5c_1 = maxRetries;
  this.v5b_1 = block;
};
protoOf(HttpRequestRetryConfig).h5c = function (maxRetries, block) {
  if (!(maxRetries === -1))
    this.a5c_1 = maxRetries;
  this.w5b_1 = block;
};
protoOf(HttpRequestRetryConfig).i5c = function (maxRetries, retryOnTimeout) {
  this.h5c(maxRetries, HttpRequestRetryConfig$retryOnException$lambda(retryOnTimeout));
};
protoOf(HttpRequestRetryConfig).j5c = function (maxRetries, retryOnTimeout, $super) {
  maxRetries = maxRetries === VOID ? -1 : maxRetries;
  retryOnTimeout = retryOnTimeout === VOID ? false : retryOnTimeout;
  var tmp;
  if ($super === VOID) {
    this.i5c(maxRetries, retryOnTimeout);
    tmp = Unit_instance;
  } else {
    tmp = $super.i5c.call(this, maxRetries, retryOnTimeout);
  }
  return tmp;
};
protoOf(HttpRequestRetryConfig).k5c = function (maxRetries) {
  this.g5c(maxRetries, HttpRequestRetryConfig$retryOnServerErrors$lambda);
};
protoOf(HttpRequestRetryConfig).b5c = function (maxRetries) {
  this.k5c(maxRetries);
  this.j5c(maxRetries);
};
protoOf(HttpRequestRetryConfig).l5c = function (respectRetryAfterHeader, block) {
  var tmp = this;
  tmp.x5b_1 = HttpRequestRetryConfig$delayMillis$lambda(respectRetryAfterHeader, block);
};
protoOf(HttpRequestRetryConfig).m5c = function (base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader) {
  // Inline function 'kotlin.check' call
  if (!(base > 0)) {
    throw IllegalStateException_init_$Create$('Check failed.');
  }
  // Inline function 'kotlin.check' call
  if (!(baseDelayMs > 0n)) {
    throw IllegalStateException_init_$Create$('Check failed.');
  }
  // Inline function 'kotlin.check' call
  if (!(maxDelayMs > 0n)) {
    throw IllegalStateException_init_$Create$('Check failed.');
  }
  // Inline function 'kotlin.check' call
  if (!(randomizationMs >= 0n)) {
    throw IllegalStateException_init_$Create$('Check failed.');
  }
  this.l5c(respectRetryAfterHeader, HttpRequestRetryConfig$exponentialDelay$lambda(base, baseDelayMs, maxDelayMs, this, randomizationMs));
};
protoOf(HttpRequestRetryConfig).c5c = function (base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader, $super) {
  base = base === VOID ? 2.0 : base;
  baseDelayMs = baseDelayMs === VOID ? 1000n : baseDelayMs;
  maxDelayMs = maxDelayMs === VOID ? 60000n : maxDelayMs;
  randomizationMs = randomizationMs === VOID ? 1000n : randomizationMs;
  respectRetryAfterHeader = respectRetryAfterHeader === VOID ? true : respectRetryAfterHeader;
  var tmp;
  if ($super === VOID) {
    this.m5c(base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader);
    tmp = Unit_instance;
  } else {
    tmp = $super.m5c.call(this, base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader);
  }
  return tmp;
};
function HttpRetryShouldRetryContext(retryCount) {
  this.n5c_1 = retryCount;
}
function HttpRetryDelayContext(request, response, cause) {
  this.s5b_1 = request;
  this.t5b_1 = response;
  this.u5b_1 = cause;
}
function HttpRetryModifyRequestContext(request, response, cause, retryCount) {
  this.o5c_1 = request;
  this.p5c_1 = response;
  this.q5c_1 = cause;
  this.r5c_1 = retryCount;
}
function throwOnInvalidResponseBody(_this__u8e3s4, $completion) {
  var tmp = new $throwOnInvalidResponseBodyCOROUTINE$(_this__u8e3s4, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function isTimeoutException(_this__u8e3s4) {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  var exception = unwrapCancellationException(_this__u8e3s4);
  var tmp;
  var tmp_0;
  if (exception instanceof HttpRequestTimeoutException) {
    tmp_0 = true;
  } else {
    tmp_0 = exception instanceof ConnectTimeoutException;
  }
  if (tmp_0) {
    tmp = true;
  } else {
    tmp = exception instanceof SocketTimeoutException;
  }
  return tmp;
}
function HttpRequestRetryConfig$_init_$ref_mqbboi() {
  var l = function () {
    return new HttpRequestRetryConfig();
  };
  l.callableName = '<init>';
  return l;
}
function HttpRequestRetry$lambda($this$createClientPlugin) {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  var shouldRetry = $this$createClientPlugin.e4y_1.d5c();
  var shouldRetryOnException = $this$createClientPlugin.e4y_1.e5c();
  var delayMillis = $this$createClientPlugin.e4y_1.f5c();
  var delay = $this$createClientPlugin.e4y_1.y5b_1;
  var maxRetries = $this$createClientPlugin.e4y_1.a5c_1;
  var modifyRequest = $this$createClientPlugin.e4y_1.z5b_1;
  $this$createClientPlugin.e5d(HttpRequestRetry$lambda$slambda_0(maxRetries, null));
  var tmp = Send_instance;
  $this$createClientPlugin.h4y(tmp, HttpRequestRetry$lambda$slambda_2(shouldRetry, shouldRetryOnException, maxRetries, delayMillis, modifyRequest, $this$createClientPlugin, delay, null));
  return Unit_instance;
}
function invoke$shouldRetry(retryCount, maxRetries, shouldRetry, call) {
  return retryCount < maxRetries && shouldRetry(new HttpRetryShouldRetryContext(retryCount + 1 | 0), call.l4r(), call.m47());
}
function invoke$shouldRetryOnException(retryCount, maxRetries, shouldRetry, subRequest, cause) {
  return retryCount < maxRetries && shouldRetry(new HttpRetryShouldRetryContext(retryCount + 1 | 0), subRequest, cause);
}
function invoke$prepareRequest(request) {
  var subRequest = (new HttpRequestBuilder()).f5d(request);
  var tmp = request.h4q_1;
  tmp.h1y(HttpRequestRetry$lambda$prepareRequest$lambda(subRequest));
  return subRequest;
}
function HttpRequestRetry$lambda$slambda($maxRetries, resultContinuation) {
  this.o5d_1 = $maxRetries;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpRequestRetry$lambda$slambda).s5d = function ($this$onRequest, request, _unused_var__etf5q3, $completion) {
  var tmp = this.t5d($this$onRequest, request, _unused_var__etf5q3, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpRequestRetry$lambda$slambda).u5d = function (p1, p2, p3, $completion) {
  var tmp = p1 instanceof OnRequestContext ? p1 : THROW_CCE();
  var tmp_0 = p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE();
  return this.s5d(tmp, tmp_0, !(p3 == null) ? p3 : THROW_CCE(), $completion);
};
protoOf(HttpRequestRetry$lambda$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      if (tmp === 0) {
        this.e8_1 = 1;
        var tmp0_elvis_lhs = this.q5d_1.i4q_1.m2v(get_MaxRetriesPerRequestAttributeKey());
        var maxRetriesValue = tmp0_elvis_lhs == null ? this.o5d_1 : tmp0_elvis_lhs;
        this.q5d_1.i4q_1.o2v(get_MaxRetriesPerRequestAttributeKey(), maxRetriesValue);
        return Unit_instance;
      } else if (tmp === 1) {
        throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
   while (true);
};
protoOf(HttpRequestRetry$lambda$slambda).t5d = function ($this$onRequest, request, _unused_var__etf5q3, completion) {
  var i = new HttpRequestRetry$lambda$slambda(this.o5d_1, completion);
  i.p5d_1 = $this$onRequest;
  i.q5d_1 = request;
  i.r5d_1 = _unused_var__etf5q3;
  return i;
};
function HttpRequestRetry$lambda$slambda_0($maxRetries, resultContinuation) {
  var i = new HttpRequestRetry$lambda$slambda($maxRetries, resultContinuation);
  var l = function ($this$onRequest, request, _unused_var__etf5q3, $completion) {
    return i.s5d($this$onRequest, request, _unused_var__etf5q3, $completion);
  };
  l.$arity = 3;
  return l;
}
function HttpRequestRetry$lambda$slambda_1($shouldRetry, $shouldRetryOnException, $maxRetries, $delayMillis, $modifyRequest, $this_createClientPlugin, $delay, resultContinuation) {
  this.d5e_1 = $shouldRetry;
  this.e5e_1 = $shouldRetryOnException;
  this.f5e_1 = $maxRetries;
  this.g5e_1 = $delayMillis;
  this.h5e_1 = $modifyRequest;
  this.i5e_1 = $this_createClientPlugin;
  this.j5e_1 = $delay;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpRequestRetry$lambda$slambda_1).h55 = function ($this$on, request, $completion) {
  var tmp = this.i55($this$on, request, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpRequestRetry$lambda$slambda_1).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof Sender_0 ? p1 : THROW_CCE();
  return this.h55(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpRequestRetry$lambda$slambda_1).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 8;
          this.n5e_1 = 0;
          var tmp_0 = this;
          var tmp0_elvis_lhs = this.l5e_1.i4q_1.m2v(get_ShouldRetryPerRequestAttributeKey());
          tmp_0.u5e_1 = tmp0_elvis_lhs == null ? this.d5e_1 : tmp0_elvis_lhs;
          var tmp_1 = this;
          var tmp1_elvis_lhs = this.l5e_1.i4q_1.m2v(get_ShouldRetryOnExceptionPerRequestAttributeKey());
          tmp_1.s5e_1 = tmp1_elvis_lhs == null ? this.e5e_1 : tmp1_elvis_lhs;
          var tmp_2 = this;
          var tmp2_elvis_lhs = this.l5e_1.i4q_1.m2v(get_MaxRetriesPerRequestAttributeKey());
          tmp_2.t5e_1 = tmp2_elvis_lhs == null ? this.f5e_1 : tmp2_elvis_lhs;
          var tmp_3 = this;
          var tmp3_elvis_lhs = this.l5e_1.i4q_1.m2v(get_RetryDelayPerRequestAttributeKey());
          tmp_3.o5e_1 = tmp3_elvis_lhs == null ? this.g5e_1 : tmp3_elvis_lhs;
          var tmp_4 = this;
          var tmp4_elvis_lhs = this.l5e_1.i4q_1.m2v(get_ModifyRequestPerRequestAttributeKey());
          tmp_4.v5e_1 = tmp4_elvis_lhs == null ? this.h5e_1 : tmp4_elvis_lhs;
          this.p5e_1 = null;
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!true) {
            this.d8_1 = 9;
            continue $sm;
          }

          this.r5e_1 = invoke$prepareRequest(this.l5e_1);
          this.e8_1 = 5;
          if (!(this.p5e_1 == null)) {
            var modifyRequestContext = new HttpRetryModifyRequestContext(this.l5e_1, this.p5e_1.f5b_1, this.p5e_1.g5b_1, this.p5e_1.e5b_1);
            this.v5e_1(modifyRequestContext, this.r5e_1);
          }

          this.d8_1 = 2;
          suspendResult = this.k5e_1.l55(this.r5e_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.m5e_1 = suspendResult;
          if (!invoke$shouldRetry(this.n5e_1, this.t5e_1, this.u5e_1, this.m5e_1)) {
            this.d8_1 = 4;
            suspendResult = throwOnInvalidResponseBody(this.m5e_1.m47(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.d8_1 = 3;
            continue $sm;
          }

        case 3:
          var tmp_5 = this;
          this.n5e_1 = this.n5e_1 + 1 | 0;
          tmp_5.q5e_1 = new HttpRetryEventData(this.r5e_1, this.n5e_1, this.m5e_1.m47(), null);
          this.e8_1 = 8;
          this.d8_1 = 6;
          continue $sm;
        case 4:
          this.e8_1 = 8;
          this.d8_1 = 9;
          continue $sm;
        case 5:
          this.e8_1 = 8;
          var tmp_6 = this.g8_1;
          if (tmp_6 instanceof Error) {
            var cause = this.g8_1;
            var tmp_7 = this;
            if (!invoke$shouldRetryOnException(this.n5e_1, this.t5e_1, this.s5e_1, this.r5e_1, cause)) {
              throw cause;
            }
            this.n5e_1 = this.n5e_1 + 1 | 0;
            tmp_7.q5e_1 = new HttpRetryEventData(this.r5e_1, this.n5e_1, null, cause);
            this.d8_1 = 6;
            continue $sm;
          } else {
            throw this.g8_1;
          }

        case 6:
          this.e8_1 = 8;
          var retryData = this.q5e_1;
          this.p5e_1 = retryData;
          this.i5e_1.d4y_1.k4o_1.w4e(get_HttpRequestRetryEvent(), this.p5e_1);
          var delayContext = new HttpRetryDelayContext(this.p5e_1.d5b_1, this.p5e_1.f5b_1, this.p5e_1.g5b_1);
          this.d8_1 = 7;
          suspendResult = this.j5e_1(this.o5e_1(delayContext, this.n5e_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 7:
          get_LOGGER_6().y31('Retrying request ' + this.l5e_1.d4q_1.toString() + ' attempt: ' + this.n5e_1);
          this.d8_1 = 1;
          continue $sm;
        case 8:
          throw this.g8_1;
        case 9:
          return this.m5e_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 8) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpRequestRetry$lambda$slambda_1).i55 = function ($this$on, request, completion) {
  var i = new HttpRequestRetry$lambda$slambda_1(this.d5e_1, this.e5e_1, this.f5e_1, this.g5e_1, this.h5e_1, this.i5e_1, this.j5e_1, completion);
  i.k5e_1 = $this$on;
  i.l5e_1 = request;
  return i;
};
function HttpRequestRetry$lambda$slambda_2($shouldRetry, $shouldRetryOnException, $maxRetries, $delayMillis, $modifyRequest, $this_createClientPlugin, $delay, resultContinuation) {
  var i = new HttpRequestRetry$lambda$slambda_1($shouldRetry, $shouldRetryOnException, $maxRetries, $delayMillis, $modifyRequest, $this_createClientPlugin, $delay, resultContinuation);
  var l = function ($this$on, request, $completion) {
    return i.h55($this$on, request, $completion);
  };
  l.$arity = 2;
  return l;
}
function HttpRequestRetry$lambda$prepareRequest$lambda($subRequest) {
  return function (cause) {
    var tmp = $subRequest.h4q_1;
    var subRequestJob = isInterface(tmp, CompletableJob) ? tmp : THROW_CCE();
    if (cause == null) {
      subRequestJob.b24();
    } else {
      subRequestJob.a24(cause);
    }
    return Unit_instance;
  };
}
function $throwOnInvalidResponseBodyCOROUTINE$(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.a5d_1 = _this__u8e3s4;
}
protoOf($throwOnInvalidResponseBodyCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 6;
          if (get_isSaved(this.a5d_1)) {
            this.b5d_1 = this.a5d_1.z4r();
            this.d8_1 = 1;
            continue $sm;
          } else {
            this.c5d_1 = false;
            this.d8_1 = 4;
            continue $sm;
          }

        case 1:
          this.e8_1 = 5;
          this.d8_1 = 2;
          suspendResult = this.b5d_1.t2l(VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.d5d_1 = suspendResult;
          this.e8_1 = 6;
          this.d8_1 = 3;
          continue $sm;
        case 3:
          var tmp_0 = this.d5d_1;
          this.e8_1 = 6;
          var this_0 = this.b5d_1;
          var tmp_1;
          try {
            cancel_3(this_0);
            tmp_1 = _Result___init__impl__xyqfz8(Unit_instance);
          } catch ($p) {
            var tmp_2;
            if ($p instanceof Error) {
              var e = $p;
              tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
            } else {
              throw $p;
            }
            tmp_1 = tmp_2;
          }

          var this_1 = tmp_1;
          var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(this_1);
          if (tmp0_safe_receiver == null)
            null;
          else {
            get_LOGGER_6().x31('Failed to close response body channel', tmp0_safe_receiver);
          }

          this.c5d_1 = tmp_0;
          this.d8_1 = 4;
          continue $sm;
        case 4:
          return this.c5d_1;
        case 5:
          this.e8_1 = 6;
          var t = this.g8_1;
          var this_2 = this.b5d_1;
          var tmp_3;
          try {
            cancel_3(this_2);
            tmp_3 = _Result___init__impl__xyqfz8(Unit_instance);
          } catch ($p) {
            var tmp_4;
            if ($p instanceof Error) {
              var e_0 = $p;
              tmp_4 = _Result___init__impl__xyqfz8(createFailure(e_0));
            } else {
              throw $p;
            }
            tmp_3 = tmp_4;
          }

          var this_3 = tmp_3;
          var tmp0_safe_receiver_0 = Result__exceptionOrNull_impl_p6xea9(this_3);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            get_LOGGER_6().x31('Failed to close response body channel', tmp0_safe_receiver_0);
          }

          throw t;
        case 6:
          throw this.g8_1;
      }
    } catch ($p) {
      var e_1 = $p;
      if (this.e8_1 === 6) {
        throw e_1;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e_1;
      }
    }
   while (true);
};
var properties_initialized_HttpRequestRetry_kt_jcpv6l;
function _init_properties_HttpRequestRetry_kt__h4xjtt() {
  if (!properties_initialized_HttpRequestRetry_kt_jcpv6l) {
    properties_initialized_HttpRequestRetry_kt_jcpv6l = true;
    LOGGER_6 = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestRetry');
    HttpRequestRetryEvent = new EventDefinition();
    var tmp = HttpRequestRetryConfig$_init_$ref_mqbboi();
    HttpRequestRetry = createClientPlugin('RetryFeature', tmp, HttpRequestRetry$lambda);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'MaxRetriesPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = PrimitiveClasses_getInstance().gb();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$0 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$0);
    MaxRetriesPerRequestAttributeKey = new AttributeKey(name, tmp$ret$1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_0 = 'ShouldRetryPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_3 = PrimitiveClasses_getInstance().functionClass(3);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_4;
    try {
      tmp_4 = createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryShouldRetryContext), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequest_0), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpResponse), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().db(), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_5;
      if ($p instanceof Error) {
        var _unused_var__etf5q3_0 = $p;
        tmp_5 = null;
      } else {
        throw $p;
      }
      tmp_4 = tmp_5;
    }
    var tmp$ret$0_0 = tmp_4;
    var tmp$ret$1_0 = new TypeInfo(tmp_3, tmp$ret$0_0);
    ShouldRetryPerRequestAttributeKey = new AttributeKey(name_0, tmp$ret$1_0);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_1 = 'ShouldRetryOnExceptionPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_6 = PrimitiveClasses_getInstance().functionClass(3);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_7;
    try {
      tmp_7 = createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryShouldRetryContext), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequestBuilder), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().mb(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().db(), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_8;
      if ($p instanceof Error) {
        var _unused_var__etf5q3_1 = $p;
        tmp_8 = null;
      } else {
        throw $p;
      }
      tmp_7 = tmp_8;
    }
    var tmp$ret$0_1 = tmp_7;
    var tmp$ret$1_1 = new TypeInfo(tmp_6, tmp$ret$0_1);
    ShouldRetryOnExceptionPerRequestAttributeKey = new AttributeKey(name_1, tmp$ret$1_1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_2 = 'ModifyRequestPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_9 = PrimitiveClasses_getInstance().functionClass(2);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_10;
    try {
      tmp_10 = createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryModifyRequestContext), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequestBuilder), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_11;
      if ($p instanceof Error) {
        var _unused_var__etf5q3_2 = $p;
        tmp_11 = null;
      } else {
        throw $p;
      }
      tmp_10 = tmp_11;
    }
    var tmp$ret$0_2 = tmp_10;
    var tmp$ret$1_2 = new TypeInfo(tmp_9, tmp$ret$0_2);
    ModifyRequestPerRequestAttributeKey = new AttributeKey(name_2, tmp$ret$1_2);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_3 = 'RetryDelayPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_12 = PrimitiveClasses_getInstance().functionClass(2);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_13;
    try {
      tmp_13 = createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryDelayContext), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().hb(), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_14;
      if ($p instanceof Error) {
        var _unused_var__etf5q3_3 = $p;
        tmp_14 = null;
      } else {
        throw $p;
      }
      tmp_13 = tmp_14;
    }
    var tmp$ret$0_3 = tmp_13;
    var tmp$ret$1_3 = new TypeInfo(tmp_12, tmp$ret$0_3);
    RetryDelayPerRequestAttributeKey = new AttributeKey(name_3, tmp$ret$1_3);
  }
}
function Sender() {
}
function HttpSend$Plugin$install$slambda($plugin, $scope, resultContinuation) {
  this.f5f_1 = $plugin;
  this.g5f_1 = $scope;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpSend$Plugin$install$slambda).x4o = function ($this$intercept, content, $completion) {
  var tmp = this.y4o($this$intercept, content, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpSend$Plugin$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpSend$Plugin$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          var tmp_0 = this.i5f_1;
          if (!(tmp_0 instanceof OutgoingContent)) {
            var message = trimMargin('\n|Fail to prepare request body for sending. \n|The body type is: ' + toString(getKClassFromExpression(this.i5f_1)) + ', with Content-Type: ' + toString_0(contentType(this.h5f_1.a31_1)) + '.\n|\n|If you expect serialized body, please check that you have installed the corresponding plugin(like `ContentNegotiation`) and set `Content-Type` header.');
            throw IllegalStateException_init_$Create$(toString(message));
          }

          var tmp0 = this.h5f_1.a31_1;
          var body = this.i5f_1;
          if (body == null) {
            tmp0.g4q_1 = NullBody_instance;
            var tmp_1 = getKClass(OutgoingContent);
            var tmp_2;
            try {
              tmp_2 = createKType(getKClass(OutgoingContent), arrayOf([]), false);
            } catch ($p) {
              var tmp_3;
              if ($p instanceof Error) {
                var _unused_var__etf5q3 = $p;
                tmp_3 = null;
              } else {
                throw $p;
              }
              tmp_2 = tmp_3;
            }
            tmp0.u4v(new TypeInfo(tmp_1, tmp_2));
          } else {
            if (body instanceof OutgoingContent) {
              tmp0.g4q_1 = body;
              tmp0.u4v(null);
            } else {
              tmp0.g4q_1 = body;
              var tmp_4 = getKClass(OutgoingContent);
              var tmp_5;
              try {
                tmp_5 = createKType(getKClass(OutgoingContent), arrayOf([]), false);
              } catch ($p) {
                var tmp_6;
                if ($p instanceof Error) {
                  var _unused_var__etf5q3_0 = $p;
                  tmp_6 = null;
                } else {
                  throw $p;
                }
                tmp_5 = tmp_6;
              }
              tmp0.u4v(new TypeInfo(tmp_4, tmp_5));
            }
          }

          var maxRetriesFromRetryPlugin = this.h5f_1.a31_1.i4q_1.m2v(get_MaxRetriesPerRequestAttributeKey());
          var tmp_7;
          if (!(maxRetriesFromRetryPlugin == null)) {
            tmp_7 = maxRetriesFromRetryPlugin + 1 | 0;
          } else {
            tmp_7 = this.f5f_1.j5f_1;
          }

          var maxRetries = tmp_7;
          var realSender = new DefaultSender(maxRetries, this.g5f_1);
          var interceptedSender = realSender;
          var _iterator__ex2g4s = reversed(this.f5f_1.k5f_1).l();
          while (_iterator__ex2g4s.m()) {
            var interceptor = _iterator__ex2g4s.n();
            interceptedSender = new InterceptedSender(interceptor, interceptedSender);
          }

          this.d8_1 = 1;
          suspendResult = interceptedSender.w5e(this.h5f_1.a31_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var call = suspendResult;
          this.d8_1 = 2;
          suspendResult = this.h5f_1.e30(call, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpSend$Plugin$install$slambda).y4o = function ($this$intercept, content, completion) {
  var i = new HttpSend$Plugin$install$slambda(this.f5f_1, this.g5f_1, completion);
  i.h5f_1 = $this$intercept;
  i.i5f_1 = content;
  return i;
};
function HttpSend$Plugin$install$slambda_0($plugin, $scope, resultContinuation) {
  var i = new HttpSend$Plugin$install$slambda($plugin, $scope, resultContinuation);
  var l = function ($this$intercept, content, $completion) {
    return i.x4o($this$intercept, content, $completion);
  };
  l.$arity = 2;
  return l;
}
function $executeCOROUTINE$_0(_this__u8e3s4, requestBuilder, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.t5f_1 = _this__u8e3s4;
  this.u5f_1 = requestBuilder;
}
protoOf($executeCOROUTINE$_0).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          var tmp0_safe_receiver = this.t5f_1.y5f_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            cancel(tmp0_safe_receiver);
          }

          if (this.t5f_1.x5f_1 >= this.t5f_1.v5f_1) {
            throw new SendCountExceedException('Max send count ' + this.t5f_1.v5f_1 + ' exceeded. Consider increasing the property ' + 'maxSendCount if more is required.');
          }

          var _unary__edvuaz = this.t5f_1.x5f_1;
          this.t5f_1.x5f_1 = _unary__edvuaz + 1 | 0;
          this.d8_1 = 1;
          suspendResult = this.t5f_1.w5f_1.g4o_1.z30(this.u5f_1, this.u5f_1.g4q_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var sendResult = suspendResult;
          var tmp1_elvis_lhs = sendResult instanceof HttpClientCall ? sendResult : null;
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            var message = 'Failed to execute send pipeline. Expected [HttpClientCall], but received ' + toString(sendResult);
            throw IllegalStateException_init_$Create$(toString(message));
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }

          var call = tmp_0;
          this.t5f_1.y5f_1 = call;
          return call;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function Config() {
  this.z5f_1 = 20;
}
function Plugin_0() {
  Plugin_instance_0 = this;
  var tmp = this;
  // Inline function 'io.ktor.util.AttributeKey' call
  var name = 'HttpSend';
  // Inline function 'io.ktor.util.reflect.typeInfo' call
  var tmp_0 = getKClass(HttpSend);
  // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
  var tmp_1;
  try {
    tmp_1 = createKType(getKClass(HttpSend), arrayOf([]), false);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_1 = tmp_2;
  }
  var tmp$ret$0 = tmp_1;
  var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$0);
  tmp.a5g_1 = new AttributeKey(name, tmp$ret$1);
}
protoOf(Plugin_0).v = function () {
  return this.a5g_1;
};
protoOf(Plugin_0).b5g = function (block) {
  // Inline function 'kotlin.apply' call
  var this_0 = new Config();
  block(this_0);
  var config = this_0;
  return new HttpSend(config.z5f_1);
};
protoOf(Plugin_0).i4r = function (block) {
  return this.b5g(block);
};
protoOf(Plugin_0).c5g = function (plugin, scope) {
  var tmp = Phases_getInstance().j4x_1;
  scope.e4o_1.e31(tmp, HttpSend$Plugin$install$slambda_0(plugin, scope, null));
};
protoOf(Plugin_0).j4r = function (plugin, scope) {
  return this.c5g(plugin instanceof HttpSend ? plugin : THROW_CCE(), scope);
};
var Plugin_instance_0;
function Plugin_getInstance_0() {
  if (Plugin_instance_0 == null)
    new Plugin_0();
  return Plugin_instance_0;
}
function InterceptedSender(interceptor, nextSender) {
  this.d5g_1 = interceptor;
  this.e5g_1 = nextSender;
}
protoOf(InterceptedSender).w5e = function (requestBuilder, $completion) {
  return this.d5g_1(this.e5g_1, requestBuilder, $completion);
};
function DefaultSender(maxSendCount, client) {
  this.v5f_1 = maxSendCount;
  this.w5f_1 = client;
  this.x5f_1 = 0;
  this.y5f_1 = null;
}
protoOf(DefaultSender).w5e = function (requestBuilder, $completion) {
  var tmp = new $executeCOROUTINE$_0(this, requestBuilder, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
function HttpSend(maxSendCount) {
  Plugin_getInstance_0();
  maxSendCount = maxSendCount === VOID ? 20 : maxSendCount;
  this.j5f_1 = maxSendCount;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.k5f_1 = ArrayList_init_$Create$();
}
protoOf(HttpSend).f5g = function (block) {
  // Inline function 'kotlin.collections.plusAssign' call
  this.k5f_1.j(block);
};
function SendCountExceedException(message) {
  IllegalStateException_init_$Init$_0(message, this);
  captureStack(this, SendCountExceedException);
}
function get_LOGGER_7() {
  _init_properties_HttpTimeout_kt__pucqrr();
  return LOGGER_7;
}
var LOGGER_7;
function get_HttpTimeout() {
  _init_properties_HttpTimeout_kt__pucqrr();
  return HttpTimeout;
}
var HttpTimeout;
function HttpTimeoutCapability() {
}
protoOf(HttpTimeoutCapability).toString = function () {
  return 'HttpTimeoutCapability';
};
protoOf(HttpTimeoutCapability).hashCode = function () {
  return 2058496954;
};
protoOf(HttpTimeoutCapability).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof HttpTimeoutCapability))
    return false;
  return true;
};
var HttpTimeoutCapability_instance;
function HttpTimeoutCapability_getInstance() {
  return HttpTimeoutCapability_instance;
}
function HttpRequestTimeoutException_init_$Init$(request, $this) {
  var tmp = request.d4q_1.q3e();
  var tmp0_safe_receiver = request.g5g(HttpTimeoutCapability_instance);
  HttpRequestTimeoutException.call($this, tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k5g());
  return $this;
}
function HttpRequestTimeoutException_init_$Create$(request) {
  var tmp = HttpRequestTimeoutException_init_$Init$(request, objectCreate(protoOf(HttpRequestTimeoutException)));
  captureStack(tmp, HttpRequestTimeoutException_init_$Create$);
  return tmp;
}
function HttpRequestTimeoutException(url, timeoutMillis, cause) {
  cause = cause === VOID ? null : cause;
  IOException_init_$Init$('Request timeout has expired [url=' + url + ', request_timeout=' + toString(timeoutMillis == null ? 'unknown' : timeoutMillis) + ' ms]', cause, this);
  captureStack(this, HttpRequestTimeoutException);
  this.l5g_1 = url;
  this.m5g_1 = timeoutMillis;
}
protoOf(HttpRequestTimeoutException).p24 = function () {
  return new HttpRequestTimeoutException(this.l5g_1, this.m5g_1, this.cause);
};
function HttpTimeoutConfig_init_$Init$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, $this) {
  requestTimeoutMillis = requestTimeoutMillis === VOID ? null : requestTimeoutMillis;
  connectTimeoutMillis = connectTimeoutMillis === VOID ? null : connectTimeoutMillis;
  socketTimeoutMillis = socketTimeoutMillis === VOID ? null : socketTimeoutMillis;
  HttpTimeoutConfig.call($this);
  $this.n5g(requestTimeoutMillis);
  $this.o5g(connectTimeoutMillis);
  $this.p5g(socketTimeoutMillis);
  return $this;
}
function HttpTimeoutConfig_init_$Create$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis) {
  return HttpTimeoutConfig_init_$Init$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, objectCreate(protoOf(HttpTimeoutConfig)));
}
function checkTimeoutValue($this, value) {
  // Inline function 'kotlin.require' call
  if (!(value == null || value > 0n)) {
    var message = 'Only positive timeout values are allowed, for infinite timeout use HttpTimeoutConfig.INFINITE_TIMEOUT_MS';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return value;
}
function Companion_1() {
  Companion_instance_2 = this;
  this.q5g_1 = 9223372036854775807n;
  var tmp = this;
  // Inline function 'io.ktor.util.AttributeKey' call
  var name = 'TimeoutConfiguration';
  // Inline function 'io.ktor.util.reflect.typeInfo' call
  var tmp_0 = getKClass(HttpTimeoutConfig);
  // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
  var tmp_1;
  try {
    tmp_1 = createKType(getKClass(HttpTimeoutConfig), arrayOf([]), false);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_1 = tmp_2;
  }
  var tmp$ret$0 = tmp_1;
  var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$0);
  tmp.r5g_1 = new AttributeKey(name, tmp$ret$1);
}
var Companion_instance_2;
function Companion_getInstance_8() {
  if (Companion_instance_2 == null)
    new Companion_1();
  return Companion_instance_2;
}
protoOf(HttpTimeoutConfig).n5g = function (value) {
  this.h5g_1 = checkTimeoutValue(this, value);
};
protoOf(HttpTimeoutConfig).k5g = function () {
  return this.h5g_1;
};
protoOf(HttpTimeoutConfig).o5g = function (value) {
  this.i5g_1 = checkTimeoutValue(this, value);
};
protoOf(HttpTimeoutConfig).s5g = function () {
  return this.i5g_1;
};
protoOf(HttpTimeoutConfig).p5g = function (value) {
  this.j5g_1 = checkTimeoutValue(this, value);
};
protoOf(HttpTimeoutConfig).t5g = function () {
  return this.j5g_1;
};
protoOf(HttpTimeoutConfig).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof HttpTimeoutConfig))
    THROW_CCE();
  if (!(this.h5g_1 == other.h5g_1))
    return false;
  if (!(this.i5g_1 == other.i5g_1))
    return false;
  if (!(this.j5g_1 == other.j5g_1))
    return false;
  return true;
};
protoOf(HttpTimeoutConfig).hashCode = function () {
  var tmp0_safe_receiver = this.h5g_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getBigIntHashCode(tmp0_safe_receiver);
  var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  var tmp = imul(31, result);
  var tmp2_safe_receiver = this.i5g_1;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : getBigIntHashCode(tmp2_safe_receiver);
  result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
  var tmp_0 = imul(31, result);
  var tmp4_safe_receiver = this.j5g_1;
  var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : getBigIntHashCode(tmp4_safe_receiver);
  result = tmp_0 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
  return result;
};
function HttpTimeoutConfig() {
  Companion_getInstance_8();
  this.h5g_1 = 0n;
  this.i5g_1 = 0n;
  this.j5g_1 = 0n;
}
function get_supportsRequestTimeout(_this__u8e3s4) {
  _init_properties_HttpTimeout_kt__pucqrr();
  var tmp;
  var tmp_0;
  if (!isWebsocket(_this__u8e3s4.d4q_1.f3d())) {
    var tmp_1 = _this__u8e3s4.g4q_1;
    tmp_0 = !(tmp_1 instanceof ClientUpgradeContent);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp_2 = _this__u8e3s4.g4q_1;
    tmp = !(tmp_2 instanceof SSEClientContent);
  } else {
    tmp = false;
  }
  return tmp;
}
function applyRequestTimeout(_this__u8e3s4, request, requestTimeout) {
  _init_properties_HttpTimeout_kt__pucqrr();
  if (requestTimeout == null || requestTimeout === 9223372036854775807n)
    return Unit_instance;
  var executionContext = request.h4q_1;
  var tmp = new CoroutineName('request-timeout');
  var killer = launch(_this__u8e3s4, tmp, VOID, applyRequestTimeout$slambda_0(requestTimeout, request, executionContext, null));
  var tmp_0 = request.h4q_1;
  tmp_0.h1y(applyRequestTimeout$lambda(killer));
}
function HttpTimeoutConfig$_init_$ref_dl1k0m() {
  return function () {
    return HttpTimeoutConfig_init_$Create$();
  };
}
function HttpTimeout$lambda($this$createClientPlugin) {
  _init_properties_HttpTimeout_kt__pucqrr();
  var requestTimeoutMillis = $this$createClientPlugin.e4y_1.k5g();
  var connectTimeoutMillis = $this$createClientPlugin.e4y_1.s5g();
  var socketTimeoutMillis = $this$createClientPlugin.e4y_1.t5g();
  var tmp = Send_instance;
  $this$createClientPlugin.h4y(tmp, HttpTimeout$lambda$slambda_0(connectTimeoutMillis, socketTimeoutMillis, requestTimeoutMillis, null));
  return Unit_instance;
}
function invoke$hasNotNullTimeouts(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, supportsRequestTimeout) {
  return supportsRequestTimeout && !(requestTimeoutMillis == null) || !(connectTimeoutMillis == null) || !(socketTimeoutMillis == null);
}
function HttpTimeout$lambda$slambda($connectTimeoutMillis, $socketTimeoutMillis, $requestTimeoutMillis, resultContinuation) {
  this.c5h_1 = $connectTimeoutMillis;
  this.d5h_1 = $socketTimeoutMillis;
  this.e5h_1 = $requestTimeoutMillis;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpTimeout$lambda$slambda).h55 = function ($this$on, request, $completion) {
  var tmp = this.i55($this$on, request, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpTimeout$lambda$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof Sender_0 ? p1 : THROW_CCE();
  return this.h55(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpTimeout$lambda$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          var supportsRequestTimeout = get_supportsRequestTimeout(this.g5h_1);
          var configuration = this.g5h_1.g5g(HttpTimeoutCapability_instance);
          if (configuration == null && invoke$hasNotNullTimeouts(this.e5h_1, this.c5h_1, this.d5h_1, supportsRequestTimeout)) {
            configuration = HttpTimeoutConfig_init_$Create$();
            this.g5h_1.h5h(HttpTimeoutCapability_instance, configuration);
          }

          var tmp0_safe_receiver = configuration;
          if (tmp0_safe_receiver == null)
            null;
          else {
            var tmp0_elvis_lhs = tmp0_safe_receiver.s5g();
            tmp0_safe_receiver.o5g(tmp0_elvis_lhs == null ? this.c5h_1 : tmp0_elvis_lhs);
            var tmp1_elvis_lhs = tmp0_safe_receiver.t5g();
            tmp0_safe_receiver.p5g(tmp1_elvis_lhs == null ? this.d5h_1 : tmp1_elvis_lhs);
            if (supportsRequestTimeout) {
              var tmp2_elvis_lhs = tmp0_safe_receiver.k5g();
              tmp0_safe_receiver.n5g(tmp2_elvis_lhs == null ? this.e5h_1 : tmp2_elvis_lhs);
              applyRequestTimeout(this.f5h_1, this.g5h_1, tmp0_safe_receiver.k5g());
            }
          }

          this.d8_1 = 1;
          suspendResult = this.f5h_1.l55(this.g5h_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpTimeout$lambda$slambda).i55 = function ($this$on, request, completion) {
  var i = new HttpTimeout$lambda$slambda(this.c5h_1, this.d5h_1, this.e5h_1, completion);
  i.f5h_1 = $this$on;
  i.g5h_1 = request;
  return i;
};
function HttpTimeout$lambda$slambda_0($connectTimeoutMillis, $socketTimeoutMillis, $requestTimeoutMillis, resultContinuation) {
  var i = new HttpTimeout$lambda$slambda($connectTimeoutMillis, $socketTimeoutMillis, $requestTimeoutMillis, resultContinuation);
  var l = function ($this$on, request, $completion) {
    return i.h55($this$on, request, $completion);
  };
  l.$arity = 2;
  return l;
}
function applyRequestTimeout$slambda($requestTimeout, $request, $executionContext, resultContinuation) {
  this.q5h_1 = $requestTimeout;
  this.r5h_1 = $request;
  this.s5h_1 = $executionContext;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(applyRequestTimeout$slambda).l2t = function ($this$launch, $completion) {
  var tmp = this.m2t($this$launch, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(applyRequestTimeout$slambda).x8 = function (p1, $completion) {
  return this.l2t((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(applyRequestTimeout$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = delay(this.q5h_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var cause = HttpRequestTimeoutException_init_$Create$(this.r5h_1);
          var this_0 = get_LOGGER_7();
          if (get_isTraceEnabled(this_0)) {
            this_0.y31('Request timeout: ' + this.r5h_1.d4q_1.toString());
          }

          cancel_1(this.s5h_1, ensureNotNull(cause.message), cause);
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(applyRequestTimeout$slambda).m2t = function ($this$launch, completion) {
  var i = new applyRequestTimeout$slambda(this.q5h_1, this.r5h_1, this.s5h_1, completion);
  i.t5h_1 = $this$launch;
  return i;
};
function applyRequestTimeout$slambda_0($requestTimeout, $request, $executionContext, resultContinuation) {
  var i = new applyRequestTimeout$slambda($requestTimeout, $request, $executionContext, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.l2t($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function applyRequestTimeout$lambda($killer) {
  return function (it) {
    $killer.p1y();
    return Unit_instance;
  };
}
var properties_initialized_HttpTimeout_kt_9oyjbd;
function _init_properties_HttpTimeout_kt__pucqrr() {
  if (!properties_initialized_HttpTimeout_kt_9oyjbd) {
    properties_initialized_HttpTimeout_kt_9oyjbd = true;
    LOGGER_7 = KtorSimpleLogger('io.ktor.client.plugins.HttpTimeout');
    var tmp = HttpTimeoutConfig$_init_$ref_dl1k0m();
    HttpTimeout = createClientPlugin('HttpTimeout', tmp, HttpTimeout$lambda);
  }
}
function get_SKIP_SAVE_BODY() {
  _init_properties_SaveBody_kt__lbc3fj();
  return SKIP_SAVE_BODY;
}
var SKIP_SAVE_BODY;
function get_RESPONSE_BODY_SAVED() {
  _init_properties_SaveBody_kt__lbc3fj();
  return RESPONSE_BODY_SAVED;
}
var RESPONSE_BODY_SAVED;
function get_LOGGER_8() {
  _init_properties_SaveBody_kt__lbc3fj();
  var tmp0 = LOGGER$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('LOGGER', 0, tmp, _get_LOGGER_$ref_77hhxy(), null);
  return tmp0.w();
}
var LOGGER$delegate;
function get_SaveBody() {
  _init_properties_SaveBody_kt__lbc3fj();
  return SaveBody;
}
var SaveBody;
var SaveBodyPlugin;
function get_isSaved(_this__u8e3s4) {
  _init_properties_SaveBody_kt__lbc3fj();
  return _this__u8e3s4.s4r().m4r().n2v(get_RESPONSE_BODY_SAVED());
}
function SaveBodyPluginConfig() {
  this.u5h_1 = false;
}
function LOGGER$delegate$lambda() {
  _init_properties_SaveBody_kt__lbc3fj();
  return KtorSimpleLogger('io.ktor.client.plugins.SaveBody');
}
function _get_LOGGER_$ref_77hhxy() {
  return function () {
    return get_LOGGER_8();
  };
}
function SaveBody$lambda($this$createClientPlugin) {
  _init_properties_SaveBody_kt__lbc3fj();
  var tmp = Phases_getInstance_1().z4x_1;
  $this$createClientPlugin.d4y_1.h4o_1.e31(tmp, SaveBody$lambda$slambda_0(null));
  return Unit_instance;
}
function SaveBody$lambda$slambda(resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(SaveBody$lambda$slambda).w4x = function ($this$intercept, response, $completion) {
  var tmp = this.x4x($this$intercept, response, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(SaveBody$lambda$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.w4x(tmp, p2 instanceof HttpResponse ? p2 : THROW_CCE(), $completion);
};
protoOf(SaveBody$lambda$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 6;
          this.h5i_1 = this.e5i_1.s4r();
          this.f5i_1 = this.h5i_1.m4r();
          if (this.f5i_1.n2v(get_SKIP_SAVE_BODY())) {
            var this_0 = get_LOGGER_8();
            if (get_isTraceEnabled(this_0)) {
              this_0.y31('Skipping body saving for ' + this.h5i_1.l4r().b3p().toString());
            }
            return Unit_instance;
          }

          this.d8_1 = 1;
          continue $sm;
        case 1:
          this.e8_1 = 5;
          var this_1 = get_LOGGER_8();
          if (get_isTraceEnabled(this_1)) {
            this_1.y31('Saving body for ' + this.h5i_1.l4r().b3p().toString());
          }

          this.d8_1 = 2;
          suspendResult = save(this.h5i_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.g5i_1 = suspendResult.m47();
          this.e8_1 = 6;
          this.d8_1 = 3;
          continue $sm;
        case 3:
          var tmp_0 = this.g5i_1;
          this.e8_1 = 6;
          this.d5i_1;
          var tmp_1;
          try {
            cancel_3(this.e5i_1.z4r());
            tmp_1 = _Result___init__impl__xyqfz8(Unit_instance);
          } catch ($p) {
            var tmp_2;
            if ($p instanceof Error) {
              var e = $p;
              tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
            } else {
              throw $p;
            }
            tmp_1 = tmp_2;
          }

          var this_2 = tmp_1;
          var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(this_2);
          if (tmp0_safe_receiver == null)
            null;
          else {
            get_LOGGER_8().x31('Failed to cancel response body', tmp0_safe_receiver);
          }

          var savedResponse = tmp_0;
          this.f5i_1.o2v(get_RESPONSE_BODY_SAVED(), Unit_instance);
          this.d8_1 = 4;
          suspendResult = this.d5i_1.e30(savedResponse, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 4:
          return Unit_instance;
        case 5:
          this.e8_1 = 6;
          var t = this.g8_1;
          this.d5i_1;
          var tmp_3;
          try {
            cancel_3(this.e5i_1.z4r());
            tmp_3 = _Result___init__impl__xyqfz8(Unit_instance);
          } catch ($p) {
            var tmp_4;
            if ($p instanceof Error) {
              var e_0 = $p;
              tmp_4 = _Result___init__impl__xyqfz8(createFailure(e_0));
            } else {
              throw $p;
            }
            tmp_3 = tmp_4;
          }

          var this_3 = tmp_3;
          var tmp0_safe_receiver_0 = Result__exceptionOrNull_impl_p6xea9(this_3);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            get_LOGGER_8().x31('Failed to cancel response body', tmp0_safe_receiver_0);
          }

          throw t;
        case 6:
          throw this.g8_1;
      }
    } catch ($p) {
      var e_1 = $p;
      if (this.e8_1 === 6) {
        throw e_1;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e_1;
      }
    }
   while (true);
};
protoOf(SaveBody$lambda$slambda).x4x = function ($this$intercept, response, completion) {
  var i = new SaveBody$lambda$slambda(completion);
  i.d5i_1 = $this$intercept;
  i.e5i_1 = response;
  return i;
};
function SaveBody$lambda$slambda_0(resultContinuation) {
  var i = new SaveBody$lambda$slambda(resultContinuation);
  var l = function ($this$intercept, response, $completion) {
    return i.w4x($this$intercept, response, $completion);
  };
  l.$arity = 2;
  return l;
}
function SaveBodyPluginConfig$_init_$ref_lwjaof() {
  var l = function () {
    return new SaveBodyPluginConfig();
  };
  l.callableName = '<init>';
  return l;
}
function SaveBodyPlugin$lambda($this$createClientPlugin) {
  _init_properties_SaveBody_kt__lbc3fj();
  if ($this$createClientPlugin.e4y_1.u5h_1) {
    get_LOGGER_8().w31('It is no longer possible to disable body saving for all requests. Use client.prepareRequest(...).execute { ... } syntax to prevent saving the body in memory.\n\nThis API is deprecated and will be removed in Ktor 4.0.0\nIf you were relying on this functionality, share your use case by commenting on this issue: https://youtrack.jetbrains.com/issue/KTOR-8367/');
  } else {
    get_LOGGER_8().w31('The SaveBodyPlugin plugin is deprecated and can be safely removed. Request bodies are now saved in memory by default for all non-streaming responses.');
  }
  return Unit_instance;
}
var properties_initialized_SaveBody_kt_hzvee7;
function _init_properties_SaveBody_kt__lbc3fj() {
  if (!properties_initialized_SaveBody_kt_hzvee7) {
    properties_initialized_SaveBody_kt_hzvee7 = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'SkipSaveBody';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(Unit);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(Unit), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$0 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$0);
    SKIP_SAVE_BODY = new AttributeKey(name, tmp$ret$1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_0 = 'ResponseBodySaved';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_2 = getKClass(Unit);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_3;
    try {
      tmp_3 = createKType(getKClass(Unit), arrayOf([]), false);
    } catch ($p) {
      var tmp_4;
      if ($p instanceof Error) {
        var _unused_var__etf5q3_0 = $p;
        tmp_4 = null;
      } else {
        throw $p;
      }
      tmp_3 = tmp_4;
    }
    var tmp$ret$0_0 = tmp_3;
    var tmp$ret$1_0 = new TypeInfo(tmp_2, tmp$ret$0_0);
    RESPONSE_BODY_SAVED = new AttributeKey(name_0, tmp$ret$1_0);
    LOGGER$delegate = lazy(LOGGER$delegate$lambda);
    SaveBody = createClientPlugin_0('SaveBody', SaveBody$lambda);
    var tmp_5 = SaveBodyPluginConfig$_init_$ref_lwjaof();
    SaveBodyPlugin = createClientPlugin('DoubleReceivePlugin', tmp_5, SaveBodyPlugin$lambda);
  }
}
function HookHandler(hook, handler) {
  this.i5i_1 = hook;
  this.j5i_1 = handler;
}
protoOf(HookHandler).k4q = function (client) {
  this.i5i_1.k4x(client, this.j5i_1);
};
function ClientPluginBuilder$onClose$lambda() {
  return Unit_instance;
}
function ClientPluginBuilder(key, client, pluginConfig) {
  this.c4y_1 = key;
  this.d4y_1 = client;
  this.e4y_1 = pluginConfig;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.f4y_1 = ArrayList_init_$Create$();
  var tmp_0 = this;
  tmp_0.g4y_1 = ClientPluginBuilder$onClose$lambda;
}
protoOf(ClientPluginBuilder).e5d = function (block) {
  this.h4y(RequestHook_instance, block);
};
protoOf(ClientPluginBuilder).k5i = function (block) {
  this.h4y(ResponseHook_instance, block);
};
protoOf(ClientPluginBuilder).l5i = function (block) {
  this.h4y(TransformRequestBodyHook_instance, block);
};
protoOf(ClientPluginBuilder).j57 = function (block) {
  this.h4y(TransformResponseBodyHook_instance, block);
};
protoOf(ClientPluginBuilder).h4y = function (hook, handler) {
  this.f4y_1.j(new HookHandler(hook, handler));
};
function ClientPluginInstance$onClose$lambda() {
  return Unit_instance;
}
function ClientPluginInstance(key, config, body) {
  this.m5i_1 = key;
  this.n5i_1 = config;
  this.o5i_1 = body;
  var tmp = this;
  tmp.p5i_1 = ClientPluginInstance$onClose$lambda;
}
protoOf(ClientPluginInstance).k4q = function (scope) {
  var tmp0 = new ClientPluginBuilder(this.m5i_1, scope, this.n5i_1);
  // Inline function 'kotlin.apply' call
  this.o5i_1(tmp0);
  var pluginBuilder = tmp0;
  this.p5i_1 = pluginBuilder.g4y_1;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = pluginBuilder.f4y_1.l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    element.k4q(scope);
  }
};
protoOf(ClientPluginInstance).i3 = function () {
  this.p5i_1();
};
function SetupRequest$install$slambda($handler, resultContinuation) {
  this.y5i_1 = $handler;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(SetupRequest$install$slambda).x4o = function ($this$intercept, it, $completion) {
  var tmp = this.y4o($this$intercept, it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(SetupRequest$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(SetupRequest$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.y5i_1(this.z5i_1.a31_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(SetupRequest$install$slambda).y4o = function ($this$intercept, it, completion) {
  var i = new SetupRequest$install$slambda(this.y5i_1, completion);
  i.z5i_1 = $this$intercept;
  i.a5j_1 = it;
  return i;
};
function SetupRequest$install$slambda_0($handler, resultContinuation) {
  var i = new SetupRequest$install$slambda($handler, resultContinuation);
  var l = function ($this$intercept, it, $completion) {
    return i.x4o($this$intercept, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function SetupRequest() {
}
protoOf(SetupRequest).b5j = function (client, handler) {
  var tmp = Phases_getInstance().f4x_1;
  client.e4o_1.e31(tmp, SetupRequest$install$slambda_0(handler, null));
};
protoOf(SetupRequest).k4x = function (client, handler) {
  return this.b5j(client, (!(handler == null) ? isSuspendFunction(handler, 1) : false) ? handler : THROW_CCE());
};
var SetupRequest_instance;
function SetupRequest_getInstance() {
  return SetupRequest_instance;
}
function Sender_0(httpSendSender, coroutineContext) {
  this.j55_1 = httpSendSender;
  this.k55_1 = coroutineContext;
}
protoOf(Sender_0).f1x = function () {
  return this.k55_1;
};
protoOf(Sender_0).l55 = function (requestBuilder, $completion) {
  return this.j55_1.w5e(requestBuilder, $completion);
};
function Send$install$slambda($handler, $client, resultContinuation) {
  this.k5j_1 = $handler;
  this.l5j_1 = $client;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(Send$install$slambda).o5j = function ($this$intercept, request, $completion) {
  var tmp = this.p5j($this$intercept, request, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(Send$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
  return this.o5j(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
};
protoOf(Send$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.k5j_1(new Sender_0(this.m5j_1, this.l5j_1.d4o_1), this.n5j_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(Send$install$slambda).p5j = function ($this$intercept, request, completion) {
  var i = new Send$install$slambda(this.k5j_1, this.l5j_1, completion);
  i.m5j_1 = $this$intercept;
  i.n5j_1 = request;
  return i;
};
function Send$install$slambda_0($handler, $client, resultContinuation) {
  var i = new Send$install$slambda($handler, $client, resultContinuation);
  var l = function ($this$intercept, request, $completion) {
    return i.o5j($this$intercept, request, $completion);
  };
  l.$arity = 2;
  return l;
}
function Send() {
}
protoOf(Send).q5j = function (client, handler) {
  var tmp = plugin(client, Plugin_getInstance_0());
  tmp.f5g(Send$install$slambda_0(handler, client, null));
};
protoOf(Send).k4x = function (client, handler) {
  return this.q5j(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
};
var Send_instance;
function Send_getInstance() {
  return Send_instance;
}
function SendingRequest$install$slambda($handler, resultContinuation) {
  this.z5j_1 = $handler;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(SendingRequest$install$slambda).x4o = function ($this$intercept, it, $completion) {
  var tmp = this.y4o($this$intercept, it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(SendingRequest$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(SendingRequest$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          var tmp_0 = this.a5k_1.d30();
          suspendResult = this.z5j_1(this.a5k_1.a31_1, tmp_0 instanceof OutgoingContent ? tmp_0 : THROW_CCE(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(SendingRequest$install$slambda).y4o = function ($this$intercept, it, completion) {
  var i = new SendingRequest$install$slambda(this.z5j_1, completion);
  i.a5k_1 = $this$intercept;
  i.b5k_1 = it;
  return i;
};
function SendingRequest$install$slambda_0($handler, resultContinuation) {
  var i = new SendingRequest$install$slambda($handler, resultContinuation);
  var l = function ($this$intercept, it, $completion) {
    return i.x4o($this$intercept, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function SendingRequest() {
}
protoOf(SendingRequest).c5k = function (client, handler) {
  var tmp = Phases_getInstance_0().m4q_1;
  client.g4o_1.e31(tmp, SendingRequest$install$slambda_0(handler, null));
};
protoOf(SendingRequest).k4x = function (client, handler) {
  return this.c5k(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
};
var SendingRequest_instance;
function SendingRequest_getInstance() {
  return SendingRequest_instance;
}
function createClientPlugin(name, createConfiguration, body) {
  return new ClientPluginImpl(name, createConfiguration, body);
}
function createClientPlugin_0(name, body) {
  return createClientPlugin(name, createClientPlugin$lambda, body);
}
function ClientPluginImpl(name, createConfiguration, body) {
  this.d5k_1 = createConfiguration;
  this.e5k_1 = body;
  var tmp = this;
  // Inline function 'io.ktor.util.AttributeKey' call
  // Inline function 'io.ktor.util.reflect.typeInfo' call
  var tmp_0 = getKClass(ClientPluginInstance);
  // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
  var tmp_1;
  try {
    tmp_1 = createKType(getKClass(ClientPluginInstance), arrayOf([createInvariantKTypeProjection(createKType(createKTypeParameter('PluginConfigT', arrayOf([createKType(PrimitiveClasses_getInstance().ab(), arrayOf([]), false)]), 'invariant', false, 'io.ktor.client.plugins.api.ClientPluginImpl'), arrayOf([]), false))]), false);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_1 = tmp_2;
  }
  var tmp$ret$0 = tmp_1;
  var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$0);
  tmp.f5k_1 = new AttributeKey(name, tmp$ret$1);
}
protoOf(ClientPluginImpl).v = function () {
  return this.f5k_1;
};
protoOf(ClientPluginImpl).g5k = function (block) {
  // Inline function 'kotlin.apply' call
  var this_0 = this.d5k_1();
  block(this_0);
  var config = this_0;
  return new ClientPluginInstance(this.f5k_1, config, this.e5k_1);
};
protoOf(ClientPluginImpl).i4r = function (block) {
  return this.g5k(block);
};
protoOf(ClientPluginImpl).h5k = function (plugin, scope) {
  plugin.k4q(scope);
};
protoOf(ClientPluginImpl).j4r = function (plugin, scope) {
  return this.h5k(plugin instanceof ClientPluginInstance ? plugin : THROW_CCE(), scope);
};
function createClientPlugin$lambda() {
  return Unit_instance;
}
function TransformRequestBodyContext() {
}
function TransformResponseBodyContext() {
}
function OnRequestContext() {
}
function RequestHook$install$slambda($handler, resultContinuation) {
  this.q5k_1 = $handler;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(RequestHook$install$slambda).x4o = function ($this$intercept, it, $completion) {
  var tmp = this.y4o($this$intercept, it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(RequestHook$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(RequestHook$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.q5k_1(new OnRequestContext(), this.r5k_1.a31_1, this.r5k_1.d30(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(RequestHook$install$slambda).y4o = function ($this$intercept, it, completion) {
  var i = new RequestHook$install$slambda(this.q5k_1, completion);
  i.r5k_1 = $this$intercept;
  i.s5k_1 = it;
  return i;
};
function RequestHook$install$slambda_0($handler, resultContinuation) {
  var i = new RequestHook$install$slambda($handler, resultContinuation);
  var l = function ($this$intercept, it, $completion) {
    return i.x4o($this$intercept, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function RequestHook() {
}
protoOf(RequestHook).t5k = function (client, handler) {
  var tmp = Phases_getInstance().g4x_1;
  client.e4o_1.e31(tmp, RequestHook$install$slambda_0(handler, null));
};
protoOf(RequestHook).k4x = function (client, handler) {
  return this.t5k(client, (!(handler == null) ? isSuspendFunction(handler, 3) : false) ? handler : THROW_CCE());
};
var RequestHook_instance;
function RequestHook_getInstance() {
  return RequestHook_instance;
}
function OnResponseContext() {
}
function ResponseHook$install$slambda($handler, resultContinuation) {
  this.c5l_1 = $handler;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(ResponseHook$install$slambda).w4x = function ($this$intercept, it, $completion) {
  var tmp = this.x4x($this$intercept, it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(ResponseHook$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.w4x(tmp, p2 instanceof HttpResponse ? p2 : THROW_CCE(), $completion);
};
protoOf(ResponseHook$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.c5l_1(new OnResponseContext(), this.d5l_1.d30(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(ResponseHook$install$slambda).x4x = function ($this$intercept, it, completion) {
  var i = new ResponseHook$install$slambda(this.c5l_1, completion);
  i.d5l_1 = $this$intercept;
  i.e5l_1 = it;
  return i;
};
function ResponseHook$install$slambda_0($handler, resultContinuation) {
  var i = new ResponseHook$install$slambda($handler, resultContinuation);
  var l = function ($this$intercept, it, $completion) {
    return i.w4x($this$intercept, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function ResponseHook() {
}
protoOf(ResponseHook).f5l = function (client, handler) {
  var tmp = Phases_getInstance_1().a4y_1;
  client.h4o_1.e31(tmp, ResponseHook$install$slambda_0(handler, null));
};
protoOf(ResponseHook).k4x = function (client, handler) {
  return this.f5l(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
};
var ResponseHook_instance;
function ResponseHook_getInstance() {
  return ResponseHook_instance;
}
function TransformRequestBodyHook$install$slambda($handler, resultContinuation) {
  this.o5l_1 = $handler;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(TransformRequestBodyHook$install$slambda).x4o = function ($this$intercept, it, $completion) {
  var tmp = this.y4o($this$intercept, it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(TransformRequestBodyHook$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(TransformRequestBodyHook$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          this.d8_1 = 1;
          suspendResult = this.o5l_1(new TransformRequestBodyContext(), this.p5l_1.a31_1, this.p5l_1.d30(), this.p5l_1.a31_1.r5l(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var newContent = suspendResult;
          if (!(newContent == null)) {
            this.d8_1 = 2;
            suspendResult = this.p5l_1.e30(newContent, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.d8_1 = 3;
            continue $sm;
          }

        case 2:
          this.d8_1 = 3;
          continue $sm;
        case 3:
          return Unit_instance;
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(TransformRequestBodyHook$install$slambda).y4o = function ($this$intercept, it, completion) {
  var i = new TransformRequestBodyHook$install$slambda(this.o5l_1, completion);
  i.p5l_1 = $this$intercept;
  i.q5l_1 = it;
  return i;
};
function TransformRequestBodyHook$install$slambda_0($handler, resultContinuation) {
  var i = new TransformRequestBodyHook$install$slambda($handler, resultContinuation);
  var l = function ($this$intercept, it, $completion) {
    return i.x4o($this$intercept, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function TransformRequestBodyHook() {
}
protoOf(TransformRequestBodyHook).s5l = function (client, handler) {
  var tmp = Phases_getInstance().h4x_1;
  client.e4o_1.e31(tmp, TransformRequestBodyHook$install$slambda_0(handler, null));
};
protoOf(TransformRequestBodyHook).k4x = function (client, handler) {
  return this.s5l(client, (!(handler == null) ? isSuspendFunction(handler, 4) : false) ? handler : THROW_CCE());
};
var TransformRequestBodyHook_instance;
function TransformRequestBodyHook_getInstance() {
  return TransformRequestBodyHook_instance;
}
function TransformResponseBodyHook$install$slambda($handler, resultContinuation) {
  this.b5m_1 = $handler;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(TransformResponseBodyHook$install$slambda).r4p = function ($this$intercept, it, $completion) {
  var tmp = this.s4p($this$intercept, it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(TransformResponseBodyHook$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.r4p(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
};
protoOf(TransformResponseBodyHook$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          var _destruct__k2r9zo = this.c5m_1.d30();
          this.e5m_1 = _destruct__k2r9zo.wf();
          var content = _destruct__k2r9zo.xf();
          if (!isInterface(content, ByteReadChannel))
            return Unit_instance;
          this.d8_1 = 1;
          suspendResult = this.b5m_1(new TransformResponseBodyContext(), this.c5m_1.a31_1.m47(), content, this.e5m_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp0_elvis_lhs = suspendResult;
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }

          var newContent = tmp_0;
          var tmp_1;
          if (!(newContent instanceof NullBody)) {
            tmp_1 = !this.e5m_1.r31_1.fa(newContent);
          } else {
            tmp_1 = false;
          }

          if (tmp_1) {
            throw IllegalStateException_init_$Create$('transformResponseBody returned ' + toString(newContent) + ' but expected value of type ' + this.e5m_1.toString());
          }

          this.d8_1 = 2;
          suspendResult = this.c5m_1.e30(new HttpResponseContainer(this.e5m_1, newContent), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(TransformResponseBodyHook$install$slambda).s4p = function ($this$intercept, it, completion) {
  var i = new TransformResponseBodyHook$install$slambda(this.b5m_1, completion);
  i.c5m_1 = $this$intercept;
  i.d5m_1 = it;
  return i;
};
function TransformResponseBodyHook$install$slambda_0($handler, resultContinuation) {
  var i = new TransformResponseBodyHook$install$slambda($handler, resultContinuation);
  var l = function ($this$intercept, it, $completion) {
    return i.r4p($this$intercept, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function TransformResponseBodyHook() {
}
protoOf(TransformResponseBodyHook).f5m = function (client, handler) {
  var tmp = Phases_getInstance_2().d4r_1;
  client.f4o_1.e31(tmp, TransformResponseBodyHook$install$slambda_0(handler, null));
};
protoOf(TransformResponseBodyHook).k4x = function (client, handler) {
  return this.f5m(client, (!(handler == null) ? isSuspendFunction(handler, 4) : false) ? handler : THROW_CCE());
};
var TransformResponseBodyHook_instance;
function TransformResponseBodyHook_getInstance() {
  return TransformResponseBodyHook_instance;
}
function CookieWithTimestamp(cookie, createdAt) {
  this.g5m_1 = cookie;
  this.h5m_1 = createdAt;
}
protoOf(CookieWithTimestamp).wf = function () {
  return this.g5m_1;
};
protoOf(CookieWithTimestamp).xf = function () {
  return this.h5m_1;
};
protoOf(CookieWithTimestamp).toString = function () {
  return 'CookieWithTimestamp(cookie=' + this.g5m_1.toString() + ', createdAt=' + this.h5m_1.toString() + ')';
};
protoOf(CookieWithTimestamp).hashCode = function () {
  var result = this.g5m_1.hashCode();
  result = imul(result, 31) + getBigIntHashCode(this.h5m_1) | 0;
  return result;
};
protoOf(CookieWithTimestamp).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CookieWithTimestamp))
    return false;
  if (!this.g5m_1.equals(other.g5m_1))
    return false;
  if (!(this.h5m_1 === other.h5m_1))
    return false;
  return true;
};
function cleanup($this, timestamp) {
  removeAll($this.j5m_1, AcceptAllCookiesStorage$cleanup$lambda($this, timestamp));
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 9223372036854775807n;
  var _iterator__ex2g4s = $this.j5m_1.l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    var acc = accumulator;
    var cookie = element.wf();
    var createdAt = element.xf();
    var tmp0_safe_receiver = maxAgeOrExpires($this, cookie, createdAt);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.math.min' call
      tmp = acc <= tmp0_safe_receiver ? acc : tmp0_safe_receiver;
    }
    var tmp1_elvis_lhs = tmp;
    accumulator = tmp1_elvis_lhs == null ? acc : tmp1_elvis_lhs;
  }
  var newOldest = accumulator;
  $this.k5m_1.kotlinx$atomicfu$value = newOldest;
}
function maxAgeOrExpires($this, _this__u8e3s4, createdAt) {
  var tmp0_safe_receiver = _this__u8e3s4.o34_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = add(createdAt, multiply(numberToLong(tmp0_safe_receiver), 1000n));
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = _this__u8e3s4.p34_1;
    tmp_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.i2y_1;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  return tmp_0;
}
function AcceptAllCookiesStorage$_init_$lambda_odelxi() {
  return getTimeMillis();
}
function AcceptAllCookiesStorage$addCookie$lambda($cookie, $requestUrl) {
  return function (_destruct__k2r9zo) {
    var existingCookie = _destruct__k2r9zo.wf();
    return existingCookie.l34_1 === $cookie.l34_1 && matches(existingCookie, $requestUrl);
  };
}
function AcceptAllCookiesStorage$cleanup$lambda(this$0, $timestamp) {
  return function (_destruct__k2r9zo) {
    var cookie = _destruct__k2r9zo.wf();
    var createdAt = _destruct__k2r9zo.xf();
    var tmp0_elvis_lhs = maxAgeOrExpires(this$0, cookie, createdAt);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var expires = tmp;
    return expires < $timestamp;
  };
}
function $getCOROUTINE$(_this__u8e3s4, requestUrl, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.u5m_1 = _this__u8e3s4;
  this.v5m_1 = requestUrl;
}
protoOf($getCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.x5m_1 = this.u5m_1.l5m_1;
          var tmp_0 = this;
          tmp_0.w5m_1 = null;
          this.d8_1 = 1;
          suspendResult = this.x5m_1.a2h(this.w5m_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp$ret$0 = Unit_instance;
          l$ret$1: do {
            var tmp_1;
            try {
              var now = this.u5m_1.i5m_1();
              if (now >= this.u5m_1.k5m_1.kotlinx$atomicfu$value) {
                cleanup(this.u5m_1, now);
              }
              var tmp0 = this.u5m_1.j5m_1;
              var destination = ArrayList_init_$Create$();
              var _iterator__ex2g4s = tmp0.l();
              while (_iterator__ex2g4s.m()) {
                var element = _iterator__ex2g4s.n();
                if (matches(element.g5m_1, this.v5m_1)) {
                  destination.j(element);
                }
              }
              var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
              var _iterator__ex2g4s_0 = destination.l();
              while (_iterator__ex2g4s_0.m()) {
                var item = _iterator__ex2g4s_0.n();
                destination_0.j(item.g5m_1);
              }
              var cookies = destination_0;
              tmp$ret$0 = cookies;
              break l$ret$1;
            } catch ($p) {
              var tmp_2;
              var t = $p;
              this.x5m_1.m2g(this.w5m_1);
              throw t;
            }
          }
           while (false);
          var tmp_3 = tmp$ret$0;
          this.x5m_1.m2g(this.w5m_1);
          return tmp_3;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $addCookieCOROUTINE$(_this__u8e3s4, requestUrl, cookie, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.g5n_1 = _this__u8e3s4;
  this.h5n_1 = requestUrl;
  this.i5n_1 = cookie;
}
protoOf($addCookieCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          var $this$with = this.i5n_1;
          if (isBlank($this$with.l34_1))
            return Unit_instance;
          this.k5n_1 = this.g5n_1.l5m_1;
          var tmp_0 = this;
          tmp_0.j5n_1 = null;
          this.d8_1 = 1;
          suspendResult = this.k5n_1.a2h(this.j5n_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          l$ret$1: do {
            var tmp_1;
            try {
              removeAll(this.g5n_1.j5m_1, AcceptAllCookiesStorage$addCookie$lambda(this.i5n_1, this.h5n_1));
              var createdAt = this.g5n_1.i5m_1();
              this.g5n_1.j5m_1.j(new CookieWithTimestamp(fillDefaults(this.i5n_1, this.h5n_1), createdAt));
              var tmp0_safe_receiver = maxAgeOrExpires(this.g5n_1, this.i5n_1, createdAt);
              var tmp_2;
              if (tmp0_safe_receiver == null) {
                tmp_2 = null;
              } else {
                if (this.g5n_1.k5m_1.kotlinx$atomicfu$value > tmp0_safe_receiver) {
                  this.g5n_1.k5m_1.kotlinx$atomicfu$value = tmp0_safe_receiver;
                }
                tmp_2 = Unit_instance;
              }
              break l$ret$1;
            } catch ($p) {
              var tmp_3;
              var t = $p;
              this.k5n_1.m2g(this.j5n_1);
              throw t;
            }
          }
           while (false);
          this.k5n_1.m2g(this.j5n_1);
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function AcceptAllCookiesStorage(clock) {
  var tmp;
  if (clock === VOID) {
    tmp = AcceptAllCookiesStorage$_init_$lambda_odelxi;
  } else {
    tmp = clock;
  }
  clock = tmp;
  this.i5m_1 = clock;
  var tmp_0 = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp_0.j5m_1 = ArrayList_init_$Create$();
  this.k5m_1 = atomic$long$1(0n);
  this.l5m_1 = Mutex();
}
protoOf(AcceptAllCookiesStorage).l5n = function (requestUrl, $completion) {
  var tmp = new $getCOROUTINE$(this, requestUrl, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(AcceptAllCookiesStorage).m5n = function (requestUrl, cookie, $completion) {
  var tmp = new $addCookieCOROUTINE$(this, requestUrl, cookie, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(AcceptAllCookiesStorage).i3 = function () {
};
function matches(_this__u8e3s4, requestUrl) {
  var tmp0_safe_receiver = _this__u8e3s4.q34_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : toLowerCasePreservingASCIIRules(tmp0_safe_receiver);
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : trimStart(tmp1_safe_receiver, charArrayOf([_Char___init__impl__6a9atx(46)]));
  var tmp;
  if (tmp2_elvis_lhs == null) {
    var message = 'Domain field should have the default value';
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp = tmp2_elvis_lhs;
  }
  var domain = tmp;
  // Inline function 'kotlin.with' call
  _this__u8e3s4.r34_1;
  var tmp0_elvis_lhs = _this__u8e3s4.r34_1;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    var message_0 = 'Path field should have the default value';
    throw IllegalStateException_init_$Create$(toString(message_0));
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var current = tmp_0;
  var path = endsWith(current, _Char___init__impl__6a9atx(47)) ? current : '' + _this__u8e3s4.r34_1 + '/';
  var host = toLowerCasePreservingASCIIRules(requestUrl.g3d_1);
  // Inline function 'kotlin.let' call
  var pathInRequest = requestUrl.t3e();
  var requestPath = endsWith(pathInRequest, _Char___init__impl__6a9atx(47)) ? pathInRequest : pathInRequest + '/';
  if (!(host === domain) && (hostIsIp(host) || !endsWith_0(host, '.' + domain))) {
    return false;
  }
  if (!(path === '/') && !(requestPath === path) && !startsWith(requestPath, path)) {
    return false;
  }
  return !(_this__u8e3s4.s34_1 && !isSecure(requestUrl.s3d_1));
}
function fillDefaults(_this__u8e3s4, requestUrl) {
  var result = _this__u8e3s4;
  var tmp0_safe_receiver = result.r34_1;
  if (!((tmp0_safe_receiver == null ? null : startsWith(tmp0_safe_receiver, '/')) === true)) {
    result = result.w34(VOID, VOID, VOID, VOID, VOID, VOID, requestUrl.t3e());
  }
  // Inline function 'kotlin.text.isNullOrBlank' call
  var this_0 = result.q34_1;
  if (this_0 == null || isBlank(this_0)) {
    result = result.w34(VOID, VOID, VOID, VOID, VOID, requestUrl.g3d_1);
  }
  return result;
}
function get_LOGGER_9() {
  _init_properties_HttpCookies_kt__vu19yt();
  return LOGGER_8;
}
var LOGGER_8;
function HttpCookies$Companion$install$slambda($plugin, resultContinuation) {
  this.v5n_1 = $plugin;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpCookies$Companion$install$slambda).x4o = function ($this$intercept, it, $completion) {
  var tmp = this.y4o($this$intercept, it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpCookies$Companion$install$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpCookies$Companion$install$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.v5n_1.b5o(this.w5n_1.a31_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpCookies$Companion$install$slambda).y4o = function ($this$intercept, it, completion) {
  var i = new HttpCookies$Companion$install$slambda(this.v5n_1, completion);
  i.w5n_1 = $this$intercept;
  i.x5n_1 = it;
  return i;
};
function HttpCookies$Companion$install$slambda_0($plugin, resultContinuation) {
  var i = new HttpCookies$Companion$install$slambda($plugin, resultContinuation);
  var l = function ($this$intercept, it, $completion) {
    return i.x4o($this$intercept, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function HttpCookies$Companion$install$slambda_1($plugin, resultContinuation) {
  this.k5o_1 = $plugin;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpCookies$Companion$install$slambda_1).x4o = function ($this$intercept, it, $completion) {
  var tmp = this.y4o($this$intercept, it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpCookies$Companion$install$slambda_1).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.x4o(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpCookies$Companion$install$slambda_1).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.k5o_1.n5o(this.l5o_1.a31_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpCookies$Companion$install$slambda_1).y4o = function ($this$intercept, it, completion) {
  var i = new HttpCookies$Companion$install$slambda_1(this.k5o_1, completion);
  i.l5o_1 = $this$intercept;
  i.m5o_1 = it;
  return i;
};
function HttpCookies$Companion$install$slambda_2($plugin, resultContinuation) {
  var i = new HttpCookies$Companion$install$slambda_1($plugin, resultContinuation);
  var l = function ($this$intercept, it, $completion) {
    return i.x4o($this$intercept, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function HttpCookies$Companion$install$slambda_3($plugin, resultContinuation) {
  this.w5o_1 = $plugin;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpCookies$Companion$install$slambda_3).w4x = function ($this$intercept, response, $completion) {
  var tmp = this.x4x($this$intercept, response, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpCookies$Companion$install$slambda_3).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
  return this.w4x(tmp, p2 instanceof HttpResponse ? p2 : THROW_CCE(), $completion);
};
protoOf(HttpCookies$Companion$install$slambda_3).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.w5o_1.z5o(this.y5o_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpCookies$Companion$install$slambda_3).x4x = function ($this$intercept, response, completion) {
  var i = new HttpCookies$Companion$install$slambda_3(this.w5o_1, completion);
  i.x5o_1 = $this$intercept;
  i.y5o_1 = response;
  return i;
};
function HttpCookies$Companion$install$slambda_4($plugin, resultContinuation) {
  var i = new HttpCookies$Companion$install$slambda_3($plugin, resultContinuation);
  var l = function ($this$intercept, response, $completion) {
    return i.w4x($this$intercept, response, $completion);
  };
  l.$arity = 2;
  return l;
}
function Config_0() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.a5p_1 = ArrayList_init_$Create$();
  this.b5p_1 = new AcceptAllCookiesStorage();
}
protoOf(Config_0).c5p = function () {
  return new HttpCookies(this.b5p_1, this.a5p_1);
};
function Companion_2() {
  Companion_instance_3 = this;
  var tmp = this;
  // Inline function 'io.ktor.util.AttributeKey' call
  var name = 'HttpCookies';
  // Inline function 'io.ktor.util.reflect.typeInfo' call
  var tmp_0 = getKClass(HttpCookies);
  // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
  var tmp_1;
  try {
    tmp_1 = createKType(getKClass(HttpCookies), arrayOf([]), false);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_1 = tmp_2;
  }
  var tmp$ret$0 = tmp_1;
  var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$0);
  tmp.d5p_1 = new AttributeKey(name, tmp$ret$1);
}
protoOf(Companion_2).e5p = function (block) {
  // Inline function 'kotlin.apply' call
  var this_0 = new Config_0();
  block(this_0);
  return this_0.c5p();
};
protoOf(Companion_2).i4r = function (block) {
  return this.e5p(block);
};
protoOf(Companion_2).v = function () {
  return this.d5p_1;
};
protoOf(Companion_2).f5p = function (plugin, scope) {
  var tmp = Phases_getInstance().g4x_1;
  scope.e4o_1.e31(tmp, HttpCookies$Companion$install$slambda_0(plugin, null));
  var tmp_0 = Phases_getInstance_0().m4q_1;
  scope.g4o_1.e31(tmp_0, HttpCookies$Companion$install$slambda_2(plugin, null));
  var tmp_1 = Phases_getInstance_1().a4y_1;
  scope.h4o_1.e31(tmp_1, HttpCookies$Companion$install$slambda_4(plugin, null));
};
protoOf(Companion_2).j4r = function (plugin, scope) {
  return this.f5p(plugin instanceof HttpCookies ? plugin : THROW_CCE(), scope);
};
var Companion_instance_3;
function Companion_getInstance_9() {
  if (Companion_instance_3 == null)
    new Companion_2();
  return Companion_instance_3;
}
function HttpCookies$initializer$slambda(this$0, resultContinuation) {
  this.o5p_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(HttpCookies$initializer$slambda).l2t = function ($this$launch, $completion) {
  var tmp = this.m2t($this$launch, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpCookies$initializer$slambda).x8 = function (p1, $completion) {
  return this.l2t((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(HttpCookies$initializer$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          this.q5p_1 = this.o5p_1.z5n_1.l();
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!this.q5p_1.m()) {
            this.d8_1 = 3;
            continue $sm;
          }

          var element = this.q5p_1.n();
          this.d8_1 = 2;
          suspendResult = element(this.o5p_1.y5n_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.d8_1 = 1;
          continue $sm;
        case 3:
          return Unit_instance;
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(HttpCookies$initializer$slambda).m2t = function ($this$launch, completion) {
  var i = new HttpCookies$initializer$slambda(this.o5p_1, completion);
  i.p5p_1 = $this$launch;
  return i;
};
function HttpCookies$initializer$slambda_0(this$0, resultContinuation) {
  var i = new HttpCookies$initializer$slambda(this$0, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.l2t($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function $getCOROUTINE$_0(_this__u8e3s4, requestUrl, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.z5p_1 = _this__u8e3s4;
  this.a5q_1 = requestUrl;
}
protoOf($getCOROUTINE$_0).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          this.d8_1 = 1;
          suspendResult = this.z5p_1.a5o_1.l1y(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.d8_1 = 2;
          suspendResult = this.z5p_1.y5n_1.l5n(this.a5q_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $captureHeaderCookiesCOROUTINE$(_this__u8e3s4, builder, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.j5q_1 = _this__u8e3s4;
  this.k5q_1 = builder;
}
protoOf($captureHeaderCookiesCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 5;
          var $this$with = this.k5q_1;
          this.m5q_1 = clone(this.k5q_1.d4q_1).z1m();
          var tmp0_safe_receiver = $this$with.f4q_1.g1c(HttpHeaders_getInstance().e36_1);
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            get_LOGGER_9().y31('Saving cookie ' + tmp0_safe_receiver + ' for ' + this.k5q_1.d4q_1.toString());
            var this_0 = parseClientCookiesHeader(tmp0_safe_receiver);
            var destination = ArrayList_init_$Create$_0(this_0.o());
            var _iterator__ex2g4s = this_0.u().l();
            while (_iterator__ex2g4s.m()) {
              var item = _iterator__ex2g4s.n();
              var name = item.v();
              var encodedValue = item.w();
              destination.j(new Cookie(name, encodedValue, CookieEncoding_RAW_getInstance()));
            }
            tmp_0 = destination;
          }

          var cookies = tmp_0;
          if (cookies == null) {
            this.l5q_1 = null;
            this.d8_1 = 4;
            continue $sm;
          } else {
            this.n5q_1 = cookies.l();
            this.d8_1 = 1;
            continue $sm;
          }

        case 1:
          if (!this.n5q_1.m()) {
            this.d8_1 = 3;
            continue $sm;
          }

          var element = this.n5q_1.n();
          this.d8_1 = 2;
          suspendResult = this.j5q_1.y5n_1.m5n(this.m5q_1, element, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.d8_1 = 1;
          continue $sm;
        case 3:
          this.l5q_1 = Unit_instance;
          this.d8_1 = 4;
          continue $sm;
        case 4:
          return Unit_instance;
        case 5:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 5) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $sendCookiesWithCOROUTINE$(_this__u8e3s4, builder, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.w5q_1 = _this__u8e3s4;
  this.x5q_1 = builder;
}
protoOf($sendCookiesWithCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.w5q_1.l5n(clone(this.x5q_1.d4q_1).z1m(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var cookies = suspendResult;
          var $this$with = this.x5q_1;
          if (!cookies.q()) {
            var cookieHeader = renderClientCookies(cookies);
            $this$with.f4q_1.g2x(HttpHeaders_getInstance().e36_1, cookieHeader);
            get_LOGGER_9().y31('Sending cookie ' + cookieHeader + ' for ' + this.x5q_1.d4q_1.toString());
          } else {
            $this$with.f4q_1.m2x(HttpHeaders_getInstance().e36_1);
          }

          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $saveCookiesFromCOROUTINE$(_this__u8e3s4, response, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.g5r_1 = _this__u8e3s4;
  this.h5r_1 = response;
}
protoOf($saveCookiesFromCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          this.i5r_1 = get_request(this.h5r_1).b3p();
          var tmp0_safe_receiver = this.h5r_1.q39().d2x(HttpHeaders_getInstance().b38_1);
          if (tmp0_safe_receiver == null)
            null;
          else {
            var _iterator__ex2g4s = tmp0_safe_receiver.l();
            while (_iterator__ex2g4s.m()) {
              var element = _iterator__ex2g4s.n();
              get_LOGGER_9().y31('Received cookie ' + element + ' in response for ' + this.h5r_1.s4r().l4r().b3p().toString());
            }
          }

          this.j5r_1 = setCookie(this.h5r_1).l();
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!this.j5r_1.m()) {
            this.d8_1 = 3;
            continue $sm;
          }

          var element_0 = this.j5r_1.n();
          this.d8_1 = 2;
          suspendResult = this.g5r_1.y5n_1.m5n(this.i5r_1, element_0, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.d8_1 = 1;
          continue $sm;
        case 3:
          return Unit_instance;
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function HttpCookies(storage, defaults) {
  Companion_getInstance_9();
  this.y5n_1 = storage;
  this.z5n_1 = defaults;
  var tmp = this;
  var tmp_0 = GlobalScope_instance;
  var tmp_1 = Dispatchers_getInstance().l24_1;
  tmp.a5o_1 = launch(tmp_0, tmp_1, VOID, HttpCookies$initializer$slambda_0(this, null));
}
protoOf(HttpCookies).l5n = function (requestUrl, $completion) {
  var tmp = new $getCOROUTINE$_0(this, requestUrl, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpCookies).b5o = function (builder, $completion) {
  var tmp = new $captureHeaderCookiesCOROUTINE$(this, builder, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpCookies).n5o = function (builder, $completion) {
  var tmp = new $sendCookiesWithCOROUTINE$(this, builder, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpCookies).z5o = function (response, $completion) {
  var tmp = new $saveCookiesFromCOROUTINE$(this, response, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpCookies).i3 = function () {
  this.y5n_1.i3();
};
function renderClientCookies(cookies) {
  _init_properties_HttpCookies_kt__vu19yt();
  return joinToString(cookies, '; ', VOID, VOID, VOID, VOID, renderCookieHeader$ref());
}
function renderCookieHeader$ref() {
  var l = function (p0) {
    return renderCookieHeader(p0);
  };
  l.callableName = 'renderCookieHeader';
  return l;
}
var properties_initialized_HttpCookies_kt_8twc09;
function _init_properties_HttpCookies_kt__vu19yt() {
  if (!properties_initialized_HttpCookies_kt_8twc09) {
    properties_initialized_HttpCookies_kt_8twc09 = true;
    LOGGER_8 = KtorSimpleLogger('io.ktor.client.plugins.HttpCookies');
  }
}
function ClientSSESession(call, delegate) {
  this.k5r_1 = delegate;
  this.l5r_1 = call;
}
protoOf(ClientSSESession).f1x = function () {
  return this.k5r_1.f1x();
};
function ClientSSESessionWithDeserialization(call, delegate) {
  this.m5r_1 = delegate;
  this.n5r_1 = call;
}
protoOf(ClientSSESessionWithDeserialization).f1x = function () {
  return this.m5r_1.f1x();
};
function SSECapability() {
}
protoOf(SSECapability).toString = function () {
  return 'SSECapability';
};
protoOf(SSECapability).hashCode = function () {
  return -177755299;
};
protoOf(SSECapability).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SSECapability))
    return false;
  return true;
};
var SSECapability_instance;
function SSECapability_getInstance() {
  return SSECapability_instance;
}
function SSEClientContent() {
}
function WebSocketCapability() {
}
protoOf(WebSocketCapability).toString = function () {
  return 'WebSocketCapability';
};
protoOf(WebSocketCapability).hashCode = function () {
  return -1146563391;
};
protoOf(WebSocketCapability).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WebSocketCapability))
    return false;
  return true;
};
var WebSocketCapability_instance;
function WebSocketCapability_getInstance() {
  return WebSocketCapability_instance;
}
function WebSocketException_init_$Init$(message, $this) {
  WebSocketException.call($this, message, null);
  return $this;
}
function WebSocketException_init_$Create$(message) {
  var tmp = WebSocketException_init_$Init$(message, objectCreate(protoOf(WebSocketException)));
  captureStack(tmp, WebSocketException_init_$Create$);
  return tmp;
}
function WebSocketException(message, cause) {
  IllegalStateException_init_$Init$_1(message, cause, this);
  captureStack(this, WebSocketException);
}
function ClientUpgradeContent() {
}
function DefaultHttpRequest(call, data) {
  this.o5r_1 = call;
  this.p5r_1 = data.z4u_1;
  this.q5r_1 = data.y4u_1;
  this.r5r_1 = data.b4v_1;
  this.s5r_1 = data.a4v_1;
  this.t5r_1 = data.d4v_1;
}
protoOf(DefaultHttpRequest).s4r = function () {
  return this.o5r_1;
};
protoOf(DefaultHttpRequest).f1x = function () {
  return this.s4r().f1x();
};
protoOf(DefaultHttpRequest).t4r = function () {
  return this.p5r_1;
};
protoOf(DefaultHttpRequest).b3p = function () {
  return this.q5r_1;
};
protoOf(DefaultHttpRequest).q39 = function () {
  return this.s5r_1;
};
protoOf(DefaultHttpRequest).m4r = function () {
  return this.t5r_1;
};
function get_ResponseAdapterAttributeKey() {
  _init_properties_HttpRequest_kt__813lx1();
  return ResponseAdapterAttributeKey;
}
var ResponseAdapterAttributeKey;
function Companion_3() {
}
var Companion_instance_4;
function Companion_getInstance_10() {
  return Companion_instance_4;
}
function HttpRequestBuilder$setCapability$lambda() {
  // Inline function 'kotlin.collections.mutableMapOf' call
  return LinkedHashMap_init_$Create$();
}
function HttpRequestBuilder() {
  this.d4q_1 = new URLBuilder_0();
  this.e4q_1 = Companion_getInstance_2().r39_1;
  this.f4q_1 = new HeadersBuilder();
  this.g4q_1 = EmptyContent_getInstance();
  this.h4q_1 = SupervisorJob();
  this.i4q_1 = AttributesJsFn(true);
}
protoOf(HttpRequestBuilder).q39 = function () {
  return this.f4q_1;
};
protoOf(HttpRequestBuilder).u4v = function (value) {
  if (!(value == null)) {
    this.i4q_1.o2v(get_BodyTypeAttributeKey(), value);
  } else {
    this.i4q_1.p2v(get_BodyTypeAttributeKey());
  }
};
protoOf(HttpRequestBuilder).r5l = function () {
  return this.i4q_1.m2v(get_BodyTypeAttributeKey());
};
protoOf(HttpRequestBuilder).z1m = function () {
  var tmp = this.d4q_1.z1m();
  var tmp_0 = this.e4q_1;
  var tmp_1 = this.f4q_1.z1m();
  var tmp_2 = this.g4q_1;
  var tmp0_elvis_lhs = tmp_2 instanceof OutgoingContent ? tmp_2 : null;
  var tmp_3;
  if (tmp0_elvis_lhs == null) {
    var message = 'No request transformation found: ' + toString(this.g4q_1);
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp_3 = tmp0_elvis_lhs;
  }
  return new HttpRequestData(tmp, tmp_0, tmp_1, tmp_3, this.h4q_1, this.i4q_1);
};
protoOf(HttpRequestBuilder).t4v = function (builder) {
  this.h4q_1 = builder.h4q_1;
  return this.f5d(builder);
};
protoOf(HttpRequestBuilder).f5d = function (builder) {
  this.e4q_1 = builder.e4q_1;
  this.g4q_1 = builder.g4q_1;
  this.u4v(builder.r5l());
  takeFrom(this.d4q_1, builder.d4q_1);
  this.d4q_1.a3d_1 = this.d4q_1.a3d_1;
  appendAll(this.f4q_1, builder.f4q_1);
  putAll(this.i4q_1, builder.i4q_1);
  return this;
};
protoOf(HttpRequestBuilder).h5h = function (key, capability) {
  var tmp = get_ENGINE_CAPABILITIES_KEY();
  var capabilities = this.i4q_1.q2v(tmp, HttpRequestBuilder$setCapability$lambda);
  // Inline function 'kotlin.collections.set' call
  capabilities.a2(key, capability);
};
protoOf(HttpRequestBuilder).g5g = function (key) {
  var tmp0_safe_receiver = this.i4q_1.m2v(get_ENGINE_CAPABILITIES_KEY());
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h2(key);
  return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
};
function HttpRequest_0() {
}
function HttpRequestData(url, method, headers, body, executionContext, attributes) {
  this.y4u_1 = url;
  this.z4u_1 = method;
  this.a4v_1 = headers;
  this.b4v_1 = body;
  this.c4v_1 = executionContext;
  this.d4v_1 = attributes;
  var tmp = this;
  var tmp0_safe_receiver = this.d4v_1.m2v(get_ENGINE_CAPABILITIES_KEY());
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d2();
  tmp.e4v_1 = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
}
protoOf(HttpRequestData).toString = function () {
  return 'HttpRequestData(url=' + this.y4u_1.toString() + ', method=' + this.z4u_1.toString() + ')';
};
function ResponseAdapter() {
}
function HttpResponseData(statusCode, requestTime, headers, version, body, callContext) {
  this.d4s_1 = statusCode;
  this.e4s_1 = requestTime;
  this.f4s_1 = headers;
  this.g4s_1 = version;
  this.h4s_1 = body;
  this.i4s_1 = callContext;
  this.j4s_1 = GMTDate();
}
protoOf(HttpResponseData).toString = function () {
  return 'HttpResponseData=(statusCode=' + this.d4s_1.toString() + ')';
};
function isUpgradeRequest(_this__u8e3s4) {
  _init_properties_HttpRequest_kt__813lx1();
  var tmp = _this__u8e3s4.b4v_1;
  return tmp instanceof ClientUpgradeContent;
}
var properties_initialized_HttpRequest_kt_zh09pz;
function _init_properties_HttpRequest_kt__813lx1() {
  if (!properties_initialized_HttpRequest_kt_zh09pz) {
    properties_initialized_HttpRequest_kt_zh09pz = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ResponseAdapterAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(ResponseAdapter);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(ResponseAdapter), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$0 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$0);
    ResponseAdapterAttributeKey = new AttributeKey(name, tmp$ret$1);
  }
}
function Phases() {
  Phases_instance = this;
  this.f4x_1 = new PipelinePhase('Before');
  this.g4x_1 = new PipelinePhase('State');
  this.h4x_1 = new PipelinePhase('Transform');
  this.i4x_1 = new PipelinePhase('Render');
  this.j4x_1 = new PipelinePhase('Send');
}
var Phases_instance;
function Phases_getInstance() {
  if (Phases_instance == null)
    new Phases();
  return Phases_instance;
}
function HttpRequestPipeline(developmentMode) {
  Phases_getInstance();
  developmentMode = developmentMode === VOID ? true : developmentMode;
  Pipeline.call(this, [Phases_getInstance().f4x_1, Phases_getInstance().g4x_1, Phases_getInstance().h4x_1, Phases_getInstance().i4x_1, Phases_getInstance().j4x_1]);
  this.c5s_1 = developmentMode;
}
protoOf(HttpRequestPipeline).y30 = function () {
  return this.c5s_1;
};
function Phases_0() {
  Phases_instance_0 = this;
  this.l4q_1 = new PipelinePhase('Before');
  this.m4q_1 = new PipelinePhase('State');
  this.n4q_1 = new PipelinePhase('Monitoring');
  this.o4q_1 = new PipelinePhase('Engine');
  this.p4q_1 = new PipelinePhase('Receive');
}
var Phases_instance_0;
function Phases_getInstance_0() {
  if (Phases_instance_0 == null)
    new Phases_0();
  return Phases_instance_0;
}
function HttpSendPipeline(developmentMode) {
  Phases_getInstance_0();
  developmentMode = developmentMode === VOID ? true : developmentMode;
  Pipeline.call(this, [Phases_getInstance_0().l4q_1, Phases_getInstance_0().m4q_1, Phases_getInstance_0().n4q_1, Phases_getInstance_0().o4q_1, Phases_getInstance_0().p4q_1]);
  this.k5s_1 = developmentMode;
}
protoOf(HttpSendPipeline).y30 = function () {
  return this.k5s_1;
};
function get_BodyTypeAttributeKey() {
  _init_properties_RequestBody_kt__bo3lwf();
  return BodyTypeAttributeKey;
}
var BodyTypeAttributeKey;
var properties_initialized_RequestBody_kt_agyv1b;
function _init_properties_RequestBody_kt__bo3lwf() {
  if (!properties_initialized_RequestBody_kt_agyv1b) {
    properties_initialized_RequestBody_kt_agyv1b = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'BodyTypeAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(TypeInfo);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(TypeInfo), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$0 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$0);
    BodyTypeAttributeKey = new AttributeKey(name, tmp$ret$1);
  }
}
function accept(_this__u8e3s4, contentType) {
  return _this__u8e3s4.q39().i2x(HttpHeaders_getInstance().l35_1, contentType.toString());
}
function header(_this__u8e3s4, key, value) {
  var tmp;
  if (value == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    _this__u8e3s4.q39().i2x(key, toString(value));
    tmp = Unit_instance;
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? Unit_instance : tmp1_elvis_lhs;
}
function bearerAuth(_this__u8e3s4, token) {
  return header(_this__u8e3s4, HttpHeaders_getInstance().u35_1, 'Bearer ' + token);
}
function DefaultHttpResponse(call, responseData) {
  HttpResponse.call(this);
  this.l5s_1 = call;
  this.m5s_1 = responseData.i4s_1;
  this.n5s_1 = responseData.d4s_1;
  this.o5s_1 = responseData.g4s_1;
  this.p5s_1 = responseData.e4s_1;
  this.q5s_1 = responseData.j4s_1;
  var tmp = this;
  var tmp_0 = responseData.h4s_1;
  var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel) ? tmp_0 : null;
  tmp.r5s_1 = tmp0_elvis_lhs == null ? Companion_getInstance().o2n_1 : tmp0_elvis_lhs;
  this.s5s_1 = responseData.f4s_1;
}
protoOf(DefaultHttpResponse).s4r = function () {
  return this.l5s_1;
};
protoOf(DefaultHttpResponse).f1x = function () {
  return this.m5s_1;
};
protoOf(DefaultHttpResponse).r3w = function () {
  return this.n5s_1;
};
protoOf(DefaultHttpResponse).r3t = function () {
  return this.o5s_1;
};
protoOf(DefaultHttpResponse).a4s = function () {
  return this.p5s_1;
};
protoOf(DefaultHttpResponse).b4s = function () {
  return this.q5s_1;
};
protoOf(DefaultHttpResponse).z4r = function () {
  return this.r5s_1;
};
protoOf(DefaultHttpResponse).q39 = function () {
  return this.s5s_1;
};
function HttpResponse() {
}
protoOf(HttpResponse).toString = function () {
  return 'HttpResponse[' + get_request(this).b3p().toString() + ', ' + this.r3w().toString() + ']';
};
function get_request(_this__u8e3s4) {
  return _this__u8e3s4.s4r().l4r();
}
function bodyAsText(_this__u8e3s4, fallbackCharset, $completion) {
  fallbackCharset = fallbackCharset === VOID ? Charsets_getInstance().g2u_1 : fallbackCharset;
  var tmp = new $bodyAsTextCOROUTINE$(_this__u8e3s4, fallbackCharset, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function $bodyAsTextCOROUTINE$(_this__u8e3s4, fallbackCharset, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.b5t_1 = _this__u8e3s4;
  this.c5t_1 = fallbackCharset;
}
protoOf($bodyAsTextCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          var tmp0_elvis_lhs = charset_0(this.b5t_1);
          var originCharset = tmp0_elvis_lhs == null ? this.c5t_1 : tmp0_elvis_lhs;
          this.d5t_1 = originCharset.j2u();
          var this_0 = this.b5t_1;
          this.d8_1 = 1;
          var tmp_0 = this_0.s4r();
          var tmp_1 = getKClass(Source);
          var tmp_2;
          try {
            tmp_2 = createKType(getKClass(Source), arrayOf([]), false);
          } catch ($p) {
            var tmp_3;
            if ($p instanceof Error) {
              var _unused_var__etf5q3 = $p;
              tmp_3 = null;
            } else {
              throw $p;
            }
            tmp_2 = tmp_3;
          }

          suspendResult = tmp_0.p4r(new TypeInfo(tmp_1, tmp_2), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var input = (!(suspendResult == null) ? isInterface(suspendResult, Source) : false) ? suspendResult : THROW_CCE();
          return decode(this.d5t_1, input);
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function Phases_1() {
  Phases_instance_1 = this;
  this.z4x_1 = new PipelinePhase('Before');
  this.a4y_1 = new PipelinePhase('State');
  this.b4y_1 = new PipelinePhase('After');
}
var Phases_instance_1;
function Phases_getInstance_1() {
  if (Phases_instance_1 == null)
    new Phases_1();
  return Phases_instance_1;
}
function HttpReceivePipeline(developmentMode) {
  Phases_getInstance_1();
  developmentMode = developmentMode === VOID ? true : developmentMode;
  Pipeline.call(this, [Phases_getInstance_1().z4x_1, Phases_getInstance_1().a4y_1, Phases_getInstance_1().b4y_1]);
  this.l5t_1 = developmentMode;
}
protoOf(HttpReceivePipeline).y30 = function () {
  return this.l5t_1;
};
function Phases_2() {
  Phases_instance_2 = this;
  this.b4r_1 = new PipelinePhase('Receive');
  this.c4r_1 = new PipelinePhase('Parse');
  this.d4r_1 = new PipelinePhase('Transform');
  this.e4r_1 = new PipelinePhase('State');
  this.f4r_1 = new PipelinePhase('After');
}
var Phases_instance_2;
function Phases_getInstance_2() {
  if (Phases_instance_2 == null)
    new Phases_2();
  return Phases_instance_2;
}
function HttpResponsePipeline(developmentMode) {
  Phases_getInstance_2();
  developmentMode = developmentMode === VOID ? true : developmentMode;
  Pipeline.call(this, [Phases_getInstance_2().b4r_1, Phases_getInstance_2().c4r_1, Phases_getInstance_2().d4r_1, Phases_getInstance_2().e4r_1, Phases_getInstance_2().f4r_1]);
  this.t5t_1 = developmentMode;
}
protoOf(HttpResponsePipeline).y30 = function () {
  return this.t5t_1;
};
function HttpResponseContainer(expectedType, response) {
  this.v4s_1 = expectedType;
  this.w4s_1 = response;
}
protoOf(HttpResponseContainer).wf = function () {
  return this.v4s_1;
};
protoOf(HttpResponseContainer).xf = function () {
  return this.w4s_1;
};
protoOf(HttpResponseContainer).toString = function () {
  return 'HttpResponseContainer(expectedType=' + this.v4s_1.toString() + ', response=' + toString(this.w4s_1) + ')';
};
protoOf(HttpResponseContainer).hashCode = function () {
  var result = this.v4s_1.hashCode();
  result = imul(result, 31) + hashCode(this.w4s_1) | 0;
  return result;
};
protoOf(HttpResponseContainer).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof HttpResponseContainer))
    return false;
  if (!this.v4s_1.equals(other.v4s_1))
    return false;
  if (!equals(this.w4s_1, other.w4s_1))
    return false;
  return true;
};
function $fetchResponseCOROUTINE$(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.c5u_1 = _this__u8e3s4;
}
protoOf($fetchResponseCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 7;
          this.d8_1 = 1;
          continue $sm;
        case 1:
          this.e8_1 = 6;
          var builder = (new HttpRequestBuilder()).t4v(this.c5u_1.g5u_1);
          this.d8_1 = 2;
          suspendResult = this.c5u_1.h5u_1.g4r(builder, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.f5u_1 = suspendResult;
          this.d8_1 = 3;
          suspendResult = save(this.f5u_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          this.e5u_1 = suspendResult.m47();
          this.d8_1 = 4;
          suspendResult = this.c5u_1.i5u(this.f5u_1.m47(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 4:
          var tmp_0 = this;
          return this.e5u_1;
        case 5:
          return this.d5u_1;
        case 6:
          this.e8_1 = 7;
          var tmp_1 = this.g8_1;
          if (tmp_1 instanceof CancellationException) {
            var cause = this.g8_1;
            throw unwrapCancellationException(cause);
          } else {
            throw this.g8_1;
          }

        case 7:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 7) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $cleanupCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.r5u_1 = _this__u8e3s4;
  this.s5u_1 = _this__u8e3s4_0;
}
protoOf($cleanupCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          var tmp_0 = get_job(this.s5u_1.f1x());
          var job = isInterface(tmp_0, CompletableJob) ? tmp_0 : THROW_CCE();
          this.t5u_1 = job;
          var $this$apply = this.t5u_1;
          $this$apply.b24();
          if (!get_isSaved(this.s5u_1)) {
            try {
              cancel_3(this.s5u_1.z4r());
            } catch ($p) {
              if ($p instanceof Error) {
                var _unused_var__etf5q3 = $p;
              } else {
                throw $p;
              }
            }
          }

          this.d8_1 = 1;
          suspendResult = $this$apply.l1y(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function HttpStatement(builder, client) {
  this.g5u_1 = builder;
  this.h5u_1 = client;
}
protoOf(HttpStatement).u5u = function ($completion) {
  return this.v5u($completion);
};
protoOf(HttpStatement).v5u = function ($completion) {
  var tmp = new $fetchResponseCOROUTINE$(this, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpStatement).i5u = function (_this__u8e3s4, $completion) {
  var tmp = new $cleanupCOROUTINE$(this, _this__u8e3s4, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(HttpStatement).toString = function () {
  return 'HttpStatement[' + this.g5u_1.d4q_1.toString() + ']';
};
function observable(_this__u8e3s4, context, contentLength, listener) {
  var tmp = GlobalScope_instance;
  return writer(tmp, context, true, observable$slambda_0(_this__u8e3s4, listener, contentLength, null)).n2s_1;
}
function observable$slambda($this_observable, $listener, $contentLength, resultContinuation) {
  this.e5v_1 = $this_observable;
  this.f5v_1 = $listener;
  this.g5v_1 = $contentLength;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(observable$slambda).n4m = function ($this$writer, $completion) {
  var tmp = this.o4m($this$writer, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(observable$slambda).x8 = function (p1, $completion) {
  return this.n4m(p1 instanceof WriterScope ? p1 : THROW_CCE(), $completion);
};
protoOf(observable$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 16;
          var tmp_0 = this;
          tmp_0.n5v_1 = get_ByteArrayPool();
          this.d8_1 = 1;
          continue $sm;
        case 1:
          this.j5v_1 = this.n5v_1;
          this.i5v_1 = this.j5v_1.v2u();
          this.d8_1 = 2;
          continue $sm;
        case 2:
          this.d8_1 = 3;
          continue $sm;
        case 3:
          this.e8_1 = 15;
          this.m5v_1 = this.i5v_1;
          this.k5v_1 = 0n;
          this.d8_1 = 4;
          continue $sm;
        case 4:
          if (!!this.e5v_1.r2l()) {
            this.d8_1 = 9;
            continue $sm;
          }

          this.d8_1 = 5;
          suspendResult = readAvailable(this.e5v_1, this.m5v_1, VOID, VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          this.l5v_1 = suspendResult;
          if (this.l5v_1 <= 0) {
            this.d8_1 = 4;
            continue $sm;
          } else {
            this.d8_1 = 6;
            continue $sm;
          }

        case 6:
          this.d8_1 = 7;
          suspendResult = writeFully(this.h5v_1.p2s_1, this.m5v_1, 0, this.l5v_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 7:
          var tmp_1 = this;
          var tmp0 = this.k5v_1;
          var other = this.l5v_1;
          tmp_1.k5v_1 = add(tmp0, fromInt(other));
          this.d8_1 = 8;
          suspendResult = this.f5v_1.z4t(this.k5v_1, this.g5v_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 8:
          this.d8_1 = 4;
          continue $sm;
        case 9:
          var closedCause = this.e5v_1.p2l();
          close(this.h5v_1.p2s_1, closedCause);
          if (closedCause == null && this.k5v_1 === 0n) {
            this.d8_1 = 10;
            suspendResult = this.f5v_1.z4t(this.k5v_1, this.g5v_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.d8_1 = 11;
            continue $sm;
          }

        case 10:
          this.d8_1 = 11;
          continue $sm;
        case 11:
          this.e8_1 = 16;
          this.d8_1 = 12;
          var tmp_2 = this;
          continue $sm;
        case 12:
          this.e8_1 = 16;
          this.j5v_1.w2u(this.i5v_1);
          this.d8_1 = 14;
          continue $sm;
        case 13:
          this.e8_1 = 16;
          this.j5v_1.w2u(this.i5v_1);
          if (false) {
            this.d8_1 = 1;
            continue $sm;
          }

          this.d8_1 = 14;
          continue $sm;
        case 14:
          return Unit_instance;
        case 15:
          this.e8_1 = 16;
          var t = this.g8_1;
          this.j5v_1.w2u(this.i5v_1);
          throw t;
        case 16:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 16) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(observable$slambda).o4m = function ($this$writer, completion) {
  var i = new observable$slambda(this.e5v_1, this.f5v_1, this.g5v_1, completion);
  i.h5v_1 = $this$writer;
  return i;
};
function observable$slambda_0($this_observable, $listener, $contentLength, resultContinuation) {
  var i = new observable$slambda($this_observable, $listener, $contentLength, resultContinuation);
  var l = function ($this$writer, $completion) {
    return i.n4m($this$writer, $completion);
  };
  l.$arity = 1;
  return l;
}
function get_HttpRequestCreated() {
  _init_properties_ClientEvents_kt__xuvbz8();
  return HttpRequestCreated;
}
var HttpRequestCreated;
function get_HttpRequestIsReadyForSending() {
  _init_properties_ClientEvents_kt__xuvbz8();
  return HttpRequestIsReadyForSending;
}
var HttpRequestIsReadyForSending;
function get_HttpResponseReceived() {
  _init_properties_ClientEvents_kt__xuvbz8();
  return HttpResponseReceived;
}
var HttpResponseReceived;
function get_HttpResponseReceiveFailed() {
  _init_properties_ClientEvents_kt__xuvbz8();
  return HttpResponseReceiveFailed;
}
var HttpResponseReceiveFailed;
function get_HttpResponseCancelled() {
  _init_properties_ClientEvents_kt__xuvbz8();
  return HttpResponseCancelled;
}
var HttpResponseCancelled;
function HttpResponseReceiveFail(response, cause) {
  this.o5v_1 = response;
  this.p5v_1 = cause;
}
var properties_initialized_ClientEvents_kt_rdee4m;
function _init_properties_ClientEvents_kt__xuvbz8() {
  if (!properties_initialized_ClientEvents_kt_rdee4m) {
    properties_initialized_ClientEvents_kt_rdee4m = true;
    HttpRequestCreated = new EventDefinition();
    HttpRequestIsReadyForSending = new EventDefinition();
    HttpResponseReceived = new EventDefinition();
    HttpResponseReceiveFailed = new EventDefinition();
    HttpResponseCancelled = new EventDefinition();
  }
}
function EmptyContent() {
  EmptyContent_instance = this;
  NoContent.call(this);
  this.r5v_1 = 0n;
}
protoOf(EmptyContent).h3f = function () {
  return this.r5v_1;
};
protoOf(EmptyContent).toString = function () {
  return 'EmptyContent';
};
protoOf(EmptyContent).hashCode = function () {
  return 1450860306;
};
protoOf(EmptyContent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EmptyContent))
    return false;
  return true;
};
var EmptyContent_instance;
function EmptyContent_getInstance() {
  if (EmptyContent_instance == null)
    new EmptyContent();
  return EmptyContent_instance;
}
function get_DecompressionListAttribute() {
  _init_properties_HeadersUtils_kt__fb6dxx();
  return DecompressionListAttribute;
}
var DecompressionListAttribute;
function dropCompressionHeaders(_this__u8e3s4, method, attributes, alwaysRemove) {
  alwaysRemove = alwaysRemove === VOID ? false : alwaysRemove;
  _init_properties_HeadersUtils_kt__fb6dxx();
  if (method.equals(Companion_getInstance_2().w39_1) || method.equals(Companion_getInstance_2().x39_1))
    return Unit_instance;
  var header = _this__u8e3s4.g1c(HttpHeaders_getInstance().y35_1);
  if (header == null) {
    if (!alwaysRemove)
      return Unit_instance;
  } else {
    var tmp = get_DecompressionListAttribute();
    attributes.q2v(tmp, dropCompressionHeaders$lambda).j(header);
  }
  _this__u8e3s4.m2x(HttpHeaders_getInstance().y35_1);
  _this__u8e3s4.m2x(HttpHeaders_getInstance().a36_1);
}
function dropCompressionHeaders$lambda() {
  _init_properties_HeadersUtils_kt__fb6dxx();
  // Inline function 'kotlin.collections.mutableListOf' call
  return ArrayList_init_$Create$();
}
var properties_initialized_HeadersUtils_kt_8c3zal;
function _init_properties_HeadersUtils_kt__fb6dxx() {
  if (!properties_initialized_HeadersUtils_kt_8c3zal) {
    properties_initialized_HeadersUtils_kt_8c3zal = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'DecompressionListAttribute';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(KtMutableList);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(KtMutableList), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lb(), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$0 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$0);
    DecompressionListAttribute = new AttributeKey(name, tmp$ret$1);
  }
}
function buildHeaders(block) {
  var tmp;
  if (block === VOID) {
    tmp = buildHeaders$lambda;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'kotlin.apply' call
  var this_0 = new HeadersBuilder();
  block(this_0);
  return this_0.z1m();
}
function buildHeaders$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Companion_4() {
  Companion_instance_5 = this;
  var tmp = this;
  // Inline function 'io.ktor.util.AttributeKey' call
  var name = 'FetchOptions';
  // Inline function 'io.ktor.util.reflect.typeInfo' call
  var tmp_0 = getKClass(FetchOptions);
  // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
  var tmp_1;
  try {
    tmp_1 = createKType(getKClass(FetchOptions), arrayOf([]), false);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_1 = tmp_2;
  }
  var tmp$ret$0 = tmp_1;
  var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$0);
  tmp.s5v_1 = new AttributeKey(name, tmp$ret$1);
}
var Companion_instance_5;
function Companion_getInstance_11() {
  if (Companion_instance_5 == null)
    new Companion_4();
  return Companion_instance_5;
}
function FetchOptions(requestInit) {
  Companion_getInstance_11();
  this.t5v_1 = requestInit;
}
function fetchOptions(_this__u8e3s4, block) {
  _this__u8e3s4.i4q_1.o2v(Companion_getInstance_11().s5v_1, new FetchOptions(block));
}
function get_initHook() {
  return initHook_0;
}
var initHook_0;
function Js() {
}
protoOf(Js).u5v = function (block) {
  // Inline function 'kotlin.apply' call
  var this_0 = new JsClientEngineConfig();
  block(this_0);
  return new JsClientEngine(this_0);
};
protoOf(Js).h4r = function (block) {
  return this.u5v(block);
};
protoOf(Js).toString = function () {
  return 'Js';
};
protoOf(Js).hashCode = function () {
  return -527824213;
};
protoOf(Js).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Js))
    return false;
  return true;
};
var Js_instance;
function Js_getInstance() {
  return Js_instance;
}
function JsClientEngineConfig$requestInit$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function JsClientEngineConfig() {
  HttpClientEngineConfig.call(this);
  var tmp = this;
  tmp.z5v_1 = JsClientEngineConfig$requestInit$lambda;
  this.a5w_1 = Object.create(null);
}
function initHook$init$() {
  engines_getInstance().c5w(Js_instance);
  return Unit_instance;
}
function createWebSocket($this, urlString_capturingHack, headers, $completion) {
  var tmp = new $createWebSocketCOROUTINE$($this, urlString_capturingHack, headers, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function executeWebSocketRequest($this, request, callContext, $completion) {
  var tmp = new $executeWebSocketRequestCOROUTINE$($this, request, callContext, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function JsClientEngine$execute$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function JsClientEngine$createWebSocket$headers_capturingHack$1() {
}
function JsClientEngine$createWebSocket$lambda($headers_capturingHack) {
  return function (name, values) {
    $headers_capturingHack[name] = joinToString(values, ',');
    return Unit_instance;
  };
}
function $executeCOROUTINE$_1(_this__u8e3s4, data, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.o5x_1 = _this__u8e3s4;
  this.p5x_1 = data;
}
protoOf($executeCOROUTINE$_1).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 6;
          this.d8_1 = 1;
          suspendResult = callContext(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.q5x_1 = suspendResult;
          this.s5x_1 = this.p5x_1.d4v_1.l2v(get_CLIENT_CONFIG());
          if (isUpgradeRequest(this.p5x_1)) {
            this.d8_1 = 5;
            suspendResult = executeWebSocketRequest(this.o5x_1, this.p5x_1, this.q5x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.d8_1 = 2;
            continue $sm;
          }

        case 2:
          this.r5x_1 = GMTDate();
          this.d8_1 = 3;
          suspendResult = toRaw(this.p5x_1, this.s5x_1, this.q5x_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          var rawRequest = suspendResult;
          var tmp0_safe_receiver = this.p5x_1.d4v_1.m2v(Companion_getInstance_11().s5v_1);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t5v_1;
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            tmp_0 = JsClientEngine$execute$lambda;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }

          var fetchOptions = tmp_0;
          this.d8_1 = 4;
          suspendResult = commonFetch(this.p5x_1.y4u_1.toString(), rawRequest, fetchOptions, this.o5x_1.x5x_1, get_job(this.q5x_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 4:
          var rawResponse = suspendResult;
          var status = new HttpStatusCode(rawResponse.status, rawResponse.statusText);
          var headers = mapToKtor(rawResponse.headers, this.p5x_1.z4u_1, this.p5x_1.d4v_1);
          var version = Companion_getInstance_3().c3a_1;
          var body = readBody(CoroutineScope_0(this.q5x_1), rawResponse);
          var tmp2_safe_receiver = this.p5x_1.d4v_1.m2v(get_ResponseAdapterAttributeKey());
          var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.u5r(this.p5x_1, status, headers, body, this.p5x_1.b4v_1, this.q5x_1);
          var responseBody = tmp3_elvis_lhs == null ? body : tmp3_elvis_lhs;
          return new HttpResponseData(status, this.r5x_1, headers, version, responseBody, this.q5x_1);
        case 5:
          return suspendResult;
        case 6:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 6) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $createWebSocketCOROUTINE$(_this__u8e3s4, urlString_capturingHack, headers, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.l5w_1 = _this__u8e3s4;
  this.m5w_1 = urlString_capturingHack;
  this.n5w_1 = headers;
}
protoOf($createWebSocketCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          var tmp0 = this.n5w_1.f2x();
          var destination = ArrayList_init_$Create$();
          var _iterator__ex2g4s = tmp0.l();
          while (_iterator__ex2g4s.m()) {
            var element = _iterator__ex2g4s.n();
            if (equals_0(element, HttpHeaders_getInstance().y37_1, true)) {
              destination.j(element);
            }
          }

          var protocolHeaderNames = destination;
          var tmp_0 = this;
          var destination_0 = ArrayList_init_$Create$();
          var _iterator__ex2g4s_0 = protocolHeaderNames.l();
          while (_iterator__ex2g4s_0.m()) {
            var element_0 = _iterator__ex2g4s_0.n();
            var tmp0_safe_receiver = this.n5w_1.d2x(element_0);
            if (tmp0_safe_receiver == null)
              null;
            else {
              destination_0.j(tmp0_safe_receiver);
            }
          }

          var this_0 = flatten(destination_0);
          tmp_0.p5w_1 = copyToArray(this_0);
          if (PlatformUtils_getInstance().p2w_1) {
            this.o5w_1 = new WebSocket(this.m5w_1, this.p5w_1);
            this.d8_1 = 2;
            continue $sm;
          } else {
            var ws_import = import('ws');
            this.d8_1 = 1;
            suspendResult = await_0(ws_import, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 1:
          var ws_capturingHack = suspendResult.default;
          var headers_capturingHack = new JsClientEngine$createWebSocket$headers_capturingHack$1();
          this.n5w_1.k2x(JsClientEngine$createWebSocket$lambda(headers_capturingHack));
          this.o5w_1 = new ws_capturingHack(this.m5w_1, this.p5w_1, {headers: headers_capturingHack});
          this.d8_1 = 2;
          continue $sm;
        case 2:
          return this.o5w_1;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $executeWebSocketRequestCOROUTINE$(_this__u8e3s4, request, callContext, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.y5w_1 = _this__u8e3s4;
  this.z5w_1 = request;
  this.a5x_1 = callContext;
}
protoOf($executeWebSocketRequestCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 5;
          this.c5x_1 = GMTDate();
          this.f5x_1 = this.z5w_1.y4u_1.toString();
          this.d8_1 = 1;
          suspendResult = createWebSocket(this.y5w_1, this.f5x_1, this.z5w_1.a4v_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.d5x_1 = suspendResult;
          this.b5x_1 = new JsWebSocketSession(this.a5x_1, this.d5x_1);
          this.e8_1 = 3;
          this.d8_1 = 2;
          suspendResult = awaitConnection(this.d5x_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.e5x_1 = suspendResult;
          this.e8_1 = 5;
          this.d8_1 = 4;
          continue $sm;
        case 3:
          this.e8_1 = 5;
          var tmp_0 = this.g8_1;
          if (tmp_0 instanceof Error) {
            var cause = this.g8_1;
            var tmp_1 = this;
            cancel_2(this.a5x_1, CancellationException_0('Failed to connect to ' + this.f5x_1, cause));
            throw cause;
          } else {
            throw this.g8_1;
          }

        case 4:
          this.e8_1 = 5;
          var this_0 = this.d5x_1.protocol;
          var tmp_2;
          if (charSequenceLength(this_0) > 0) {
            tmp_2 = this_0;
          } else {
            tmp_2 = null;
          }

          var protocol = tmp_2;
          var headers = !(protocol == null) ? headersOf(HttpHeaders_getInstance().y37_1, protocol) : Companion_getInstance_4().k39_1;
          return new HttpResponseData(Companion_getInstance_1().k3a_1, this.c5x_1, headers, Companion_getInstance_3().c3a_1, this.b5x_1, this.a5x_1);
        case 5:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 5) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function JsClientEngine(config) {
  HttpClientEngineBase.call(this, 'ktor-js');
  this.x5x_1 = config;
  this.y5x_1 = setOf_0([HttpTimeoutCapability_instance, WebSocketCapability_instance, SSECapability_instance]);
  // Inline function 'kotlin.check' call
  if (!(this.x5x_1.l4w_1 == null)) {
    var message = 'Proxy unsupported in Js engine.';
    throw IllegalStateException_init_$Create$(toString(message));
  }
}
protoOf(JsClientEngine).j4q = function () {
  return this.x5x_1;
};
protoOf(JsClientEngine).f4v = function () {
  return this.y5x_1;
};
protoOf(JsClientEngine).h4w = function (data, $completion) {
  var tmp = new $executeCOROUTINE$_1(this, data, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
function mapToKtor(_this__u8e3s4, method, attributes) {
  return buildHeaders(mapToKtor$lambda(_this__u8e3s4, method, attributes));
}
function awaitConnection(_this__u8e3s4, $completion) {
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.w21();
  $l$block: {
    if (cancellable.b1y()) {
      break $l$block;
    }
    var eventListener = awaitConnection$lambda(cancellable, _this__u8e3s4);
    _this__u8e3s4.addEventListener('open', eventListener);
    _this__u8e3s4.addEventListener('error', eventListener);
    cancellable.h20(awaitConnection$lambda_0(_this__u8e3s4, eventListener));
  }
  return cancellable.e22();
}
function asString(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  var tmp = JSON;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = ['message', 'target', 'type', 'isTrusted'];
  this_0.k7(tmp.stringify(_this__u8e3s4, tmp$ret$2));
  return this_0.toString();
}
function mapToKtor$lambda$lambda($this_buildHeaders) {
  return function (value, key) {
    $this_buildHeaders.i2x(key, value);
    return Unit_instance;
  };
}
function mapToKtor$lambda($this_mapToKtor, $method, $attributes) {
  return function ($this$buildHeaders) {
    // Inline function 'kotlin.js.asDynamic' call
    $this_mapToKtor.forEach(mapToKtor$lambda$lambda($this$buildHeaders));
    dropCompressionHeaders($this$buildHeaders, $method, $attributes, PlatformUtils_getInstance().p2w_1);
    return Unit_instance;
  };
}
function awaitConnection$lambda($continuation, $this_awaitConnection) {
  return function (event) {
    var tmp0_subject = event.type;
    var tmp;
    if (tmp0_subject === 'open') {
      var tmp0 = $continuation;
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value = $this_awaitConnection;
      var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
      tmp0.o8(tmp$ret$0);
      tmp = Unit_instance;
    } else if (tmp0_subject === 'error') {
      var tmp0_0 = $continuation;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = WebSocketException_init_$Create$(asString(event));
      var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
      tmp0_0.o8(tmp$ret$2);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function awaitConnection$lambda_0($this_awaitConnection, $eventListener) {
  return function (it) {
    $this_awaitConnection.removeEventListener('open', $eventListener);
    $this_awaitConnection.removeEventListener('error', $eventListener);
    var tmp;
    if (!(it == null)) {
      $this_awaitConnection.close();
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function toRaw(_this__u8e3s4, clientConfig, callContext, $completion) {
  var tmp = new $toRawCOROUTINE$(_this__u8e3s4, clientConfig, callContext, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function getBodyBytes(content, callContext, $completion) {
  var tmp = new $getBodyBytesCOROUTINE$(content, callContext, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function buildObject(block) {
  var tmp = {};
  // Inline function 'kotlin.apply' call
  var this_0 = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  block(this_0);
  return this_0;
}
function toRaw$lambda($skipContentLengthHeader, $jsHeaders) {
  return function (key, value) {
    var tmp;
    if ($skipContentLengthHeader && key === HttpHeaders_getInstance().a36_1) {
      return Unit_instance;
    }
    $jsHeaders[key] = value;
    return Unit_instance;
  };
}
function toRaw$lambda_0($this_toRaw, $jsHeaders, $clientConfig, $bodyBytes) {
  return function ($this$buildObject) {
    $this$buildObject.method = $this_toRaw.z4u_1.z39_1;
    $this$buildObject.headers = $jsHeaders;
    var tmp;
    if ($clientConfig.u4q_1) {
      // Inline function 'org.w3c.fetch.FOLLOW' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = 'follow';
    } else {
      // Inline function 'org.w3c.fetch.MANUAL' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = 'manual';
    }
    $this$buildObject.redirect = tmp;
    var tmp0_safe_receiver = $bodyBytes;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$buildObject.body = new Uint8Array(toTypedArray(tmp0_safe_receiver));
    }
    return Unit_instance;
  };
}
function getBodyBytes$slambda($content, resultContinuation) {
  this.e5z_1 = $content;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(getBodyBytes$slambda).n4m = function ($this$writer, $completion) {
  var tmp = this.o4m($this$writer, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(getBodyBytes$slambda).x8 = function (p1, $completion) {
  return this.n4m(p1 instanceof WriterScope ? p1 : THROW_CCE(), $completion);
};
protoOf(getBodyBytes$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.e5z_1.n3f(this.f5z_1.p2s_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(getBodyBytes$slambda).o4m = function ($this$writer, completion) {
  var i = new getBodyBytes$slambda(this.e5z_1, completion);
  i.f5z_1 = $this$writer;
  return i;
};
function getBodyBytes$slambda_0($content, resultContinuation) {
  var i = new getBodyBytes$slambda($content, resultContinuation);
  var l = function ($this$writer, $completion) {
    return i.n4m($this$writer, $completion);
  };
  l.$arity = 1;
  return l;
}
function $toRawCOROUTINE$(_this__u8e3s4, clientConfig, callContext, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.h5y_1 = _this__u8e3s4;
  this.i5y_1 = clientConfig;
  this.j5y_1 = callContext;
}
protoOf($toRawCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.k5y_1 = {};
          var this_0 = this.h5y_1;
          var skipContentLengthHeader = !get_supportsRequestBody(this_0.z4u_1) && isEmpty(this_0.b4v_1);
          mergeHeaders(this_0.a4v_1, this_0.b4v_1, toRaw$lambda(skipContentLengthHeader, this.k5y_1));
          this.d8_1 = 1;
          suspendResult = getBodyBytes(this.h5y_1.b4v_1, this.j5y_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var bodyBytes = suspendResult;
          return buildObject(toRaw$lambda_0(this.h5y_1, this.k5y_1, this.i5y_1, bodyBytes));
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $getBodyBytesCOROUTINE$(content, callContext, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.t5y_1 = content;
  this.u5y_1 = callContext;
}
protoOf($getBodyBytesCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          var tmp0_subject = this.t5y_1;
          if (tmp0_subject instanceof ByteArrayContent) {
            this.v5y_1 = this.t5y_1.i3f();
            this.d8_1 = 5;
            continue $sm;
          } else {
            if (tmp0_subject instanceof ReadChannelContent) {
              this.d8_1 = 3;
              suspendResult = readRemaining(this.t5y_1.l3f(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof WriteChannelContent) {
                this.d8_1 = 2;
                var tmp_0 = GlobalScope_instance;
                suspendResult = readRemaining(writer(tmp_0, this.u5y_1, VOID, getBodyBytes$slambda_0(this.t5y_1, null)).n2s_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (tmp0_subject instanceof ContentWrapper) {
                  this.d8_1 = 1;
                  suspendResult = getBodyBytes(this.t5y_1.r3f(), this.u5y_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (tmp0_subject instanceof NoContent) {
                    this.v5y_1 = null;
                    this.d8_1 = 5;
                    continue $sm;
                  } else {
                    if (tmp0_subject instanceof ProtocolUpgrade) {
                      var tmp_1 = this;
                      throw new UnsupportedContentTypeException(this.t5y_1);
                    } else {
                      var tmp_2 = this;
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
            }
          }

          break;
        case 1:
          this.v5y_1 = suspendResult;
          this.d8_1 = 5;
          continue $sm;
        case 2:
          var ARGUMENT = suspendResult;
          this.v5y_1 = readByteArray(ARGUMENT);
          this.d8_1 = 5;
          continue $sm;
        case 3:
          var ARGUMENT_0 = suspendResult;
          this.v5y_1 = readByteArray(ARGUMENT_0);
          this.d8_1 = 5;
          continue $sm;
        case 4:
          throw this.g8_1;
        case 5:
          return this.v5y_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function asByteArray(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return new Int8Array(_this__u8e3s4.buffer, _this__u8e3s4.byteOffset, _this__u8e3s4.length);
}
function readBodyBrowser(_this__u8e3s4, response) {
  var tmp0_elvis_lhs = response.body;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Companion_getInstance().o2n_1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stream = tmp;
  return channelFromStream(_this__u8e3s4, stream);
}
function channelFromStream(_this__u8e3s4, stream) {
  return writer(_this__u8e3s4, VOID, VOID, channelFromStream$slambda_0(stream, null)).n2s_1;
}
function readChunk(_this__u8e3s4, $completion) {
  var safe = SafeContinuation_init_$Create$(intercepted($completion));
  var tmp = _this__u8e3s4.read();
  var tmp_0 = tmp.then(readChunk$lambda(safe));
  tmp_0.catch(readChunk$lambda_0(safe));
  return safe.v8();
}
function channelFromStream$slambda$lambda(it) {
  return Unit_instance;
}
function channelFromStream$slambda($stream, resultContinuation) {
  this.o5z_1 = $stream;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(channelFromStream$slambda).n4m = function ($this$writer, $completion) {
  var tmp = this.o4m($this$writer, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(channelFromStream$slambda).x8 = function (p1, $completion) {
  return this.n4m(p1 instanceof WriterScope ? p1 : THROW_CCE(), $completion);
};
protoOf(channelFromStream$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 9;
          this.r5z_1 = this.o5z_1.getReader();
          this.e8_1 = 7;
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!true) {
            this.d8_1 = 6;
            continue $sm;
          }

          this.d8_1 = 2;
          suspendResult = readChunk(this.r5z_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          var tmp0_elvis_lhs = suspendResult;
          if (tmp0_elvis_lhs == null) {
            this.d8_1 = 6;
            var tmp_0 = this;
            continue $sm;
          } else {
            this.s5z_1 = tmp0_elvis_lhs;
            this.d8_1 = 3;
            continue $sm;
          }

        case 3:
          var chunk = this.s5z_1;
          this.d8_1 = 4;
          suspendResult = writeFully(this.p5z_1.p2s_1, asByteArray(chunk), VOID, VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 4:
          this.d8_1 = 5;
          suspendResult = this.p5z_1.p2s_1.i2l(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          this.d8_1 = 1;
          continue $sm;
        case 6:
          this.e8_1 = 9;
          this.d8_1 = 10;
          continue $sm;
        case 7:
          this.e8_1 = 9;
          var tmp_1 = this.g8_1;
          if (tmp_1 instanceof Error) {
            this.q5z_1 = this.g8_1;
            this.d8_1 = 8;
            var tmp_2 = this.r5z_1.cancel(this.q5z_1);
            suspendResult = await_0(tmp_2.catch(channelFromStream$slambda$lambda), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            throw this.g8_1;
          }

        case 8:
          throw this.q5z_1;
        case 9:
          throw this.g8_1;
        case 10:
          this.e8_1 = 9;
          return Unit_instance;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 9) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(channelFromStream$slambda).o4m = function ($this$writer, completion) {
  var i = new channelFromStream$slambda(this.o5z_1, completion);
  i.p5z_1 = $this$writer;
  return i;
};
function channelFromStream$slambda_0($stream, resultContinuation) {
  var i = new channelFromStream$slambda($stream, resultContinuation);
  var l = function ($this$writer, $completion) {
    return i.n4m($this$writer, $completion);
  };
  l.$arity = 1;
  return l;
}
function readChunk$lambda($continuation) {
  return function (it) {
    var chunk = it.value;
    var result = it.done ? null : chunk;
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $continuation;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(result);
    this_0.o8(tmp$ret$0);
    return Unit_instance;
  };
}
function readChunk$lambda_0($continuation) {
  return function (cause) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = $continuation;
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(cause));
    this_0.o8(tmp$ret$0);
    return Unit_instance;
  };
}
function commonFetch(input, init, requestConfig, config, callJob, $completion) {
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.w21();
  var controller = AbortController_0();
  init.signal = controller.signal;
  config.z5v_1(init);
  requestConfig(init);
  callJob.j1y(true, VOID, commonFetch$lambda(controller));
  var tmp;
  if (PlatformUtils_getInstance().p2w_1) {
    tmp = fetch(input, init);
  } else {
    var options = Object.assign(Object.create(null), init, config.a5w_1);
    tmp = fetch(input, options);
  }
  var promise = tmp;
  var tmp_0 = commonFetch$lambda_0(cancellable);
  promise.then(tmp_0, commonFetch$lambda_1(cancellable));
  return cancellable.e22();
}
function readBody(_this__u8e3s4, response) {
  return readBodyBrowser(_this__u8e3s4, response);
}
function AbortController_0() {
  return new AbortController();
}
function commonFetch$lambda($controller) {
  return function (it) {
    $controller.abort();
    return Unit_instance;
  };
}
function commonFetch$lambda_0($continuation) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $continuation;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
    this_0.o8(tmp$ret$0);
    return Unit_instance;
  };
}
function commonFetch$lambda_1($continuation) {
  return function (it) {
    var tmp0 = $continuation;
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = Error_init_$Create$('Fail to fetch', it);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    tmp0.o8(tmp$ret$0);
    return Unit_instance;
  };
}
function isReservedStatusCode($this, _this__u8e3s4) {
  // Inline function 'kotlin.let' call
  var resolved = Companion_getInstance_5().e4f(_this__u8e3s4);
  return resolved == null || equals(resolved, Codes_CLOSED_ABNORMALLY_getInstance());
}
function JsWebSocketSession$lambda(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var event = it;
    var data = event.data;
    var tmp;
    if (data instanceof ArrayBuffer) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = new Int8Array(data);
      tmp = Binary_init_$Create$(true, tmp$ret$3);
    } else {
      if (!(data == null) ? typeof data === 'string' : false) {
        tmp = Text_init_$Create$(data);
      } else {
        var error = IllegalStateException_init_$Create$('Unknown frame type: ' + event.type);
        this$0.v5z_1.a24(error);
        throw error;
      }
    }
    var frame = tmp;
    this$0.w5z_1.m2c(frame);
    return Unit_instance;
  };
}
function JsWebSocketSession$lambda_0(this$0) {
  return function (it) {
    var cause = WebSocketException_init_$Create$(toString(it));
    this$0.v5z_1.a24(cause);
    this$0.w5z_1.q2c(cause);
    this$0.x5z_1.u2c();
    return Unit_instance;
  };
}
function JsWebSocketSession$lambda_1(this$0) {
  return function (event) {
    var tmp = event.code;
    var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
    var tmp_1 = event.reason;
    var reason = new CloseReason(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : THROW_CCE());
    this$0.v5z_1.y23(reason);
    this$0.w5z_1.m2c(Close_init_$Create$(reason));
    this$0.w5z_1.s2c();
    this$0.x5z_1.u2c();
    return Unit_instance;
  };
}
function JsWebSocketSession$slambda(this$0, resultContinuation) {
  this.j60_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(JsWebSocketSession$slambda).l2t = function ($this$launch, $completion) {
  var tmp = this.m2t($this$launch, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(JsWebSocketSession$slambda).x8 = function (p1, $completion) {
  return this.l2t((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(JsWebSocketSession$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 10;
          var tmp_0 = this;
          tmp_0.o60_1 = this.j60_1.x5z_1;
          this.d8_1 = 1;
          continue $sm;
        case 1:
          this.m60_1 = this.o60_1;
          this.l60_1 = null;
          this.d8_1 = 2;
          continue $sm;
        case 2:
          this.d8_1 = 3;
          continue $sm;
        case 3:
          this.e8_1 = 9;
          this.e8_1 = 8;
          this.n60_1 = this.m60_1.l();
          this.d8_1 = 4;
          continue $sm;
        case 4:
          this.d8_1 = 5;
          suspendResult = this.n60_1.h2b(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          if (!suspendResult) {
            this.d8_1 = 6;
            continue $sm;
          }

          var e = this.n60_1.n();
          switch (e.q4f_1.j2_1) {
            case 0:
              var text = e.r4f_1;
              this.j60_1.u5z_1.send(decodeToString(text, 0, 0 + text.length | 0));
              break;
            case 1:
              var tmp_1 = e.r4f_1;
              var source = tmp_1 instanceof Int8Array ? tmp_1 : THROW_CCE();
              var frameData = source.buffer.slice(source.byteOffset, source.byteOffset + source.byteLength | 0);
              this.j60_1.u5z_1.send(frameData);
              break;
            case 2:
              var builder = new Buffer();
              writeFully_0(builder, e.r4f_1);
              var data = builder;
              var code = data.i1u();
              var reason = readText(data);
              this.j60_1.v5z_1.y23(new CloseReason(code, reason));
              if (isReservedStatusCode(this.j60_1, code)) {
                this.j60_1.u5z_1.close();
              } else {
                this.j60_1.u5z_1.close(code, reason);
              }

              break;
            case 3:
            case 4:
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }

          this.d8_1 = 4;
          continue $sm;
        case 6:
          this.e8_1 = 10;
          this.d8_1 = 7;
          var tmp_2 = this;
          continue $sm;
        case 7:
          this.e8_1 = 10;
          cancelConsumed(this.m60_1, this.l60_1);
          this.d8_1 = 12;
          continue $sm;
        case 8:
          this.e8_1 = 9;
          var tmp_3 = this.g8_1;
          if (tmp_3 instanceof Error) {
            var e_0 = this.g8_1;
            var tmp_4 = this;
            this.l60_1 = e_0;
            throw e_0;
          } else {
            throw this.g8_1;
          }

        case 9:
          this.e8_1 = 10;
          var t = this.g8_1;
          cancelConsumed(this.m60_1, this.l60_1);
          throw t;
        case 10:
          throw this.g8_1;
        case 11:
          this.e8_1 = 10;
          cancelConsumed(this.m60_1, this.l60_1);
          if (false) {
            this.d8_1 = 1;
            continue $sm;
          }

          this.d8_1 = 12;
          continue $sm;
        case 12:
          return Unit_instance;
      }
    } catch ($p) {
      var e_1 = $p;
      if (this.e8_1 === 10) {
        throw e_1;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e_1;
      }
    }
   while (true);
};
protoOf(JsWebSocketSession$slambda).m2t = function ($this$launch, completion) {
  var i = new JsWebSocketSession$slambda(this.j60_1, completion);
  i.k60_1 = $this$launch;
  return i;
};
function JsWebSocketSession$slambda_0(this$0, resultContinuation) {
  var i = new JsWebSocketSession$slambda(this$0, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.l2t($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function JsWebSocketSession$lambda_2(this$0) {
  return function (cause) {
    var tmp;
    if (cause == null) {
      this$0.u5z_1.close();
      tmp = Unit_instance;
    } else {
      this$0.u5z_1.close(Codes_NORMAL_getInstance().b4f_1, 'Client failed');
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function JsWebSocketSession(coroutineContext, websocket) {
  this.t5z_1 = coroutineContext;
  this.u5z_1 = websocket;
  this.v5z_1 = CompletableDeferred();
  this.w5z_1 = Channel(2147483647);
  this.x5z_1 = Channel(2147483647);
  this.y5z_1 = this.w5z_1;
  this.z5z_1 = this.x5z_1;
  this.a60_1 = this.v5z_1;
  // Inline function 'org.w3c.dom.ARRAYBUFFER' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  var tmp$ret$2 = 'arraybuffer';
  this.u5z_1.binaryType = tmp$ret$2;
  this.u5z_1.addEventListener('message', JsWebSocketSession$lambda(this));
  this.u5z_1.addEventListener('error', JsWebSocketSession$lambda_0(this));
  this.u5z_1.addEventListener('close', JsWebSocketSession$lambda_1(this));
  launch(this, VOID, VOID, JsWebSocketSession$slambda_0(this, null));
  var tmp0_safe_receiver = this.t5z_1.q8(Key_instance);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.h1y(JsWebSocketSession$lambda_2(this));
  }
}
protoOf(JsWebSocketSession).f1x = function () {
  return this.t5z_1;
};
function get_FACTORY() {
  _init_properties_HttpClientJs_kt__cy67gk();
  return FACTORY;
}
var FACTORY;
function HttpClient_1(block) {
  var tmp;
  if (block === VOID) {
    tmp = HttpClient$lambda_3;
  } else {
    tmp = block;
  }
  block = tmp;
  _init_properties_HttpClientJs_kt__cy67gk();
  return HttpClient_0(get_FACTORY(), block);
}
function HttpClient$lambda_3(_this__u8e3s4) {
  _init_properties_HttpClientJs_kt__cy67gk();
  return Unit_instance;
}
var properties_initialized_HttpClientJs_kt_eni8iq;
function _init_properties_HttpClientJs_kt__cy67gk() {
  if (!properties_initialized_HttpClientJs_kt_eni8iq) {
    properties_initialized_HttpClientJs_kt_eni8iq = true;
    var tmp0 = engines_getInstance();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.l();
      while (_iterator__ex2g4s.m()) {
        var element = _iterator__ex2g4s.n();
        if (!equals(element, Js_instance)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    FACTORY = tmp0_elvis_lhs == null ? Js_instance : tmp0_elvis_lhs;
  }
}
function checkContentLength(contentLength, bodySize, method) {
}
function platformRequestDefaultTransform(contentType, context, body) {
  return null;
}
function platformResponseDefaultTransformers(_this__u8e3s4) {
}
function Node(item, next) {
  this.p60_1 = item;
  this.q60_1 = next;
}
function engines$iterator$1() {
  this.r60_1 = engines_getInstance().b5w_1.kotlinx$atomicfu$value;
}
protoOf(engines$iterator$1).n = function () {
  var result = ensureNotNull(this.r60_1);
  this.r60_1 = result.q60_1;
  return result.p60_1;
};
protoOf(engines$iterator$1).m = function () {
  return !(null == this.r60_1);
};
function engines() {
  engines_instance = this;
  this.b5w_1 = atomic$ref$1(null);
}
protoOf(engines).c5w = function (item) {
  $l$loop: while (true) {
    var current = this.b5w_1.kotlinx$atomicfu$value;
    var new_0 = new Node(item, current);
    if (this.b5w_1.atomicfu$compareAndSet(current, new_0))
      break $l$loop;
  }
};
protoOf(engines).l = function () {
  return new engines$iterator$1();
};
var engines_instance;
function engines_getInstance() {
  if (engines_instance == null)
    new engines();
  return engines_instance;
}
function ConnectTimeoutException() {
}
function SocketTimeoutException() {
}
function InterruptedIOException() {
}
function unwrapCancellationException(_this__u8e3s4) {
  var exception = _this__u8e3s4;
  $l$loop: while (exception instanceof CancellationException) {
    if (equals(exception, exception.cause)) {
      return _this__u8e3s4;
    }
    exception = exception.cause;
  }
  var tmp0_elvis_lhs = exception;
  return tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
}
//region block: post-declaration
defineProp(protoOf(DoubleReceiveException), 'message', function () {
  return this.e();
});
defineProp(protoOf(NoTransformationFoundException), 'message', function () {
  return this.e();
});
protoOf(HttpClientEngineBase).f4v = get_supportedCapabilities;
protoOf(HttpClientEngineBase).k4q = install;
defineProp(protoOf(ClientEngineClosedException), 'cause', function () {
  return this.f();
});
protoOf(KtorCallContextElement).q8 = get;
protoOf(KtorCallContextElement).eh = fold;
protoOf(KtorCallContextElement).dh = minusKey;
protoOf(KtorCallContextElement).fh = plus;
defineProp(protoOf(RedirectResponseException), 'message', function () {
  return this.e();
});
defineProp(protoOf(ClientRequestException), 'message', function () {
  return this.e();
});
defineProp(protoOf(ServerResponseException), 'message', function () {
  return this.e();
});
protoOf(HttpRequest$1).f1x = get_coroutineContext;
//endregion
//region block: init
Companion_instance_1 = new Companion_0();
AfterRenderHook_instance = new AfterRenderHook();
AfterReceiveHook_instance = new AfterReceiveHook();
RequestError_instance = new RequestError();
ReceiveError_instance = new ReceiveError();
RenderRequestHook_instance = new RenderRequestHook();
SetupRequestContext_instance = new SetupRequestContext();
HttpTimeoutCapability_instance = new HttpTimeoutCapability();
SetupRequest_instance = new SetupRequest();
Send_instance = new Send();
SendingRequest_instance = new SendingRequest();
RequestHook_instance = new RequestHook();
ResponseHook_instance = new ResponseHook();
TransformRequestBodyHook_instance = new TransformRequestBodyHook();
TransformResponseBodyHook_instance = new TransformResponseBodyHook();
SSECapability_instance = new SSECapability();
WebSocketCapability_instance = new WebSocketCapability();
Companion_instance_4 = new Companion_3();
Js_instance = new Js();
//endregion
//region block: eager init
initHook_0 = initHook$init$();
//endregion
//region block: exports
var initHook = {get: get_initHook};
export {
  initHook as initHook,
};
export {
  bodyAsText as bodyAsText1is16t8kuttw9,
  SendingRequest_instance as SendingRequest_instance1w1fa9l3pabv8,
  Send_instance as Send_instance19u839hbvwh8q,
  Companion_getInstance_9 as Companion_getInstance1mmr0u1e9b7o6,
  EmptyContent_getInstance as EmptyContent_getInstance116ybdh9l8hek,
  OnRequestContext as OnRequestContext1tmu5b6bhlblg,
  OnResponseContext as OnResponseContext1dt4k8jhlnzte,
  Sender_0 as Sender1wtdgti85uk42,
  TransformRequestBodyContext as TransformRequestBodyContext3ll40opqaho0d,
  TransformResponseBodyContext as TransformResponseBodyContext1axf7xx6ifwbj,
  createClientPlugin_0 as createClientPlugin16sdkdabbewya,
  createClientPlugin as createClientPluginjwpvufjows5r,
  ClientSSESessionWithDeserialization as ClientSSESessionWithDeserialization37nab8162l18r,
  ClientSSESession as ClientSSESession332rusa1q4gim,
  get_HttpTimeout as get_HttpTimeout3mcrbvfnvmyx2,
  ResponseException as ResponseException2ofl6x4wye9sn,
  defaultRequest as defaultRequest2ux1d5xxixv6z,
  pluginOrNull as pluginOrNulleoo3166jvfvu,
  plugin as plugin3vxt624hnu3pv,
  HttpRequestBuilder as HttpRequestBuilder15f2nnx9sjuv1,
  accept as accept2gi3b7wj4jds9,
  bearerAuth as bearerAuthj128my0vj44j,
  header as header3kx6g3yb4df1r,
  HttpResponse as HttpResponse1532ob1hsse1y,
  HttpStatement as HttpStatement3zxb33q8lku,
  get_request as get_request3dwcif5y0fvf1,
  HttpClient_1 as HttpClient3584jcajl7sef,
  fetchOptions as fetchOptions3avk4v4j4l43h,
};
//endregion

//# sourceMappingURL=ktor-ktor-client-core.mjs.map
